export type Maybe<T> = T | null;
export type InputMaybe<T> = undefined | T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  FlexibleFloat: any;
  FlexibleInt: any;
  JSON: any;
};

export type ActivitiesResult = {
  __typename?: 'ActivitiesResult';
  items: Array<Activity>;
  metadata: PaginationMetadata;
};

export type Activity = {
  __typename?: 'Activity';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ID']>;
  championId?: Maybe<Scalars['ID']>;
  cohortFacilityIds?: Maybe<Array<Scalars['String']>>;
  comments?: Maybe<Array<Comment>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentJob?: Maybe<Job>;
  currentJobId?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<ActivityDocument>>;
  executionPlan: ExecutionPlanType;
  id: Scalars['ID'];
  inputs?: Maybe<Array<Maybe<ActivityUserInput>>>;
  jobs?: Maybe<Array<Job>>;
  lobMail?: Maybe<LobMail>;
  logs?: Maybe<Array<ActivityLog>>;
  nonChampionIds?: Maybe<Array<Scalars['String']>>;
  notes?: Maybe<Scalars['String']>;
  output?: Maybe<Scalars['JSON']>;
  payments?: Maybe<Array<Payment>>;
  reportDetailsExtended?: Maybe<Scalars['JSON']>;
  status: ActivityStatus;
  type: ActivityType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflow: Workflow;
};

export type ActivityDocument = {
  __typename?: 'ActivityDocument';
  activity: Activity;
  activityId: Scalars['ID'];
  document: Document;
  documentId: Scalars['ID'];
};

export type ActivityInput = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  executionPlan?: InputMaybe<ExecutionPlanType>;
  input?: InputMaybe<Scalars['JSON']>;
  message?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ActivityStatus>;
  type?: InputMaybe<ActivityType>;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activityId: Scalars['ID'];
  errorType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  stackTrace?: Maybe<Scalars['String']>;
  status: ActivityStatus;
  time?: Maybe<Scalars['DateTime']>;
};

export type ActivityLogsResult = {
  __typename?: 'ActivityLogsResult';
  count: Scalars['Int'];
  items?: Maybe<Array<ActivityLog>>;
};

export type ActivityOutput = {
  __typename?: 'ActivityOutput';
  records?: Maybe<Array<ActivityRecord>>;
};

export type ActivityRecord = {
  __typename?: 'ActivityRecord';
  associatedDocumentId?: Maybe<Scalars['String']>;
  at: Scalars['DateTime'];
  key: Scalars['String'];
  kind: ActivityRecordKind;
  name: Scalars['String'];
};

export enum ActivityRecordKind {
  AstDocumentation = 'AST_DOCUMENTATION',
  DikeDescription = 'DIKE_DESCRIPTION',
  EmergencyResponsePlan = 'EMERGENCY_RESPONSE_PLAN',
  HazardousMaterialsInventoryStatement = 'HAZARDOUS_MATERIALS_INVENTORY_STATEMENT',
  HazardousMaterialsManagementPlan = 'HAZARDOUS_MATERIALS_MANAGEMENT_PLAN',
  Invoice = 'INVOICE',
  Other = 'OTHER',
  Receipt = 'RECEIPT',
  ReferenceImage = 'REFERENCE_IMAGE',
  Report = 'REPORT',
  SafeguardMeasures = 'SAFEGUARD_MEASURES',
  Screenshot = 'SCREENSHOT',
  Sds = 'SDS',
  SiteCoordinateAbbreviation = 'SITE_COORDINATE_ABBREVIATION',
  SitePlan = 'SITE_PLAN',
  TrainingPlan = 'TRAINING_PLAN',
  UstDocumentation = 'UST_DOCUMENTATION'
}

export type ActivitySafeToResetResponse = {
  __typename?: 'ActivitySafeToResetResponse';
  activity?: Maybe<Activity>;
  isSafeToReset: Scalars['Boolean'];
};

export enum ActivityStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Error = 'Error',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Queued = 'Queued',
  StaffCompleted = 'StaffCompleted'
}

export enum ActivityType {
  AddDocument = 'AddDocument',
  CollectEvidence = 'CollectEvidence',
  CollectEvidenceOfCompletion = 'CollectEvidenceOfCompletion',
  CreatePdf = 'CreatePdf',
  CreateZip = 'CreateZip',
  DistributeCohortDocuments = 'DistributeCohortDocuments',
  FillPdf = 'FillPdf',
  GenerateCustomerDeliverables = 'GenerateCustomerDeliverables',
  Geppetto = 'Geppetto',
  InitializeCohorts = 'InitializeCohorts',
  Lob = 'Lob',
  Presubmission = 'Presubmission',
  SendEmail = 'SendEmail',
  SendSupplementalAgencyCommunication = 'SendSupplementalAgencyCommunication',
  SignReportPages = 'SignReportPages',
  Staff = 'Staff',
  Tier2Submit = 'Tier2Submit',
  Tier2SubmitValidation = 'Tier2SubmitValidation',
  ValidateCohort = 'ValidateCohort',
  ValidateCohortMembership = 'ValidateCohortMembership',
  WaitForAllAltIdReports = 'WaitForAllAltIdReports',
  WaitForAllCnReports = 'WaitForAllCNReports',
  WaitForAllCredentialReports = 'WaitForAllCredentialReports',
  WaitForAllFd = 'WaitForAllFD',
  WaitForAllLepc = 'WaitForAllLEPC',
  WaitForAllStateReports = 'WaitForAllStateReports',
  WaitForCohorts = 'WaitForCohorts'
}

export type ActivityUserInput = {
  __typename?: 'ActivityUserInput';
  activityId: Scalars['ID'];
  id: Scalars['ID'];
  label: Scalars['String'];
  required: Scalars['Boolean'];
  shortName: Scalars['String'];
  type: ActivityUserInputType;
  value?: Maybe<Scalars['String']>;
};

export enum ActivityUserInputType {
  Boolean = 'Boolean',
  Number = 'Number'
}

export enum AgencyTypeCode {
  Contractor = 'CONTRACTOR',
  County = 'COUNTY',
  EpaContractor = 'EPA_CONTRACTOR',
  Interstate = 'INTERSTATE',
  Local = 'LOCAL',
  Municipal = 'MUNICIPAL',
  Other = 'OTHER',
  OtherEpa = 'OTHER_EPA',
  OtherFederal = 'OTHER_FEDERAL',
  OtherState = 'OTHER_STATE',
  Regional = 'REGIONAL',
  SeniorEnvironmentalEmploymentSeeInspector = 'SENIOR_ENVIRONMENTAL_EMPLOYMENT_SEE_INSPECTOR',
  State = 'STATE',
  StateContractor = 'STATE_CONTRACTOR',
  Tribal = 'TRIBAL',
  UnknownFromConversion = 'UNKNOWN_FROM_CONVERSION',
  UsEpa = 'US_EPA'
}

export type AllWasteByMonth = {
  __typename?: 'AllWasteByMonth';
  hazardous: Scalars['Float'];
  month: Scalars['Date'];
  nonHazardous: Scalars['Float'];
  universal: Scalars['Float'];
};

export type AllWasteShipmentsByFacility = {
  __typename?: 'AllWasteShipmentsByFacility';
  byMonth: Array<AllWasteByMonth>;
  totalHazardousAmount: Scalars['Float'];
  totalNonHazardousAmount: Scalars['Float'];
  totalUniversalAmount: Scalars['Float'];
};

export type AllWasteShipmentsByMonth = {
  __typename?: 'AllWasteShipmentsByMonth';
  byMonth: Array<FacilityWasteByMonth>;
  highestCalculatedGeneratorStatus?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  totalAcutelyHazardousAmount: Scalars['Float'];
  /** Total of all acutely hazardous, hazardous, and state regulated waste */
  totalAllHazardousAmount: Scalars['Float'];
  /** Total of all hazardous and nonhazardous waste */
  totalAllWasteAmount: Scalars['Float'];
  totalHazardousAmount: Scalars['Float'];
  totalNonhazardousAmount: Scalars['Float'];
  totalStateRegulatedAmount: Scalars['Float'];
};

export type AlternateId = {
  __typename?: 'AlternateId';
  expiresAt?: Maybe<Scalars['Date']>;
  hasNoId: Scalars['Boolean'];
  id: Scalars['ID'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type AlternateIdInput = {
  expiresAt?: InputMaybe<Scalars['Date']>;
  hasNoId?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  type: Scalars['String'];
  value: Scalars['String'];
};

export type AmountWithUnit = {
  __typename?: 'AmountWithUnit';
  amount?: Maybe<Scalars['Float']>;
  amountCode?: Maybe<Scalars['Int']>;
  unit?: Maybe<UnitType>;
};

export enum AssignmentType {
  Assignee = 'ASSIGNEE',
  Reviewer = 'REVIEWER'
}

export type BulkCopyInventoryResult = {
  __typename?: 'BulkCopyInventoryResult';
  failed: Array<CopyFacilityInventoryResult>;
  skipped: Array<CopyFacilityInventoryResult>;
  succeeded: Array<CopyFacilityInventoryResult>;
};

export type BulkReportSafeToResetResponse = {
  __typename?: 'BulkReportSafeToResetResponse';
  activities?: Maybe<Array<Maybe<ActivitySafeToResetResponse>>>;
  facility?: Maybe<Facility>;
  id: Scalars['ID'];
  isSafeToReset: Scalars['Boolean'];
  tenant?: Maybe<Tenant>;
  unsafeResetReasons: Array<Scalars['String']>;
};

export type BulkResetReportInput = {
  encampStatus: TierIiReportEncampStatus;
  organizationStatus: TierIiReportOrgStatus;
  reportIds: Array<Scalars['ID']>;
  safetyOverride?: InputMaybe<Scalars['Boolean']>;
  shouldForceCancelWorkflow?: InputMaybe<Scalars['Boolean']>;
  shouldForceReSnapshot?: InputMaybe<Scalars['Boolean']>;
  untouchedSteps?: InputMaybe<Array<TierIiReportStep>>;
};

export type BulkResetReportsResult = {
  __typename?: 'BulkResetReportsResult';
  succeeded: Scalars['Boolean'];
};

export type BulkSubmissionsJobResult = {
  __typename?: 'BulkSubmissionsJobResult';
  jobId?: Maybe<Scalars['ID']>;
  succeeded: Scalars['Boolean'];
};

export type BulkSubmissionsResult = {
  __typename?: 'BulkSubmissionsResult';
  failed?: Maybe<Scalars['Int']>;
  succeeded: Scalars['Boolean'];
  updated?: Maybe<Scalars['Int']>;
};

export type BulkUpdateNotReportingReasonResult = {
  __typename?: 'BulkUpdateNotReportingReasonResult';
  succeeded?: Maybe<Scalars['Boolean']>;
};

export type BulkUpdateReconciliationStatusInput = {
  newStatus: ReconciliationStatus;
  paymentIds: Array<Scalars['ID']>;
};

export type BulkUpdateSubmissionsStatusInput = {
  status: SubmissionStatus;
  submissionIds: Array<Scalars['ID']>;
  virtualEventIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type BulkVerifyAndSubmitReportsResult = {
  __typename?: 'BulkVerifyAndSubmitReportsResult';
  succeeded: Scalars['Boolean'];
};

export enum CaDocumentType {
  AboveGroundPetroleumStorageActDocumentation = 'AboveGroundPetroleumStorageActDocumentation',
  HazardousWasteTankClosureCertificate = 'HazardousWasteTankClosureCertificate',
  OwnerStatementOfDesignatedUstOperatorCompliance = 'OwnerStatementOfDesignatedUSTOperatorCompliance',
  RecyclableMaterialsReportDocumentation = 'RecyclableMaterialsReportDocumentation',
  UstCertificationOfFinancialResponsibility = 'USTCertificationOfFinancialResponsibility',
  UstLetterFromChiefFinancialOfficer = 'USTLetterFromChiefFinancialOfficer',
  UstMonitoringSitePlan = 'USTMonitoringSitePlan',
  UstOwnerOperatorWrittenAgreement = 'USTOwnerOperatorWrittenAgreement',
  UstResponsePlan = 'USTResponsePlan'
}

export type CheckForFileResult = {
  __typename?: 'CheckForFileResult';
  exists: Scalars['Boolean'];
  signedUrl?: Maybe<Scalars['String']>;
};

export type Chemical = {
  __typename?: 'Chemical';
  alternateId?: Maybe<Scalars['String']>;
  associatedFacilities: Array<Facility>;
  casNumber?: Maybe<Scalars['String']>;
  chemicalTenants?: Maybe<Array<ChemicalTenant>>;
  components?: Maybe<Array<ChemicalComponent>>;
  createdAt: Scalars['DateTime'];
  createdAtViaMerge?: Maybe<Scalars['Date']>;
  createdBy: Scalars['String'];
  density?: Maybe<Scalars['Float']>;
  densityUnits?: Maybe<DensityUnits>;
  documents?: Maybe<Array<ChemicalDocument>>;
  ehsForm?: Maybe<EhsForm>;
  extensions: ExtensionsByProgramArea;
  facilityChemicalMeasurementCount?: Maybe<Scalars['Int']>;
  facilityChemicalMeasurementMaxAmount?: Maybe<AmountWithUnit>;
  facilityChemicalStateFields?: Maybe<Array<FacilityChemicalStateField>>;
  facilityChemicals?: Maybe<Array<FacilityChemical>>;
  healthHazards: Array<HealthHazard>;
  id: Scalars['ID'];
  ifcHazards: Array<InternationalFireCodeHazard>;
  isEhs: Scalars['Boolean'];
  isTradeSecret: Scalars['Boolean'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  manufacturerSupplier?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  needsReview: Scalars['Boolean'];
  noCasNumber?: Maybe<Scalars['Boolean']>;
  noHazardsNotReporting?: Maybe<Scalars['Boolean']>;
  normalizedCasNumber?: Maybe<Scalars['String']>;
  oregonHazards: Array<OregonHazard>;
  physicalHazards: Array<PhysicalHazard>;
  pureOrMixture?: Maybe<PureOrMixture>;
  recommendedUse?: Maybe<Scalars['String']>;
  revisionDate?: Maybe<Scalars['Date']>;
  stateFields?: Maybe<Array<DynamicField>>;
  stateOfMatter: Array<StateOfMatter>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedBy?: Maybe<Scalars['String']>;
  verifier?: Maybe<User>;
  version?: Maybe<Scalars['String']>;
};


export type ChemicalFacilityChemicalMeasurementCountArgs = {
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type ChemicalFacilityChemicalMeasurementMaxAmountArgs = {
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type ChemicalFacilityChemicalsArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
};

export type ChemicalAnomaliesResult = {
  __typename?: 'ChemicalAnomaliesResult';
  count: Scalars['Int'];
  items: Array<ChemicalAnomaly>;
};

export type ChemicalAnomaly = {
  __typename?: 'ChemicalAnomaly';
  chemicalId: Scalars['ID'];
  chemicalName: Scalars['String'];
  currentYearMaxAmount?: Maybe<Scalars['Float']>;
  currentYearReportId?: Maybe<Scalars['ID']>;
  currentYearUnit?: Maybe<UnitType>;
  facilityId: Scalars['ID'];
  facilityName: Scalars['String'];
  previousYearMaxAmount?: Maybe<Scalars['Float']>;
  previousYearReportId?: Maybe<Scalars['ID']>;
  previousYearUnit?: Maybe<UnitType>;
};

export type ChemicalComponent = {
  __typename?: 'ChemicalComponent';
  casNumber?: Maybe<Scalars['String']>;
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  componentPercentage?: Maybe<Scalars['Float']>;
  ehsForm?: Maybe<EhsForm>;
  id: Scalars['ID'];
  isEhs: Scalars['Boolean'];
  name: Scalars['String'];
  noCasNumber?: Maybe<Scalars['Boolean']>;
  weightOrVolume?: Maybe<WeightOrVolume>;
};

export type ChemicalComponentInput = {
  casNumber?: InputMaybe<Scalars['String']>;
  componentPercentage?: InputMaybe<Scalars['Float']>;
  ehsForm?: InputMaybe<EhsForm>;
  id: Scalars['ID'];
  isEhs?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  noCasNumber?: InputMaybe<Scalars['Boolean']>;
  weightOrVolume?: InputMaybe<WeightOrVolume>;
};

export type ChemicalDocument = {
  __typename?: 'ChemicalDocument';
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  document: Document;
  documentId: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type ChemicalDocumentInput = {
  chemicalId?: InputMaybe<Scalars['ID']>;
  document: DocumentInput;
  documentId: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type ChemicalFacilitiesResult = {
  __typename?: 'ChemicalFacilitiesResult';
  count: Scalars['Int'];
  items: Array<ChemicalFacility>;
};

export type ChemicalFacility = {
  __typename?: 'ChemicalFacility';
  chemicalCount: Scalars['Int'];
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  encampStatus?: Maybe<TierIiReportEncampStatus>;
  facilityId: Scalars['String'];
  facilityName?: Maybe<Scalars['String']>;
  fireDepartment?: Maybe<Scalars['String']>;
  hasIncompleteReviews?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  issues: Scalars['Int'];
  lepc?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  organizationStatus?: Maybe<TierIiReportOrgStatus>;
  partnerTenantName?: Maybe<Scalars['String']>;
  reportKind?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tierIIReportId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ChemicalInput = {
  alternateId?: InputMaybe<Scalars['String']>;
  casNumber?: InputMaybe<Scalars['String']>;
  components?: InputMaybe<Array<ChemicalComponentInput>>;
  createdAtViaMerge?: InputMaybe<Scalars['Date']>;
  density?: InputMaybe<Scalars['Float']>;
  densityUnits?: InputMaybe<DensityUnits>;
  documents?: InputMaybe<Array<ChemicalDocumentInput>>;
  ehsForm?: InputMaybe<EhsForm>;
  healthHazards?: InputMaybe<Array<HealthHazard>>;
  ifcHazards?: InputMaybe<Array<InternationalFireCodeHazard>>;
  isEhs?: InputMaybe<Scalars['Boolean']>;
  isTradeSecret?: InputMaybe<Scalars['Boolean']>;
  manufacturerSupplier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  needsReview?: InputMaybe<Scalars['Boolean']>;
  noCasNumber?: InputMaybe<Scalars['Boolean']>;
  noHazardsNotReporting?: InputMaybe<Scalars['Boolean']>;
  oregonHazards?: InputMaybe<Array<OregonHazard>>;
  physicalHazards?: InputMaybe<Array<PhysicalHazard>>;
  pureOrMixture?: InputMaybe<PureOrMixture>;
  recommendedUse?: InputMaybe<Scalars['String']>;
  revisionDate?: InputMaybe<Scalars['DateTime']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  stateOfMatter?: InputMaybe<Array<StateOfMatter>>;
  tenantIds?: InputMaybe<Array<Scalars['ID']>>;
  verifiedAt?: InputMaybe<Scalars['DateTime']>;
  verifiedBy?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['String']>;
};

export type ChemicalMeasurementSummary = {
  __typename?: 'ChemicalMeasurementSummary';
  alternateId?: Maybe<Scalars['String']>;
  casNumber?: Maybe<Scalars['String']>;
  components?: Maybe<Array<ChemicalComponent>>;
  hasCarryOver?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isEhs?: Maybe<Scalars['Boolean']>;
  issues: Array<Issue>;
  maxAmount?: Maybe<AmountWithUnit>;
  name: Scalars['String'];
  pureOrMixture?: Maybe<PureOrMixture>;
  totalMeasurements?: Maybe<Scalars['Int']>;
};

export type ChemicalOverviewFilter = {
  assignedToMe?: InputMaybe<Scalars['Boolean']>;
  reportKind?: InputMaybe<TierIiReportKind>;
  tagNames?: InputMaybe<Array<Scalars['String']>>;
};

export type ChemicalStateField = {
  __typename?: 'ChemicalStateField';
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  type: ProgramArea;
  value: Scalars['JSON'];
};

export type ChemicalTenant = {
  __typename?: 'ChemicalTenant';
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  id: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['String'];
};

export type ChemicalWithAssociatedData = {
  __typename?: 'ChemicalWithAssociatedData';
  chemical: Chemical;
  jurisdictions: Array<Scalars['String']>;
};

export type ChemicalsOverviewMyProgressResult = {
  __typename?: 'ChemicalsOverviewMyProgressResult';
  dueDate: Scalars['String'];
  reportsRemaining: Scalars['Int'];
  reportsTotal: Scalars['Int'];
};

export type ChemicalsResult = {
  __typename?: 'ChemicalsResult';
  count: Scalars['Int'];
  items: Array<Chemical>;
};

export type Cohort = {
  __typename?: 'Cohort';
  alternateIdId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['ID'];
  credentialUsername?: Maybe<Scalars['String']>;
  currentWorkflow?: Maybe<Workflow>;
  currentWorkflowId?: Maybe<Scalars['ID']>;
  errorMessage?: Maybe<Scalars['String']>;
  fdId?: Maybe<Scalars['ID']>;
  fireDepartment?: Maybe<FireDepartment>;
  id: Scalars['ID'];
  lepc?: Maybe<Lepc>;
  lepcId?: Maybe<Scalars['ID']>;
  members: Array<CohortMember>;
  reportingYear: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  status: CohortStatus;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  type: CohortType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['ID'];
  workflows: Array<Workflow>;
};

export type CohortMember = {
  __typename?: 'CohortMember';
  cohort: Cohort;
  cohortId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['ID'];
  facility: Facility;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  status: CohortMemberStatus;
  tierIIReport?: Maybe<TierIiReport>;
  tierIIReportId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['ID'];
};

export enum CohortMemberStatus {
  NotParticipating = 'NOT_PARTICIPATING',
  NotReady = 'NOT_READY',
  Ready = 'READY',
  Unknown = 'UNKNOWN'
}

export type CohortMembersResult = {
  __typename?: 'CohortMembersResult';
  count: Scalars['Int'];
  items: Array<CohortMember>;
};

export enum CohortStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export enum CohortType {
  AlternateId = 'ALTERNATE_ID',
  Credential = 'CREDENTIAL',
  FireDepartment = 'FIRE_DEPARTMENT',
  Lepc = 'LEPC',
  State = 'STATE'
}

export type CohortsResult = {
  __typename?: 'CohortsResult';
  count: Scalars['Int'];
  items: Array<Cohort>;
};

export enum CollectEvidenceOfCompletionActions {
  ChemicalCount = 'chemicalCount',
  Completion = 'completion'
}

export enum CollectionMode {
  Aggregate = 'AGGREGATE',
  AggregateDefaulted = 'AGGREGATE_DEFAULTED',
  Measurement = 'MEASUREMENT',
  MeasurementDefaulted = 'MEASUREMENT_DEFAULTED'
}

export type Comment = {
  __typename?: 'Comment';
  activity?: Maybe<Activity>;
  activityId?: Maybe<Scalars['ID']>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSystemMessage?: Maybe<Scalars['Boolean']>;
  report?: Maybe<TierIiReport>;
  reportId?: Maybe<Scalars['ID']>;
  submissionId?: Maybe<Scalars['ID']>;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  workflow?: Maybe<Workflow>;
  workflowId?: Maybe<Scalars['ID']>;
};

export type CommentInput = {
  activityId?: InputMaybe<Scalars['ID']>;
  comment: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  reportId?: InputMaybe<Scalars['ID']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  workflowId?: InputMaybe<Scalars['ID']>;
};

export type Communication = {
  __typename?: 'Communication';
  communicationDocuments: Array<CommunicationDocument>;
  communicationFacilities: Array<CommunicationFacility>;
  communicationType?: Maybe<CommunicationType>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completedByUser?: Maybe<User>;
  completedByUserId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  emailBody?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailRecipientAddresses: Array<Scalars['String']>;
  emailReplyTo?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  emailTemplateName?: Maybe<Scalars['String']>;
  fireDepartment?: Maybe<FireDepartment>;
  fireDepartmentId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  job?: Maybe<Job>;
  jobId?: Maybe<Scalars['String']>;
  leadAgency?: Maybe<LeadAgency>;
  leadAgencyId?: Maybe<Scalars['Int']>;
  lepc?: Maybe<Lepc>;
  lepcId?: Maybe<Scalars['String']>;
  lobMail?: Maybe<LobMail>;
  lobMailId?: Maybe<Scalars['String']>;
  mailRecipientAddressLine1?: Maybe<Scalars['String']>;
  mailRecipientAddressLine2?: Maybe<Scalars['String']>;
  mailRecipientCity?: Maybe<Scalars['String']>;
  mailRecipientState?: Maybe<Scalars['String']>;
  mailRecipientZip?: Maybe<Scalars['String']>;
  policeDepartment?: Maybe<PoliceDepartment>;
  policeDepartmentId?: Maybe<Scalars['Int']>;
  proofDocument?: Maybe<Document>;
  proofDocumentId?: Maybe<Scalars['String']>;
  recipientName?: Maybe<Scalars['String']>;
  status: CommunicationStatus;
  tenant: Tenant;
  tenantId: Scalars['String'];
  tierIIReports: Array<TierIiReport>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type CommunicationDocument = {
  __typename?: 'CommunicationDocument';
  communication: Communication;
  communicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  document: Document;
  documentId: Scalars['String'];
  id: Scalars['ID'];
  sequence: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type CommunicationFacility = {
  __typename?: 'CommunicationFacility';
  chemical?: Maybe<Chemical>;
  chemicalId?: Maybe<Scalars['String']>;
  communication: Communication;
  communicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility: Facility;
  facilityId: Scalars['String'];
  id: Scalars['ID'];
  reportingYear?: Maybe<Scalars['Int']>;
  type?: Maybe<CommunicationFacilityType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type CommunicationFacilityInput = {
  chemicalId?: InputMaybe<Scalars['ID']>;
  facilityId: Scalars['ID'];
  reportingYear?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<CommunicationFacilityType>;
};

export enum CommunicationFacilityType {
  Over_302ThresholdNotification = 'OVER_302_THRESHOLD_NOTIFICATION',
  Over_311ThresholdNotification = 'OVER_311_THRESHOLD_NOTIFICATION'
}

export enum CommunicationStatus {
  Draft = 'DRAFT',
  Error = 'ERROR',
  Pending = 'PENDING',
  SentToEmailClient = 'SENT_TO_EMAIL_CLIENT',
  SentToMailClient = 'SENT_TO_MAIL_CLIENT'
}

export enum CommunicationType {
  CertifiedMail = 'CERTIFIED_MAIL',
  Check = 'CHECK',
  Email = 'EMAIL',
  FirstClassMail = 'FIRST_CLASS_MAIL'
}

export type CommunicationsResult = {
  __typename?: 'CommunicationsResult';
  count: Scalars['Int'];
  items: Array<Communication>;
};

export enum ContactReportRole {
  EpcraBilling = 'EPCRA_BILLING',
  EpcraCaOperator = 'EPCRA_CA_OPERATOR',
  EpcraCaOwner = 'EPCRA_CA_OWNER',
  EpcraCaPropertyOwner = 'EPCRA_CA_PROPERTY_OWNER',
  EpcraCaTankOperator = 'EPCRA_CA_TANK_OPERATOR',
  EpcraCaTankOwner = 'EPCRA_CA_TANK_OWNER',
  EpcraChemicalCarrier = 'EPCRA_CHEMICAL_CARRIER',
  EpcraEmergencyContact = 'EPCRA_EMERGENCY_CONTACT',
  EpcraEmergencyCoordinator = 'EPCRA_EMERGENCY_COORDINATOR',
  EpcraEmergencyEquipmentContact = 'EPCRA_EMERGENCY_EQUIPMENT_CONTACT',
  EpcraOwnerOperator = 'EPCRA_OWNER_OPERATOR',
  EpcraT2MDirectSiteCommunication = 'EPCRA_T2M_DIRECT_SITE_COMMUNICATION',
  EpcraT2MParentCompany = 'EPCRA_T2M_PARENT_COMPANY',
  EpcraTierIiContact = 'EPCRA_TIER_II_CONTACT',
  General = 'GENERAL',
  RcraAuthorizedRepresentative = 'RCRA_AUTHORIZED_REPRESENTATIVE',
  RcraBillingContact = 'RCRA_BILLING_CONTACT',
  RcraHurricanePointOfContact = 'RCRA_HURRICANE_POINT_OF_CONTACT',
  RcraOperator = 'RCRA_OPERATOR',
  RcraOwner = 'RCRA_OWNER',
  RcraRealPropertyOwner = 'RCRA_REAL_PROPERTY_OWNER',
  RcraSiteContact = 'RCRA_SITE_CONTACT',
  RcraSiteManager = 'RCRA_SITE_MANAGER'
}

export type CopyFacilityInventoryResult = {
  __typename?: 'CopyFacilityInventoryResult';
  facilityId: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
};

export type CopyInventoryResult = {
  __typename?: 'CopyInventoryResult';
  fromYear?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum CopyableDemoTenantDataType {
  ChemicalAndFacility = 'CHEMICAL_AND_FACILITY',
  Waste = 'WASTE'
}

export type CopyableDemoTenantInput = {
  dataType: CopyableDemoTenantDataType;
};

export type CountStat = {
  __typename?: 'CountStat';
  count: Scalars['Int'];
  key: Scalars['String'];
  name: Scalars['String'];
};

export type CountiesResult = {
  __typename?: 'CountiesResult';
  count: Scalars['Int'];
  items: Array<Scalars['String']>;
};

export enum Country {
  Canada = 'CANADA',
  Usa = 'USA'
}

export type Counts = {
  __typename?: 'Counts';
  count?: Maybe<Scalars['Int']>;
  countKey?: Maybe<Scalars['String']>;
};

export type CreateChemicalsFromSdsInput = {
  documentIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type CreateCommunicationInput = {
  communicationDocuments: Array<DocumentWithSequenceInput>;
  facilities: Array<CommunicationFacilityInput>;
  recipients: Array<RecipientInput>;
  tenantId: Scalars['ID'];
  tierIIReportIds: Array<Scalars['ID']>;
};

export type CreateDocumentInput = {
  fileExtension: Scalars['String'];
  storageLink: Scalars['String'];
  title: Scalars['String'];
};

export type CreateSubmissionInput = {
  attachmentDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  comments?: InputMaybe<Array<CommentInput>>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  moveToReview?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  reportingPeriodEnd?: InputMaybe<Scalars['DateTime']>;
  reportingPeriodStart?: InputMaybe<Scalars['DateTime']>;
  reviewMode?: InputMaybe<ReviewMode>;
  reviewRequired?: InputMaybe<Scalars['Boolean']>;
  reviewers?: InputMaybe<Array<SubmissionReviewerInput>>;
  signatureType?: InputMaybe<SignatureType>;
  staffAssigneeId?: InputMaybe<Scalars['ID']>;
  submissionDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  submissionMethod?: InputMaybe<SubmissionMethod>;
  submissionType: SubmissionType;
  tenantId: Scalars['String'];
  title: Scalars['String'];
  virtualEventId: Scalars['ID'];
};

export type CreateSubtaskInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  title: Scalars['String'];
};

export type CreateTaskInput = {
  assigneeId: Scalars['ID'];
  deadline: Scalars['Date'];
  description?: InputMaybe<Scalars['String']>;
  documentIds: Array<Scalars['ID']>;
  facilityIds: Array<Scalars['ID']>;
  frequency: Frequency;
  interval: Scalars['Int'];
  links: Array<Scalars['String']>;
  reminderDays: Array<Scalars['Int']>;
  subtasks: Array<CreateSubtaskInput>;
  tags?: InputMaybe<Array<TagInput>>;
  tenantId: Scalars['ID'];
  title: Scalars['String'];
  watchers: Array<Scalars['ID']>;
};

export type CreateUserInput = {
  email: Scalars['String'];
  first?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
};

export type CreateWebAutomationJobInput = {
  action: WebAutomationAction;
  credentialId?: InputMaybe<Scalars['ID']>;
  credentialUsername: Scalars['String'];
  encampRequestId?: InputMaybe<Scalars['ID']>;
  evidenceOfCompletionActions: Array<CollectEvidenceOfCompletionActions>;
  facilityId?: InputMaybe<Scalars['ID']>;
  forceClassicSubmissionStrategy: Scalars['Boolean'];
  parameters: Scalars['JSON'];
  reportId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  requestId?: InputMaybe<Scalars['ID']>;
  stateOrTerritory: Scalars['String'];
  status: JobStatus;
  stepError: Scalars['String'];
  task: JobTask;
  tenantId: Scalars['String'];
};

export type Credential = {
  __typename?: 'Credential';
  email?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<Facility>>;
  facilityCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isEncampOwned: Scalars['Boolean'];
  issues?: Maybe<Array<Issue>>;
  kind: CredentialKind;
  lastVerificationCheckAt?: Maybe<Scalars['DateTime']>;
  lastVerificationSuccessAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  securityQuestions?: Maybe<Array<CredentialSecurityQuestion>>;
  states?: Maybe<Array<Scalars['String']>>;
  tenantId: Scalars['ID'];
  username: Scalars['String'];
  usesCombinedInvoicing: Scalars['Boolean'];
  verificationStatus: CredentialVerificationStatus;
};

export type CredentialInfo = {
  __typename?: 'CredentialInfo';
  username: Scalars['String'];
  verificationStatus: Scalars['String'];
};

export type CredentialInput = {
  email?: InputMaybe<Scalars['String']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  kind: CredentialKind;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  username: Scalars['String'];
  usesCombinedInvoicing?: InputMaybe<Scalars['Boolean']>;
};

export type CredentialInputForValidation = {
  email?: InputMaybe<Scalars['String']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  kind: CredentialKind;
  name: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['ID']>;
  username: Scalars['String'];
  usesCombinedInvoicing?: InputMaybe<Scalars['Boolean']>;
};

export enum CredentialKind {
  Lepc = 'LEPC',
  RcraCounty = 'RCRA_COUNTY',
  RcraFederal = 'RCRA_FEDERAL',
  RcraPayment = 'RCRA_PAYMENT',
  RcraState = 'RCRA_STATE',
  Tierii = 'TIERII'
}

export type CredentialResult = {
  __typename?: 'CredentialResult';
  count: Scalars['Int'];
  items: Array<Credential>;
};

export type CredentialSecurityQuestion = {
  __typename?: 'CredentialSecurityQuestion';
  answer: Scalars['String'];
  question: Scalars['String'];
};

export enum CredentialVerificationStatus {
  BadPassword = 'BAD_PASSWORD',
  BadSecurityQuestionAnswer = 'BAD_SECURITY_QUESTION_ANSWER',
  BadUsername = 'BAD_USERNAME',
  CurrentlyVerifying = 'CURRENTLY_VERIFYING',
  ExpiredPassword = 'EXPIRED_PASSWORD',
  FailedOneTimePassword = 'FAILED_ONE_TIME_PASSWORD',
  Good = 'GOOD',
  InvalidAccessidOrPassword = 'INVALID_ACCESSID_OR_PASSWORD',
  InUse = 'IN_USE',
  Locked = 'LOCKED',
  NotAttempted = 'NOT_ATTEMPTED',
  RequiresNewPassword = 'REQUIRES_NEW_PASSWORD',
  UnknownErrorNeedsHuman = 'UNKNOWN_ERROR_NEEDS_HUMAN',
  UnknownNonVerifiable = 'UNKNOWN_NON_VERIFIABLE',
  Verifying = 'VERIFYING'
}

export type CurrentlyReportedFederalGeneratorStatus = {
  __typename?: 'CurrentlyReportedFederalGeneratorStatus';
  createdDate: Scalars['Date'];
  status: RcraInfoFederalWasteGeneratorStatus;
};

export type CurrentlyReportedStateGeneratorStatus = {
  __typename?: 'CurrentlyReportedStateGeneratorStatus';
  createdDate: Scalars['Date'];
  status: StateRegulatoryStatus;
};

export type CurrentlyReportedStatus = {
  __typename?: 'CurrentlyReportedStatus';
  fedWasteGenerator?: Maybe<CurrentlyReportedFederalGeneratorStatus>;
  stateWasteGenerator?: Maybe<CurrentlyReportedStateGeneratorStatus>;
};

export enum DbCollectionMode {
  Aggregate = 'AGGREGATE',
  Measurement = 'MEASUREMENT'
}

export type DeleteCandidatesInput = {
  candidateIds: Array<Scalars['ID']>;
};

export type DeleteChemicalDocumentInput = {
  chemicalId: Scalars['ID'];
  documentId: Scalars['ID'];
};

export type DeleteChemicalDocumentResult = {
  __typename?: 'DeleteChemicalDocumentResult';
  chemicalDocumentId?: Maybe<Scalars['ID']>;
  document: Document;
};

export type DemoAccountCandidate = {
  __typename?: 'DemoAccountCandidate';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  naics?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  operatorName?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  rcraIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  registryId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DemoAccountCandidateSearchResult = {
  __typename?: 'DemoAccountCandidateSearchResult';
  count: Scalars['Int'];
  items: Array<DemoAccountCandidate>;
};

export type DemoOrganizationInput = {
  excludeDomains: Array<Scalars['String']>;
  excludeEpaIds: Array<Scalars['String']>;
  excludeNameTerms: Array<Scalars['String']>;
  excludeRegistryIds: Array<Scalars['String']>;
  includeDomains: Array<Scalars['String']>;
  includeEpaIds: Array<Scalars['String']>;
  includeNameTerms: Array<Scalars['String']>;
  includeRegistryIds: Array<Scalars['String']>;
  salesforceId?: InputMaybe<Scalars['String']>;
  tenantName: Scalars['String'];
};

export type DenialReason = {
  __typename?: 'DenialReason';
  configRule?: Maybe<WorkflowManagerConfigEnhanced>;
  type?: Maybe<DenialType>;
};

export enum DenialType {
  ExplicitFacility = 'EXPLICIT_FACILITY',
  ExplicitTenant = 'EXPLICIT_TENANT',
  ImplicitEnvironment = 'IMPLICIT_ENVIRONMENT',
  ImplicitState = 'IMPLICIT_STATE'
}

export type DeniedFacilitiesResult = {
  __typename?: 'DeniedFacilitiesResult';
  count: Scalars['Int'];
  items: Array<DeniedFacility>;
};

export type DeniedFacility = {
  __typename?: 'DeniedFacility';
  denialReasons: Array<DenialReason>;
  facility: FacilityPrimitives;
  partnerTenant?: Maybe<TenantPrimitives>;
  ruleUpdatedAt?: Maybe<Scalars['DateTime']>;
  ruleUpdatedBy?: Maybe<Scalars['String']>;
  tenant: TenantPrimitives;
};

export enum DensityUnits {
  KilogramsPerBarrel = 'KILOGRAMS_PER_BARREL',
  KilogramsPerCubicFoot = 'KILOGRAMS_PER_CUBIC_FOOT',
  KilogramsPerGallon = 'KILOGRAMS_PER_GALLON',
  KilogramsPerLiter = 'KILOGRAMS_PER_LITER',
  MetricTonsPerBarrel = 'METRIC_TONS_PER_BARREL',
  MetricTonsPerCubicFoot = 'METRIC_TONS_PER_CUBIC_FOOT',
  MetricTonsPerGallon = 'METRIC_TONS_PER_GALLON',
  MetricTonsPerLiter = 'METRIC_TONS_PER_LITER',
  PoundsPerBarrel = 'POUNDS_PER_BARREL',
  PoundsPerCubicFoot = 'POUNDS_PER_CUBIC_FOOT',
  PoundsPerGallon = 'POUNDS_PER_GALLON',
  PoundsPerLiter = 'POUNDS_PER_LITER',
  TonsPerBarrel = 'TONS_PER_BARREL',
  TonsPerCubicFoot = 'TONS_PER_CUBIC_FOOT',
  TonsPerGallon = 'TONS_PER_GALLON',
  TonsPerLiter = 'TONS_PER_LITER'
}

export enum DestinationViewType {
  Destinations = 'DESTINATIONS',
  DestinationsByManagementMethod = 'DESTINATIONS_BY_MANAGEMENT_METHOD',
  ManagementMethods = 'MANAGEMENT_METHODS'
}

export type DevtoolsReportsForTenantInput = {
  id: Scalars['ID'];
  state?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type DevtoolsReportsForTenantResult = {
  __typename?: 'DevtoolsReportsForTenantResult';
  updatedCount: Scalars['Int'];
};

export type Document = {
  __typename?: 'Document';
  activities?: Maybe<Array<Activity>>;
  area?: Maybe<Scalars['String']>;
  authoredAt?: Maybe<Scalars['Date']>;
  chemicalDocument?: Maybe<Array<ChemicalDocument>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  currentSubmissionDocument?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  documentMetadata?: Maybe<DocumentMetadata>;
  documentTags?: Maybe<Array<Tag>>;
  documentType: DocumentType;
  downloadLink?: Maybe<Scalars['String']>;
  extractedFilename?: Maybe<Scalars['String']>;
  extractionStatus: ExtractionStatus;
  facilities?: Maybe<Array<Facility>>;
  fileExtension?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  job?: Maybe<Array<Job>>;
  lastExtractionAt?: Maybe<Scalars['DateTime']>;
  lobId?: Maybe<Scalars['String']>;
  report?: Maybe<TierIiReport>;
  reportId?: Maybe<Scalars['String']>;
  sizeMegabytes?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  storageLink: Scalars['String'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export type DocumentAiEnrichmentJob = {
  __typename?: 'DocumentAIEnrichmentJob';
  documents: Array<Document>;
  id: Scalars['ID'];
  status: JobStatus;
};

export type DocumentAssociationsInput = {
  activityId?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['String']>;
  reportId?: InputMaybe<Scalars['String']>;
  stateFieldInfo?: InputMaybe<StateFieldInfoInput>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type DocumentFacilityMatches = {
  __typename?: 'DocumentFacilityMatches';
  documentId: Scalars['ID'];
  matches: Array<FacilityMatch>;
};

export type DocumentInput = {
  activityId?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['String']>;
  authoredAt?: InputMaybe<Scalars['Date']>;
  currentSubmissionDocument?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  documentTags?: InputMaybe<Array<TagInput>>;
  documentType?: InputMaybe<DocumentType>;
  facilities?: InputMaybe<Array<FacilityDocumentInput>>;
  fileExtension?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jurisdictions?: InputMaybe<Array<Scalars['String']>>;
  reportId?: InputMaybe<Scalars['String']>;
  sizeMegabytes?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  storageLink?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type DocumentInput2 = {
  area?: InputMaybe<Scalars['String']>;
  authoredAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentTags?: InputMaybe<Array<TagInput>>;
  documentType?: InputMaybe<DocumentType>;
  fileExtension?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  jurisdictions?: InputMaybe<Array<Scalars['String']>>;
  state?: InputMaybe<Scalars['String']>;
  storageLink?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type DocumentMetadata = {
  __typename?: 'DocumentMetadata';
  documentType: DocumentType;
  id: Scalars['ID'];
  programArea?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export enum DocumentSource {
  Customer = 'CUSTOMER',
  Tpm = 'TPM'
}

export enum DocumentStatus {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  Revoked = 'REVOKED'
}

export enum DocumentType {
  AstDocumentation = 'ASTDocumentation',
  AboveGroundPetroleumStorageActDocumentation = 'AboveGroundPetroleumStorageActDocumentation',
  Certification = 'Certification',
  Check = 'Check',
  CoverLetter = 'CoverLetter',
  DikeDescription = 'DikeDescription',
  Epcra302 = 'EPCRA302',
  Epcra304 = 'EPCRA304',
  Epcra311 = 'EPCRA311',
  Epcra312 = 'EPCRA312',
  Epcra313 = 'EPCRA313',
  EmergencyResponsePlan = 'EmergencyResponsePlan',
  FeeCalculation = 'FeeCalculation',
  Fees = 'Fees',
  Form = 'Form',
  HazardousMaterialsContingencyPlanOrQuickGuide = 'HazardousMaterialsContingencyPlanOrQuickGuide',
  HazardousMaterialsInventoryStatement = 'HazardousMaterialsInventoryStatement',
  HazardousMaterialsManagementPlan = 'HazardousMaterialsManagementPlan',
  HazardousWasteAnnualReport = 'HazardousWasteAnnualReport',
  HazardousWasteBiennialReport = 'HazardousWasteBiennialReport',
  HazardousWasteContingencyPlan = 'HazardousWasteContingencyPlan',
  HazardousWasteFeesReceipts = 'HazardousWasteFeesReceipts',
  HazardousWasteNotification = 'HazardousWasteNotification',
  HazardousWasteQuarterlyReport = 'HazardousWasteQuarterlyReport',
  HazardousWasteRecertification = 'HazardousWasteRecertification',
  HazardousWasteTankClosureCertificate = 'HazardousWasteTankClosureCertificate',
  Invoice = 'Invoice',
  NegativeDeclaration = 'NegativeDeclaration',
  Other = 'Other',
  OtherRcra = 'OtherRCRA',
  OwnerStatementOfDesignatedUstOperatorCompliance = 'OwnerStatementOfDesignatedUSTOperatorCompliance',
  P2Plan = 'P2Plan',
  P2Update = 'P2Update',
  Permit = 'Permit',
  Proof = 'Proof',
  RcraAnnual = 'RCRAAnnual',
  RcraFeePaymentOrInvoice = 'RCRAFeePaymentOrInvoice',
  RcraManifest = 'RCRAManifest',
  RcraUpdateNotification = 'RCRAUpdateNotification',
  Receipt = 'Receipt',
  RecyclableMaterialsReportDocumentation = 'RecyclableMaterialsReportDocumentation',
  ReferenceImage = 'ReferenceImage',
  Report = 'Report',
  RevisionOrUpdate = 'RevisionOrUpdate',
  SafeguardMeasures = 'SafeguardMeasures',
  SafetyDataSheet = 'SafetyDataSheet',
  Screenshot = 'Screenshot',
  SiteCoordinateAbbreviation = 'SiteCoordinateAbbreviation',
  SitePlan = 'SitePlan',
  SpillPreventionControlAndCountermeasurePlan = 'SpillPreventionControlAndCountermeasurePlan',
  Submission = 'Submission',
  TrainingPlan = 'TrainingPlan',
  UstCertificationOfFinancialResponsibility = 'USTCertificationOfFinancialResponsibility',
  UstDocumentation = 'USTDocumentation',
  UstLetterFromChiefFinancialOfficer = 'USTLetterFromChiefFinancialOfficer',
  UstMonitoringSitePlan = 'USTMonitoringSitePlan',
  UstOwnerOperatorWrittenAgreement = 'USTOwnerOperatorWrittenAgreement',
  UstResponsePlan = 'USTResponsePlan'
}

export type DocumentWithSequenceInput = {
  documentId: Scalars['ID'];
  sequence: Scalars['Int'];
};

export type DocumentsResult = {
  __typename?: 'DocumentsResult';
  count: Scalars['Int'];
  items: Array<Document>;
};

export type DownloadTierIiDeliverablesPreview = {
  __typename?: 'DownloadTierIIDeliverablesPreview';
  jobId: Scalars['ID'];
};

export type DynamicField = {
  __typename?: 'DynamicField';
  group?: Maybe<Scalars['String']>;
  helperText?: Maybe<Scalars['String']>;
  inputMask?: Maybe<Scalars['String']>;
  inputType: DynamicFieldType;
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  label: Scalars['String'];
  layout?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  selectOptions?: Maybe<Array<DynamicFieldOption>>;
  tooltip?: Maybe<Scalars['String']>;
  type?: Maybe<ProgramArea>;
  value?: Maybe<Scalars['JSON']>;
  visibleWhen?: Maybe<Scalars['JSON']>;
};

export type DynamicFieldInput = {
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  type: ProgramArea;
  value?: InputMaybe<Scalars['JSON']>;
};

export type DynamicFieldOption = {
  __typename?: 'DynamicFieldOption';
  label: Scalars['String'];
  value: Scalars['JSON'];
};

export enum DynamicFieldType {
  Autocomplete = 'AUTOCOMPLETE',
  Boolean = 'BOOLEAN',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  Multiselect = 'MULTISELECT',
  MultiselectWithOther = 'MULTISELECT_WITH_OTHER',
  Numeric = 'NUMERIC',
  PhoneNumber = 'PHONE_NUMBER',
  Radiogroup = 'RADIOGROUP',
  Select = 'SELECT',
  SelectNjPoliceDepartment = 'SELECT_NJ_POLICE_DEPARTMENT',
  SelectWithOther = 'SELECT_WITH_OTHER',
  SicCodeSelect = 'SIC_CODE_SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type DynamicFieldsResult = {
  __typename?: 'DynamicFieldsResult';
  items: Array<DynamicField>;
};

export type EchoExporter = {
  __typename?: 'EchoExporter';
  airFlag?: Maybe<Scalars['Boolean']>;
  airIds: Array<Scalars['String']>;
  caa3yrComplQtrsHistory: Array<QuarterlyHistory>;
  caaComplianceStatus?: Maybe<Scalars['String']>;
  caaDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  caaDaysLastEvaluation?: Maybe<Scalars['Int']>;
  caaEvaluationCount?: Maybe<Scalars['Int']>;
  caaFormalActionCount?: Maybe<Scalars['Int']>;
  caaHpvFlag?: Maybe<Scalars['Boolean']>;
  caaInformalCount?: Maybe<Scalars['Int']>;
  caaLastPenaltyAmt?: Maybe<Scalars['Float']>;
  caaLastPenaltyDate?: Maybe<Scalars['DateTime']>;
  caaNaics: Array<Scalars['String']>;
  caaPenalties?: Maybe<Scalars['Float']>;
  caaPermitTypes: Array<Scalars['String']>;
  caaQtrsWithNc?: Maybe<Scalars['Int']>;
  caaSics: Array<Scalars['String']>;
  cwa3yrQncrCodes?: Maybe<Scalars['String']>;
  cwa13qtrsComplHistory: Array<QuarterlyHistory>;
  cwa13qtrsEfflntExceedances?: Maybe<Scalars['Float']>;
  cwaComplianceStatus?: Maybe<Scalars['String']>;
  cwaComplianceTracking?: Maybe<Scalars['String']>;
  cwaDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  cwaDaysLastInspection?: Maybe<Scalars['Int']>;
  cwaFormalActionCount?: Maybe<Scalars['Int']>;
  cwaInformalCount?: Maybe<Scalars['Int']>;
  cwaInspectionCount?: Maybe<Scalars['Int']>;
  cwaLastPenaltyAmt?: Maybe<Scalars['Float']>;
  cwaLastPenaltyDate?: Maybe<Scalars['DateTime']>;
  cwaNaics: Array<Scalars['String']>;
  cwaPenalties?: Maybe<Scalars['Float']>;
  cwaPermitTypes: Array<Scalars['String']>;
  cwaQtrsWithNc?: Maybe<Scalars['Int']>;
  cwaSics: Array<Scalars['String']>;
  cwaSncFlag?: Maybe<Scalars['Boolean']>;
  dfrUrl?: Maybe<Scalars['String']>;
  ejscreenFlagUs?: Maybe<Scalars['Boolean']>;
  fac3yrComplianceHistory: Array<QuarterlyHistory>;
  facAccuracyMeters?: Maybe<Scalars['Float']>;
  facActiveFlag?: Maybe<Scalars['Boolean']>;
  facChesapeakeBayFlg?: Maybe<Scalars['Boolean']>;
  facCity?: Maybe<Scalars['String']>;
  facCollectionMethod?: Maybe<Scalars['String']>;
  facComplianceStatus?: Maybe<Scalars['String']>;
  facCounty?: Maybe<Scalars['String']>;
  facDateLastFormalActEpa?: Maybe<Scalars['DateTime']>;
  facDateLastFormalActSt?: Maybe<Scalars['DateTime']>;
  facDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  facDateLastInformalActEpa?: Maybe<Scalars['DateTime']>;
  facDateLastInformalActSt?: Maybe<Scalars['DateTime']>;
  facDateLastInformalAction?: Maybe<Scalars['DateTime']>;
  facDateLastInspection?: Maybe<Scalars['DateTime']>;
  facDateLastInspectionEpa?: Maybe<Scalars['DateTime']>;
  facDateLastInspectionState?: Maybe<Scalars['DateTime']>;
  facDateLastPenalty?: Maybe<Scalars['DateTime']>;
  facDaysLastInspection?: Maybe<Scalars['Int']>;
  facDerivedCb2010?: Maybe<Scalars['String']>;
  facDerivedCd113?: Maybe<Scalars['String']>;
  facDerivedHuc?: Maybe<Scalars['String']>;
  facDerivedStctyFips?: Maybe<Scalars['String']>;
  facDerivedTribes?: Maybe<Scalars['String']>;
  facDerivedWbd?: Maybe<Scalars['String']>;
  facDerivedZip?: Maybe<Scalars['String']>;
  facEpaRegion?: Maybe<Scalars['String']>;
  facFederalAgency?: Maybe<Scalars['String']>;
  facFederalFlg?: Maybe<Scalars['Boolean']>;
  facFipsCode?: Maybe<Scalars['String']>;
  facFormalActionCount?: Maybe<Scalars['Int']>;
  facImpWaterFlg?: Maybe<Scalars['Boolean']>;
  facIndianCntryFlg?: Maybe<Scalars['Boolean']>;
  facInformalCount?: Maybe<Scalars['Int']>;
  facInspectionCount?: Maybe<Scalars['Int']>;
  facLastPenaltyAmt?: Maybe<Scalars['Float']>;
  facLat?: Maybe<Scalars['Float']>;
  facLong?: Maybe<Scalars['Float']>;
  facMajorFlag?: Maybe<Scalars['Boolean']>;
  facMapIcon?: Maybe<Scalars['String']>;
  facMyrtkUniverse?: Maybe<Scalars['String']>;
  facNaaFlag?: Maybe<Scalars['Boolean']>;
  facNaicsCodes: Array<Scalars['String']>;
  facName?: Maybe<Scalars['String']>;
  facPenaltyCount?: Maybe<Scalars['Int']>;
  facPercentMinority?: Maybe<Scalars['Float']>;
  facPopDen?: Maybe<Scalars['Float']>;
  facProgramsWithSnc?: Maybe<Scalars['Int']>;
  facQtrsWithNc?: Maybe<Scalars['Int']>;
  facReferencePoint?: Maybe<Scalars['String']>;
  facSicCodes: Array<Scalars['String']>;
  facSncFlg?: Maybe<Scalars['Boolean']>;
  facState?: Maybe<Scalars['String']>;
  facStreet?: Maybe<Scalars['String']>;
  facTotalPenalties?: Maybe<Scalars['Float']>;
  facUsMexBorderFlg?: Maybe<Scalars['Boolean']>;
  facZip?: Maybe<Scalars['String']>;
  fecCaseIds: Array<Scalars['String']>;
  fecLastCaseDate?: Maybe<Scalars['DateTime']>;
  fecNumberOfCases?: Maybe<Scalars['Int']>;
  fecTotalPenalties?: Maybe<Scalars['Float']>;
  ghgCo2Releases?: Maybe<Scalars['Float']>;
  ghgFlag?: Maybe<Scalars['Boolean']>;
  ghgIds: Array<Scalars['String']>;
  npdesFlag?: Maybe<Scalars['Boolean']>;
  npdesIds: Array<Scalars['String']>;
  rcra3yrComplQtrsHistory: Array<QuarterlyHistory>;
  rcraComplianceStatus?: Maybe<Scalars['String']>;
  rcraDateLastFormalAction?: Maybe<Scalars['DateTime']>;
  rcraDaysLastEvaluation?: Maybe<Scalars['Int']>;
  rcraFlag?: Maybe<Scalars['Boolean']>;
  rcraFormalActionCount?: Maybe<Scalars['Int']>;
  rcraIds: Array<Scalars['String']>;
  rcraInformalCount?: Maybe<Scalars['Int']>;
  rcraInspectionCount?: Maybe<Scalars['Int']>;
  rcraLastPenaltyAmt?: Maybe<Scalars['Float']>;
  rcraLastPenaltyDate?: Maybe<Scalars['DateTime']>;
  rcraNaics: Array<Scalars['String']>;
  rcraPenalties?: Maybe<Scalars['Float']>;
  rcraPermitTypes: Array<Scalars['String']>;
  rcraQtrsWithNc?: Maybe<Scalars['Int']>;
  rcraSncFlag?: Maybe<Scalars['Boolean']>;
  registryId: Scalars['String'];
  sdwaComplianceStatus?: Maybe<Scalars['String']>;
  sdwaFormalActionCount?: Maybe<Scalars['Int']>;
  sdwaIds: Array<Scalars['String']>;
  sdwaInformalCount?: Maybe<Scalars['Int']>;
  sdwaSncFlag?: Maybe<Scalars['Boolean']>;
  sdwaSystemTypes: Array<Scalars['String']>;
  sdwisFlag?: Maybe<Scalars['Boolean']>;
  triFlag?: Maybe<Scalars['Boolean']>;
  triIds: Array<Scalars['String']>;
  triOffSiteTransfers?: Maybe<Scalars['Float']>;
  triOnSiteReleases?: Maybe<Scalars['Float']>;
  triReleasesTransfers?: Maybe<Scalars['Float']>;
  triReporter?: Maybe<Scalars['Boolean']>;
  triReporterInPast?: Maybe<Scalars['Boolean']>;
};

export type EchoExporterAggregated = {
  __typename?: 'EchoExporterAggregated';
  echoFacilityName?: Maybe<Scalars['String']>;
  echoFirstNaicsCode?: Maybe<Scalars['String']>;
  facilityCity?: Maybe<Scalars['String']>;
  facilityCounty?: Maybe<Scalars['String']>;
  facilityState?: Maybe<Scalars['String']>;
  facilityStreet?: Maybe<Scalars['String']>;
  facilityZip?: Maybe<Scalars['String']>;
  naics3?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['Int']>;
  nonComplianceCountLast12Qrtrs?: Maybe<Scalars['Int']>;
  penaltiesLast12Qrtrs?: Maybe<Scalars['Float']>;
  registryId: Scalars['String'];
  violationCountLast12Qrtrs?: Maybe<Scalars['Int']>;
};

export type EchoExporterResult = {
  __typename?: 'EchoExporterResult';
  count: Scalars['Int'];
  items: Array<EchoExporter>;
};

export type EchoOverview = {
  __typename?: 'EchoOverview';
  history: Array<EchoOverviewHistory>;
  stats: EchoOverviewStats;
};

export type EchoOverviewHistory = {
  __typename?: 'EchoOverviewHistory';
  noViolation: Scalars['Int'];
  program: Scalars['String'];
  quarter: Scalars['String'];
  significantNoncompliance: Scalars['Int'];
  unknown: Scalars['Int'];
  violation: Scalars['Int'];
};

export type EchoOverviewStats = {
  __typename?: 'EchoOverviewStats';
  activeFacilityCount?: Maybe<Scalars['Int']>;
  airComplianceStatusCounts?: Maybe<Array<Counts>>;
  airFacilityCount?: Maybe<Scalars['Int']>;
  airPermitTypeCounts?: Maybe<Array<Counts>>;
  airSignificantViolatorCount?: Maybe<Scalars['Int']>;
  airViolatorCount?: Maybe<Scalars['Int']>;
  totalFacilityCount?: Maybe<Scalars['Int']>;
  wasteComplianceStatusCounts?: Maybe<Array<Counts>>;
  wasteFacilityCount?: Maybe<Scalars['Int']>;
  wastePermitTypeCounts?: Maybe<Array<Counts>>;
  wasteSignificantViolatorCount?: Maybe<Scalars['Int']>;
  wasteViolatorCount?: Maybe<Scalars['Int']>;
  waterComplianceStatusCounts?: Maybe<Array<Counts>>;
  waterFacilityCount?: Maybe<Scalars['Int']>;
  waterPermitTypeCounts?: Maybe<Array<Counts>>;
  waterSignificantViolatorCount?: Maybe<Scalars['Int']>;
  waterViolatorCount?: Maybe<Scalars['Int']>;
};

export enum EchoQuarterlyHistory {
  Inactive = 'INACTIVE',
  NoViolation = 'NO_VIOLATION',
  SignificantNoncompliance = 'SIGNIFICANT_NONCOMPLIANCE',
  Unknown = 'UNKNOWN',
  Violation = 'VIOLATION'
}

export enum EhsForm {
  Molten = 'MOLTEN',
  None = 'NONE',
  SolidParticleSizeLessThan_100Micron = 'SOLID_PARTICLE_SIZE_LESS_THAN_100_MICRON',
  Solution = 'SOLUTION'
}

export type EmailReviewersResult = {
  __typename?: 'EmailReviewersResult';
  ids: Array<Scalars['ID']>;
  success: Scalars['Boolean'];
};

export type EncampFilingStatusResult = {
  __typename?: 'EncampFilingStatusResult';
  totalFiled: Scalars['Int'];
  totalWaitingToFile: Scalars['Int'];
  totalWaitingToReceive: Scalars['Int'];
};

export type EncampStats = {
  __typename?: 'EncampStats';
  hoursSaved: Scalars['Int'];
  totalPaymentsMade: Scalars['Float'];
  totalPaymentsManaged: Scalars['Int'];
  treesPlanted: Scalars['Int'];
};

export type EpaIdStatus = {
  __typename?: 'EpaIdStatus';
  epaId: Scalars['String'];
  isInactive: Scalars['Boolean'];
};

export type ErrorBlockingCohort = {
  __typename?: 'ErrorBlockingCohort';
  activityType: ActivityType;
  cohortId: Scalars['String'];
  cohortMembers: Scalars['Int'];
  errorMessage: Scalars['String'];
  groupId: Scalars['Int'];
  workflowId: Scalars['String'];
};

export type ErrorCluster = {
  __typename?: 'ErrorCluster';
  activityDescription?: Maybe<Scalars['String']>;
  activityId: Scalars['String'];
  activityType: ActivityType;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  errorMessage: Scalars['String'];
  facilityId: Scalars['String'];
  facilityName: Scalars['String'];
  groupId: Scalars['Int'];
  id: Scalars['ID'];
  reportId: Scalars['String'];
  reportTags: Array<Scalars['String']>;
  runId: Scalars['String'];
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  workflowId: Scalars['String'];
  workflowType: WorkflowType;
};

export type ErrorClusterGroup = {
  __typename?: 'ErrorClusterGroup';
  errorPattern: Scalars['String'];
  facilitiesInGroupCount: Scalars['Int'];
  facilityIds: Array<Scalars['String']>;
  groupId: Scalars['Int'];
  groupSize: Scalars['Int'];
};

export type ErrorClusterGroupsResult = {
  __typename?: 'ErrorClusterGroupsResult';
  count: Scalars['Int'];
  items: Array<ErrorClusterGroup>;
};

export type ErrorClusterRun = {
  __typename?: 'ErrorClusterRun';
  groupCount: Scalars['Int'];
  runId: Scalars['String'];
  totalErrors: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ErrorClusterRunsResult = {
  __typename?: 'ErrorClusterRunsResult';
  count: Scalars['Int'];
  items: Array<ErrorClusterRun>;
};

export type ErrorClustersResult = {
  __typename?: 'ErrorClustersResult';
  count: Scalars['Int'];
  items: Array<ErrorCluster>;
};

export type ErrorsBlockingCohortResult = {
  __typename?: 'ErrorsBlockingCohortResult';
  count: Scalars['Int'];
  items: Array<ErrorBlockingCohort>;
};

export type EventMutationInput = {
  date: Scalars['Date'];
  eventMutationScope: EventMutationScope;
  taskId: Scalars['ID'];
};

export enum EventMutationScope {
  All = 'ALL',
  This = 'THIS',
  ThisAndFollowing = 'THIS_AND_FOLLOWING'
}

export enum ExecutionPlanType {
  Automation = 'Automation',
  Human = 'Human'
}

export type ExemptMailingAddressFromVerificationInput = {
  city: Scalars['String'];
  primaryLine: Scalars['String'];
  recipientName: Scalars['String'];
  secondaryLine?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type ExportCsvResult = {
  __typename?: 'ExportCsvResult';
  downloadUrl?: Maybe<Scalars['String']>;
  errorMsg?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ExtensionsByProgramArea = {
  __typename?: 'ExtensionsByProgramArea';
  EPCRA: Array<DynamicField>;
};

export type ExtensionsByProgramAreaInput = {
  EPCRA?: InputMaybe<Scalars['JSON']>;
};

export enum ExtractionStatus {
  Failed = 'FAILED',
  NotAttempted = 'NOT_ATTEMPTED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type FacilitiesResult = {
  __typename?: 'FacilitiesResult';
  count: Scalars['Int'];
  items: Array<Facility>;
};

export type Facility = {
  __typename?: 'Facility';
  businessUnit?: Maybe<Scalars['String']>;
  chemicalFeatureFlagOverride?: Maybe<FeatureFlagOverride>;
  city?: Maybe<Scalars['String']>;
  collectionMode?: Maybe<CollectionMode>;
  colocationReportingFacility?: Maybe<Facility>;
  colocationReportingFacilityId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  contacts?: Maybe<Array<FacilityContact>>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  dateClosed?: Maybe<Scalars['Date']>;
  dateInactive?: Maybe<Scalars['Date']>;
  dateOpened?: Maybe<Scalars['Date']>;
  dbNumber?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Document>>;
  eManifestLastUpdated?: Maybe<Scalars['DateTime']>;
  echoFacilityMatchCandidates?: Maybe<Array<InsightsCandidate>>;
  epaGeneratorStatus?: Maybe<Scalars['String']>;
  epaGeneratorStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  epaGeneratorStatusUpdatedBy?: Maybe<Scalars['String']>;
  epaIdStatuses: Array<EpaIdStatus>;
  facilityAlternateIds?: Maybe<Array<AlternateId>>;
  facilityChemicalStateFields?: Maybe<Array<FacilityChemicalStateField>>;
  facilityCredentials?: Maybe<Array<FacilityCredential>>;
  facilityType?: Maybe<Scalars['String']>;
  facilityWasteStreams?: Maybe<FacilityWasteStreamResult>;
  fireDepartment?: Maybe<FireDepartment>;
  fireDepartmentId?: Maybe<Scalars['String']>;
  fireDepartmentName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAutoGeocoded?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isMailingAddressEncamp?: Maybe<Scalars['Boolean']>;
  isMailingAddressSameAsFacility?: Maybe<Scalars['Boolean']>;
  isNotReporting?: Maybe<Scalars['Boolean']>;
  isNotReportingThroughEncamp?: Maybe<Scalars['Boolean']>;
  isSubjectToChemicalAccidentPrevention?: Maybe<Scalars['Boolean']>;
  isSubjectToEmergencyPlanning?: Maybe<Scalars['Boolean']>;
  isSubjectToToxicsReleaseInventoryReporting?: Maybe<Scalars['Boolean']>;
  isUnmanned?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  jobs?: Maybe<Array<Job>>;
  latitude?: Maybe<Scalars['Float']>;
  lepc?: Maybe<Lepc>;
  lepcId?: Maybe<Scalars['String']>;
  lepcName?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  mailingCity?: Maybe<Scalars['String']>;
  mailingCompanyName?: Maybe<Scalars['String']>;
  mailingCountry?: Maybe<Scalars['String']>;
  mailingState?: Maybe<Scalars['String']>;
  mailingStreetAddress1?: Maybe<Scalars['String']>;
  mailingStreetAddress2?: Maybe<Scalars['String']>;
  mailingZip?: Maybe<Scalars['String']>;
  maxNumOccupants?: Maybe<Scalars['Int']>;
  mostRecentEManifestShippedDate?: Maybe<Scalars['Date']>;
  mostRecentVendorManifestShippedDate?: Maybe<Scalars['Date']>;
  municipality?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  phone24Hour?: Maybe<Scalars['String']>;
  portalCredential?: Maybe<PortalCredential>;
  rawExtensions?: Maybe<Scalars['JSON']>;
  regulatoryStatus?: Maybe<FacilityRegulatoryStatus>;
  renderPhone?: Maybe<DynamicField>;
  renderPhone24Hour?: Maybe<DynamicField>;
  reportingChemicalCount: Scalars['Int'];
  reportsManually?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  stateFields: Array<DynamicField>;
  status?: Maybe<FacilityStatus>;
  statusReason?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  supplementalFireDepartments?: Maybe<Array<SupplementalFireDepartment>>;
  supplementalLepcs?: Maybe<Array<SupplementalLepc>>;
  tags: Array<Tag>;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
  tierIIReports?: Maybe<Array<TierIiReport>>;
  undergroundStorageTanks?: Maybe<Array<UndergroundStorageTank>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  useEncampBillingContact?: Maybe<Scalars['Boolean']>;
  vendorWasteManifestLastUpdated?: Maybe<Scalars['DateTime']>;
  wasteCodes?: Maybe<WasteCodesResult>;
  wasteFeatureFlagOverride?: Maybe<FeatureFlagOverride>;
  wasteStreams?: Maybe<WasteStreamsResult>;
  zip?: Maybe<Scalars['String']>;
};


export type FacilityContactsArgs = {
  programArea?: InputMaybe<ProgramArea>;
};


export type FacilityFacilityWasteStreamsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type FacilityJobsArgs = {
  action?: InputMaybe<WebAutomationAction>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type FacilityWasteCodesArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  view?: InputMaybe<FacilityWasteView>;
};


export type FacilityWasteStreamsArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  view?: InputMaybe<FacilityWasteView>;
};

export type FacilityChemical = {
  __typename?: 'FacilityChemical';
  averageAmount?: Maybe<Scalars['Float']>;
  averageAmountCode?: Maybe<Scalars['Int']>;
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  daysOnSite?: Maybe<Scalars['Int']>;
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isAlwaysReported?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  jurisdictions?: Maybe<Array<Scalars['String']>>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxAmountCode?: Maybe<Scalars['Int']>;
  maxAmountLargestContainer?: Maybe<Scalars['Float']>;
  reportingFacilityChemical?: Maybe<ReportingFacilityChemical>;
  reportingYear: Scalars['Int'];
  stateFields: Array<DynamicField>;
  storageLocations?: Maybe<Array<FacilityChemicalStorageLocation>>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityChemicalInput = {
  averageAmount?: InputMaybe<Scalars['FlexibleFloat']>;
  averageAmountCode?: InputMaybe<Scalars['Int']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  daysOnSite?: InputMaybe<Scalars['FlexibleInt']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  hasConfidentialStorageLocations?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isAlwaysReported?: InputMaybe<Scalars['Boolean']>;
  maxAmount?: InputMaybe<Scalars['FlexibleFloat']>;
  maxAmountCode?: InputMaybe<Scalars['Int']>;
  maxAmountLargestContainer?: InputMaybe<Scalars['FlexibleFloat']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  storageLocations: Array<FacilityChemicalStorageLocationInput>;
  unit?: InputMaybe<UnitType>;
};

export type FacilityChemicalMeasurement = {
  __typename?: 'FacilityChemicalMeasurement';
  amount: Scalars['Float'];
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  maxAmountLargestContainer?: Maybe<Scalars['Float']>;
  measuredAtUtc: Scalars['Date'];
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit: UnitType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityChemicalMeasurementInput = {
  amount?: InputMaybe<Scalars['Float']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  facilityId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  maxAmountLargestContainer?: InputMaybe<Scalars['Float']>;
  measuredAtUtc?: InputMaybe<Scalars['Date']>;
  otherPressureValue?: InputMaybe<Scalars['String']>;
  pressure?: InputMaybe<Pressure>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId: Scalars['ID'];
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
  unit?: InputMaybe<UnitType>;
};

export type FacilityChemicalMeasurementsResult = {
  __typename?: 'FacilityChemicalMeasurementsResult';
  count: Scalars['Int'];
  items: Array<FacilityChemicalMeasurement>;
};

export type FacilityChemicalStateField = {
  __typename?: 'FacilityChemicalStateField';
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  reportingYear: Scalars['Int'];
  type: ProgramArea;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  value: Scalars['JSON'];
};

export type FacilityChemicalStateFieldInput = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  reportingYear: Scalars['Int'];
  type: ProgramArea;
  value?: InputMaybe<Scalars['JSON']>;
};

export type FacilityChemicalStorageLocation = {
  __typename?: 'FacilityChemicalStorageLocation';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facilityChemical?: Maybe<FacilityChemical>;
  facilityChemicalId: Scalars['ID'];
  id: Scalars['ID'];
  maxAmount?: Maybe<Scalars['Float']>;
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityChemicalStorageLocationInput = {
  id: Scalars['ID'];
  maxAmount?: InputMaybe<Scalars['FlexibleFloat']>;
  otherPressureValue?: InputMaybe<Scalars['String']>;
  pressure?: InputMaybe<Pressure>;
  storageLocation: StorageLocationInput;
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
  unit?: InputMaybe<UnitType>;
};

export type FacilityChemicalThresholdData = {
  __typename?: 'FacilityChemicalThresholdData';
  isOverThreshold?: Maybe<Scalars['Boolean']>;
};

export type FacilityChemicalsResult = {
  __typename?: 'FacilityChemicalsResult';
  count: Scalars['Int'];
  items: Array<FacilityChemical>;
};

export type FacilityContact = {
  __typename?: 'FacilityContact';
  facility: Facility;
  id: Scalars['ID'];
  isPrimaryContact?: Maybe<Scalars['Boolean']>;
  issues?: Maybe<Array<Issue>>;
  person: Person;
  reportingRoles: Array<ContactReportRole>;
};

export type FacilityContactInput = {
  facilityId: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>;
  person: PersonInput;
  reportingRoles: Array<ContactReportRole>;
};

export type FacilityCredential = {
  __typename?: 'FacilityCredential';
  credential: Credential;
  credentialId: Scalars['ID'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
};

export type FacilityDocumentInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type FacilityEpaId = {
  __typename?: 'FacilityEPAId';
  currentWasteGeneratorStatus?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  epaId?: Maybe<Scalars['String']>;
  facility: Facility;
  facilityId: Scalars['ID'];
};

export type FacilityEchoExporter = {
  __typename?: 'FacilityEchoExporter';
  customerFacilityId?: Maybe<Scalars['String']>;
  echoFacilityName?: Maybe<Scalars['String']>;
  echoFirstNaicsCode?: Maybe<Scalars['String']>;
  facilityCity?: Maybe<Scalars['String']>;
  facilityCounty?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
  facilityState?: Maybe<Scalars['String']>;
  facilityStatus?: Maybe<FacilityStatus>;
  facilityStreet?: Maybe<Scalars['String']>;
  facilityZip?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  naics3?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['Int']>;
  nonComplianceCountLast12Qrtrs?: Maybe<Scalars['Int']>;
  penaltiesLast12Qrtrs?: Maybe<Scalars['Float']>;
  registryId?: Maybe<Scalars['String']>;
  violationCountLast12Qrtrs?: Maybe<Scalars['Int']>;
};

export type FacilityInput = {
  businessUnit?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  collectionMode?: InputMaybe<DbCollectionMode>;
  colocationReportingFacilityId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  customerFacilityId?: InputMaybe<Scalars['String']>;
  dateClosed?: InputMaybe<Scalars['Date']>;
  dateInactive?: InputMaybe<Scalars['Date']>;
  dateOpened?: InputMaybe<Scalars['Date']>;
  dbNumber?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  epaGeneratorStatus?: InputMaybe<Scalars['String']>;
  epaGeneratorStatusUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  epaGeneratorStatusUpdatedBy?: InputMaybe<Scalars['String']>;
  facilityAlternateIds?: InputMaybe<Array<AlternateIdInput>>;
  facilityType?: InputMaybe<Scalars['String']>;
  fireDepartmentId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isAutoGeocoded?: InputMaybe<Scalars['Boolean']>;
  isColocated?: InputMaybe<Scalars['Boolean']>;
  isMailingAddressEncamp?: InputMaybe<Scalars['Boolean']>;
  isMailingAddressSameAsFacility?: InputMaybe<Scalars['JSON']>;
  isSubjectToChemicalAccidentPrevention?: InputMaybe<Scalars['Boolean']>;
  isSubjectToEmergencyPlanning?: InputMaybe<Scalars['Boolean']>;
  isSubjectToToxicsReleaseInventoryReporting?: InputMaybe<Scalars['Boolean']>;
  isUnmanned?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  lepcId?: InputMaybe<Scalars['ID']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mailingCity?: InputMaybe<Scalars['String']>;
  mailingCompanyName?: InputMaybe<Scalars['String']>;
  mailingCountry?: InputMaybe<Scalars['String']>;
  mailingState?: InputMaybe<Scalars['String']>;
  mailingStreetAddress1?: InputMaybe<Scalars['String']>;
  mailingStreetAddress2?: InputMaybe<Scalars['String']>;
  mailingZip?: InputMaybe<Scalars['String']>;
  maxNumOccupants?: InputMaybe<Scalars['Int']>;
  municipality?: InputMaybe<Scalars['String']>;
  naicsCode?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone24Hour?: InputMaybe<Scalars['String']>;
  rawExtensions?: InputMaybe<Scalars['JSON']>;
  reportingChemicalCount?: InputMaybe<Scalars['Int']>;
  reportsManually?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  status?: InputMaybe<FacilityStatus>;
  statusReason?: InputMaybe<Scalars['String']>;
  streetAddress1?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  supplementalFireDepartmentIds?: InputMaybe<Array<Scalars['ID']>>;
  supplementalLepcIds?: InputMaybe<Array<Scalars['ID']>>;
  tags?: InputMaybe<Array<TagInput>>;
  useEncampBillingContact?: InputMaybe<Scalars['Boolean']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FacilityMatch = {
  __typename?: 'FacilityMatch';
  facilityId: Scalars['ID'];
  score: Scalars['Float'];
};

export type FacilityPayment = {
  __typename?: 'FacilityPayment';
  amount?: Maybe<Scalars['Float']>;
  facility?: Maybe<Facility>;
};

export type FacilityPrimitives = {
  __typename?: 'FacilityPrimitives';
  businessUnit?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  collectionMode?: Maybe<CollectionMode>;
  colocationReportingFacilityId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  dateClosed?: Maybe<Scalars['Date']>;
  dateInactive?: Maybe<Scalars['Date']>;
  dateOpened?: Maybe<Scalars['Date']>;
  dbNumber?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  epaGeneratorStatus?: Maybe<Scalars['String']>;
  epaGeneratorStatusUpdatedAt?: Maybe<Scalars['DateTime']>;
  epaGeneratorStatusUpdatedBy?: Maybe<Scalars['String']>;
  facilityType?: Maybe<Scalars['String']>;
  fireDepartmentId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isAutoGeocoded?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isMailingAddressEncamp?: Maybe<Scalars['Boolean']>;
  isMailingAddressSameAsFacility?: Maybe<Scalars['Boolean']>;
  isNotReporting?: Maybe<Scalars['Boolean']>;
  isNotReportingThroughEncamp?: Maybe<Scalars['Boolean']>;
  isSubjectToChemicalAccidentPrevention?: Maybe<Scalars['Boolean']>;
  isSubjectToEmergencyPlanning?: Maybe<Scalars['Boolean']>;
  isSubjectToToxicsReleaseInventoryReporting?: Maybe<Scalars['Boolean']>;
  isUnmanned?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  lepcId?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  mailingCity?: Maybe<Scalars['String']>;
  mailingCompanyName?: Maybe<Scalars['String']>;
  mailingCountry?: Maybe<Scalars['String']>;
  mailingState?: Maybe<Scalars['String']>;
  mailingStreetAddress1?: Maybe<Scalars['String']>;
  mailingStreetAddress2?: Maybe<Scalars['String']>;
  mailingZip?: Maybe<Scalars['String']>;
  maxNumOccupants?: Maybe<Scalars['Int']>;
  municipality?: Maybe<Scalars['String']>;
  naicsCode?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  phone24Hour?: Maybe<Scalars['String']>;
  reportsManually?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  status?: Maybe<FacilityStatus>;
  statusReason?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  useEncampBillingContact?: Maybe<Scalars['Boolean']>;
  zip?: Maybe<Scalars['String']>;
};

export type FacilityProduct = {
  __typename?: 'FacilityProduct';
  averageQuantity?: Maybe<Scalars['Int']>;
  chemicalAmounts?: Maybe<Array<FacilityProductChemicalAmounts>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  daysOnSite?: Maybe<Scalars['Int']>;
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  issues: Array<Issue>;
  maxQuantity?: Maybe<Scalars['Int']>;
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
  storageLocations?: Maybe<Array<FacilityProductStorageLocation>>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityProductChemicalAmounts = {
  __typename?: 'FacilityProductChemicalAmounts';
  averageAmount?: Maybe<Scalars['Float']>;
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  maxAmount?: Maybe<Scalars['Float']>;
  unit?: Maybe<UnitType>;
};

export type FacilityProductInput = {
  averageQuantity?: InputMaybe<Scalars['Int']>;
  daysOnSite?: InputMaybe<Scalars['Int']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  hasConfidentialStorageLocations?: InputMaybe<Scalars['Boolean']>;
  maxQuantity?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  storageLocations: Array<FacilityProductStorageLocationInput>;
};

export type FacilityProductMeasurement = {
  __typename?: 'FacilityProductMeasurement';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  issues: Array<Issue>;
  measuredAtUtc: Scalars['Date'];
  product?: Maybe<Product>;
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityProductMeasurementInput = {
  facilityId: Scalars['ID'];
  measuredAtUtc?: InputMaybe<Scalars['Date']>;
  productId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Float']>;
  storageLocation?: InputMaybe<StorageLocationInput>;
  storageLocationId?: InputMaybe<Scalars['ID']>;
};

export type FacilityProductMeasurementsResult = {
  __typename?: 'FacilityProductMeasurementsResult';
  count: Scalars['Int'];
  items: Array<FacilityProductMeasurement>;
};

export type FacilityProductStorageLocation = {
  __typename?: 'FacilityProductStorageLocation';
  facilityProduct?: Maybe<FacilityProduct>;
  facilityProductId: Scalars['ID'];
  id: Scalars['ID'];
  maxQuantity?: Maybe<Scalars['Int']>;
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
};

export type FacilityProductStorageLocationInput = {
  id: Scalars['ID'];
  maxQuantity?: InputMaybe<Scalars['Int']>;
  storageLocation: StorageLocationInput;
};

export type FacilityProductsResult = {
  __typename?: 'FacilityProductsResult';
  count: Scalars['Int'];
  items: Array<FacilityProduct>;
};

export type FacilityRegulatoryStatus = {
  __typename?: 'FacilityRegulatoryStatus';
  eManifestHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus;
  rcraInfo: RcraInfoFederalWasteGeneratorStatus;
  rcraInfoHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus;
  vendorHighestStatusThisYear: RcraInfoFederalWasteGeneratorStatus;
};

export type FacilityStateFieldsInput = {
  facilityId: Scalars['ID'];
  jurisdictions?: InputMaybe<Array<Scalars['String']>>;
};

export enum FacilityStatus {
  Closed = 'CLOSED',
  Inactive = 'INACTIVE',
  Open = 'OPEN',
  Planned = 'PLANNED'
}

export type FacilitySubmission = {
  __typename?: 'FacilitySubmission';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility: Facility;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  submission: Submission;
  submissionId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type FacilityTagUpdate = {
  facilityId: Scalars['ID'];
  tagNames: Array<Scalars['String']>;
};

export type FacilityTierIiReport = {
  __typename?: 'FacilityTierIIReport';
  assignees: Array<TierIiReportAssignee>;
  city?: Maybe<Scalars['String']>;
  colocationReportingFacilityId?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  encampStatus?: Maybe<TierIiReportEncampStatus>;
  encampStatusAnnual?: Maybe<TierIiReportEncampStatus>;
  facilityDateClosed?: Maybe<Scalars['Date']>;
  facilityDateInactive?: Maybe<Scalars['Date']>;
  facilityId: Scalars['ID'];
  facilityName?: Maybe<Scalars['String']>;
  filedOn?: Maybe<Scalars['DateTime']>;
  hasOpenInitial?: Maybe<Scalars['Boolean']>;
  hasOpenRevision?: Maybe<Scalars['Boolean']>;
  hasVerifiedInitial?: Maybe<Scalars['Boolean']>;
  hasVerifiedRevision?: Maybe<Scalars['Boolean']>;
  isClosed?: Maybe<Scalars['Boolean']>;
  isInactive?: Maybe<Scalars['Boolean']>;
  isNotReporting?: Maybe<Scalars['Boolean']>;
  isNotReportingThroughEncamp?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  notReportingReason?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  organizationStatus?: Maybe<TierIiReportOrgStatus>;
  organizationStatusAnnual?: Maybe<TierIiReportOrgStatus>;
  productCount?: Maybe<Scalars['Int']>;
  reportCreatedAt?: Maybe<Scalars['DateTime']>;
  reportCreatedBy?: Maybe<Scalars['String']>;
  reportCreatedByUser?: Maybe<User>;
  reportKind?: Maybe<TierIiReportKind>;
  reportUpdatedAt?: Maybe<Scalars['DateTime']>;
  reportUpdatedBy?: Maybe<Scalars['String']>;
  reportUpdatedByUser?: Maybe<User>;
  reportingYear: Scalars['Int'];
  reviewers: Array<TierIiReportAssignee>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  tierIIReportId?: Maybe<Scalars['ID']>;
  viewId: Scalars['String'];
  zip?: Maybe<Scalars['String']>;
};

export type FacilityTierIiReportsResult = {
  __typename?: 'FacilityTierIIReportsResult';
  count: Scalars['Int'];
  items: Array<FacilityTierIiReport>;
};

export enum FacilityTypeCode {
  Corporation = 'CORPORATION',
  CountyGovernment = 'COUNTY_GOVERNMENT',
  District = 'DISTRICT',
  FederalFacility = 'FEDERAL_FACILITY',
  GovernmentOwnedContractorOperated = 'GOVERNMENT_OWNED_CONTRACTOR_OPERATED',
  Individual = 'INDIVIDUAL',
  MixedOwnership = 'MIXED_OWNERSHIP',
  Municipality = 'MUNICIPALITY',
  MunicipalOrWaterDistrict = 'MUNICIPAL_OR_WATER_DISTRICT',
  NonGovernment = 'NON_GOVERNMENT',
  PrivatelyOwnedFacility = 'PRIVATELY_OWNED_FACILITY',
  SchoolDistrict = 'SCHOOL_DISTRICT',
  StateGovernment = 'STATE_GOVERNMENT',
  TribalGovernment = 'TRIBAL_GOVERNMENT',
  Unknown = 'UNKNOWN'
}

export enum FacilityTypeIndicator {
  FederalFacility = 'FEDERAL_FACILITY',
  NonPubliclyOwnedTreatmentWorks = 'NON_PUBLICLY_OWNED_TREATMENT_WORKS',
  PubliclyOwnedTreatmentWorks = 'PUBLICLY_OWNED_TREATMENT_WORKS'
}

export type FacilityUsage = {
  __typename?: 'FacilityUsage';
  facilityCount: Scalars['Int'];
  items: Array<FacilityUsageItem>;
  tenantCount: Scalars['Int'];
  thisYearFacilityCount: Scalars['Int'];
};

export type FacilityUsageItem = {
  __typename?: 'FacilityUsageItem';
  id: Scalars['ID'];
  name: Scalars['String'];
  reportingYears: Array<Scalars['Int']>;
  tenant: Tenant;
};

export type FacilityWasteByMonth = {
  __typename?: 'FacilityWasteByMonth';
  calculatedFederalGeneratorStatus?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  calculatedStateGeneratorStatus?: Maybe<StateRegulatoryStatus>;
  eManifestAcutelyHazardousAmount: Scalars['Float'];
  eManifestHazardousAmount: Scalars['Float'];
  eManifestNonhazardousAmount: Scalars['Float'];
  eManifestStateRegulatedAmount: Scalars['Float'];
  isOverReportedThreshold: Scalars['Boolean'];
  month: Scalars['Date'];
  reportedFederalGeneratorStatus?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  reportedStateGeneratorStatus?: Maybe<StateRegulatoryStatus>;
  unifiedAcutelyHazardousAmount: Scalars['Float'];
  unifiedHazardousAmount: Scalars['Float'];
  unifiedNonhazardousAmount: Scalars['Float'];
  unifiedStateRegulatedAmount: Scalars['Float'];
  vendorAcutelyHazardousAmount: Scalars['Float'];
  vendorHazardousAmount: Scalars['Float'];
  vendorNonhazardousAmount: Scalars['Float'];
  vendorStateRegulatedAmount: Scalars['Float'];
};

export type FacilityWasteShipmentChartsOutput = {
  __typename?: 'FacilityWasteShipmentChartsOutput';
  highestGeneratingWasteStreams: Array<HighestGeneratingWasteStream>;
  wasteShipmentsByMonth: AllWasteShipmentsByMonth;
};

export type FacilityWasteShipmentsFilter = {
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  view: FacilityWasteView;
};

export type FacilityWasteStream = {
  __typename?: 'FacilityWasteStream';
  classification?: Maybe<WasteClassificationLegacy>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  dotDescription?: Maybe<Scalars['String']>;
  facilityId: Scalars['ID'];
  facilityWasteStreamYearToDates?: Maybe<Array<FacilityWasteStreamYearToDate>>;
  federalWasteCodes?: Maybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  stateWasteCodes?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  wasteStreamHashKey?: Maybe<Scalars['String']>;
};

export type FacilityWasteStreamResult = {
  __typename?: 'FacilityWasteStreamResult';
  count: Scalars['Int'];
  items: Array<FacilityWasteStream>;
};

export type FacilityWasteStreamYearToDate = {
  __typename?: 'FacilityWasteStreamYearToDate';
  finalDestinations?: Maybe<Array<Scalars['String']>>;
  managementMethodCodes?: Maybe<Array<Scalars['String']>>;
  shipments?: Maybe<Scalars['Float']>;
};

export enum FacilityWasteView {
  All = 'ALL',
  NotReportable = 'NOT_REPORTABLE',
  Reportable = 'REPORTABLE'
}

export enum FeatureFlagOverride {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  InheritLdFlagForTenant = 'INHERIT_LD_FLAG_FOR_TENANT'
}

export type FileFormatsByDocumentType = {
  __typename?: 'FileFormatsByDocumentType';
  documentType: DocumentType;
  fileFormats: Array<Scalars['String']>;
};

export type FireDepartment = {
  __typename?: 'FireDepartment';
  additionalComments?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  deactivated: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  fireDeptId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEmailed?: Maybe<Scalars['Boolean']>;
  isMailed?: Maybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: Maybe<Scalars['Boolean']>;
  issues?: Maybe<Array<Issue>>;
  lastName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  mailingAddress?: Maybe<Scalars['String']>;
  mailingAddressLine2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  needsT2sFile?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  phoneExt?: Maybe<Scalars['String']>;
  portalId?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  preferUncertified: Scalars['Boolean'];
  state?: Maybe<Scalars['String']>;
  stateSubmitsToFireDept?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type FireDepartmentInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isEmailed?: InputMaybe<Scalars['Boolean']>;
  isMailed?: InputMaybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  needsT2sFile?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneExt?: InputMaybe<Scalars['String']>;
  portalId?: InputMaybe<Scalars['String']>;
  portalName?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateSubmitsToFireDept?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type FireDepartmentResult = {
  __typename?: 'FireDepartmentResult';
  count: Scalars['Int'];
  items: Array<FireDepartment>;
};

export enum Frequency {
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type GenerateCombinedPdfFromDocumentsInput = {
  documentIds: Array<Scalars['ID']>;
};

export type GenerateInsightsCandidatesInput = {
  queryConfiguration?: InputMaybe<QueryConfiguration>;
  tenantId: Scalars['String'];
};

export type GeneratePresignedUrlResult = {
  __typename?: 'GeneratePresignedUrlResult';
  key: Scalars['String'];
  presignedUrl: Scalars['String'];
};

export type GenerateTierIiPdfPreviewResult = {
  __typename?: 'GenerateTierIIPdfPreviewResult';
  jobId: Scalars['String'];
  s3Key: Scalars['String'];
};

export type GeneratorStatusChanges = {
  __typename?: 'GeneratorStatusChanges';
  month: Scalars['Date'];
  reportedFederalGeneratorStatus?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  reportedStateGeneratorStatus?: Maybe<StateRegulatoryStatus>;
};

export type GeneratorStatusChangesResult = {
  __typename?: 'GeneratorStatusChangesResult';
  changeCount: Scalars['Int'];
  changes: Array<GeneratorStatusChanges>;
};

export type GeneratorStatusSummary = {
  __typename?: 'GeneratorStatusSummary';
  belowThreshold: Array<GeneratorStatusSummaryItem>;
  currentlyReportedStatus: CurrentlyReportedStatus;
  exceedances: Array<GeneratorStatusSummaryItem>;
  statusChanges: GeneratorStatusChangesResult;
};

export type GeneratorStatusSummaryItem = {
  __typename?: 'GeneratorStatusSummaryItem';
  calculatedFederalGeneratorStatus?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  month: Scalars['Date'];
  reportedFederalGeneratorStatus?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
};

export type GroupedFireDepartmentsResult = {
  __typename?: 'GroupedFireDepartmentsResult';
  primary: Array<FireDepartment>;
  primaryCount: Scalars['Int'];
  supplemental: Array<FireDepartment>;
  supplementalCount: Scalars['Int'];
};

export type GroupedLepcsResult = {
  __typename?: 'GroupedLepcsResult';
  primary: Array<Lepc>;
  primaryCount: Scalars['Int'];
  supplemental: Array<Lepc>;
  supplementalCount: Scalars['Int'];
};

export type HasIssuesReason = {
  __typename?: 'HasIssuesReason';
  eManifestValue?: Maybe<Scalars['String']>;
  field: Scalars['String'];
  vendorManifestValue?: Maybe<Scalars['String']>;
};

export type HazardousWasteByMonth = {
  __typename?: 'HazardousWasteByMonth';
  acutelyHazardous: Scalars['Float'];
  hazardous: Scalars['Float'];
  month: Scalars['Date'];
};

export type HazardousWasteShipmentsByFacility = {
  __typename?: 'HazardousWasteShipmentsByFacility';
  byMonth: Array<HazardousWasteByMonth>;
  highestAcutelyHazardousMonths: Array<Scalars['String']>;
  highestHazardousMonths: Array<Scalars['String']>;
  highestWasteMonths: Array<Scalars['String']>;
  totalAcutelyHazardousAmount: Scalars['Float'];
  totalAmount: Scalars['Float'];
  totalHazardousAmount: Scalars['Float'];
};

export type HdHandler = {
  __typename?: 'HdHandler';
  accessibility?: Maybe<RcraInfoAccessibility>;
  acknowledgeDate?: Maybe<Scalars['DateTime']>;
  acknowledgeFlag?: Maybe<Scalars['Boolean']>;
  activityLocation: Scalars['String'];
  brExempt?: Maybe<Scalars['String']>;
  cdxTransactionId?: Maybe<Scalars['String']>;
  contactCity?: Maybe<Scalars['String']>;
  contactCountry?: Maybe<Scalars['String']>;
  contactEmailAddress?: Maybe<Scalars['String']>;
  contactFax?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLanguage?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactMiddleInitial?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactPhoneExt?: Maybe<Scalars['String']>;
  contactState?: Maybe<Scalars['String']>;
  contactStreet1?: Maybe<Scalars['String']>;
  contactStreet2?: Maybe<Scalars['String']>;
  contactStreetNo?: Maybe<Scalars['String']>;
  contactTitle?: Maybe<Scalars['String']>;
  contactZip?: Maybe<Scalars['String']>;
  countyCode?: Maybe<Scalars['String']>;
  createdByUserId?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  currentRecord?: Maybe<Scalars['Boolean']>;
  dataOrigin?: Maybe<RcraInfoDataOrigin>;
  fedWasteGenerator?: Maybe<RcraInfoFederalWasteGeneratorStatus>;
  fedWasteGeneratorOwner?: Maybe<Scalars['String']>;
  furnaceExemption?: Maybe<Scalars['Boolean']>;
  handlerId: Scalars['String'];
  handlerName?: Maybe<Scalars['String']>;
  hdOwnerOperators: Array<HdOwnerOperator>;
  importerActivity?: Maybe<Scalars['Boolean']>;
  includeInNationalReport?: Maybe<Scalars['Boolean']>;
  landType?: Maybe<RcraInfoLandType>;
  lastChange?: Maybe<Scalars['String']>;
  locationCity?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationGisOrigin?: Maybe<Scalars['String']>;
  locationGisPrimary?: Maybe<Scalars['Boolean']>;
  locationLatitude?: Maybe<Scalars['Float']>;
  locationLongitude?: Maybe<Scalars['Float']>;
  locationState?: Maybe<Scalars['String']>;
  locationStreet1?: Maybe<Scalars['String']>;
  locationStreet2?: Maybe<Scalars['String']>;
  locationStreetNo?: Maybe<Scalars['String']>;
  locationZip?: Maybe<Scalars['String']>;
  lqhuw?: Maybe<Scalars['Boolean']>;
  mailCity?: Maybe<Scalars['String']>;
  mailCountry?: Maybe<Scalars['String']>;
  mailState?: Maybe<Scalars['String']>;
  mailStreet1?: Maybe<Scalars['String']>;
  mailStreet2?: Maybe<Scalars['String']>;
  mailStreetNo?: Maybe<Scalars['String']>;
  mailZip?: Maybe<Scalars['String']>;
  manifestBroker?: Maybe<Scalars['Boolean']>;
  mixedWasteGenerator?: Maybe<Scalars['Boolean']>;
  nonNotifier?: Maybe<RcraInfoNonNotifier>;
  notes?: Maybe<Scalars['String']>;
  offSiteReceipt?: Maybe<Scalars['Boolean']>;
  onsiteBurnerExemption?: Maybe<Scalars['Boolean']>;
  operatorName?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  receiveDate?: Maybe<Scalars['DateTime']>;
  recognizedTraderExporter?: Maybe<Scalars['Boolean']>;
  recognizedTraderImporter?: Maybe<Scalars['Boolean']>;
  recyclerActivity?: Maybe<Scalars['Boolean']>;
  recyclerActivityNonstorage?: Maybe<Scalars['Boolean']>;
  reportCycle?: Maybe<Scalars['String']>;
  seqNumber: Scalars['Int'];
  shortTermGenerator?: Maybe<Scalars['Boolean']>;
  shortTermGeneratorNotes?: Maybe<Scalars['String']>;
  slabExporter?: Maybe<Scalars['Boolean']>;
  slabImporter?: Maybe<Scalars['Boolean']>;
  sourceType: RcraInfoSourceType;
  stateDistrict?: Maybe<Scalars['String']>;
  stateDistrictOwner?: Maybe<Scalars['String']>;
  stateWasteGenerator?: Maybe<Scalars['String']>;
  stateWasteGeneratorOwner?: Maybe<Scalars['String']>;
  subpartKCollege?: Maybe<Scalars['Boolean']>;
  subpartKHospital?: Maybe<Scalars['Boolean']>;
  subpartKNonprofit?: Maybe<Scalars['Boolean']>;
  subpartKWithdrawal?: Maybe<Scalars['Boolean']>;
  subpartPHealthcare?: Maybe<Scalars['Boolean']>;
  subpartPReverseDistributor?: Maybe<Scalars['Boolean']>;
  subpartPWithdrawal?: Maybe<Scalars['Boolean']>;
  transferFacility?: Maybe<Scalars['Boolean']>;
  transporter?: Maybe<Scalars['Boolean']>;
  tsdActivity?: Maybe<Scalars['Boolean']>;
  undergroundInjectionActivity?: Maybe<Scalars['Boolean']>;
  universalWasteDestFacility?: Maybe<Scalars['Boolean']>;
  usedOilBurner?: Maybe<Scalars['Boolean']>;
  usedOilMarketBurner?: Maybe<Scalars['Boolean']>;
  usedOilProcessor?: Maybe<Scalars['Boolean']>;
  usedOilRefiner?: Maybe<Scalars['Boolean']>;
  usedOilSpecMarketer?: Maybe<Scalars['Boolean']>;
  usedOilTransferFacility?: Maybe<Scalars['Boolean']>;
  usedOilTransporter?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type HdHandlerResult = {
  __typename?: 'HdHandlerResult';
  count: Scalars['Int'];
  items: Array<HdHandler>;
};

export type HdOwnerOperator = {
  __typename?: 'HdOwnerOperator';
  activityLocation: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dateBecameCurrent?: Maybe<Scalars['DateTime']>;
  dateEndedCurrent?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  handlerId: Scalars['String'];
  ownerOperatorIndicator?: Maybe<RcraInfoOwnerOperatorIndicator>;
  ownerOperatorName?: Maybe<Scalars['String']>;
  ownerOperatorSeq: Scalars['Int'];
  ownerOperatorType?: Maybe<RcraInfoLandType>;
  phone?: Maybe<Scalars['String']>;
  phoneExt?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  seqNumber: Scalars['Int'];
  sourceType: RcraInfoSourceType;
  state?: Maybe<Scalars['String']>;
  street1?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetNo?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export enum HealthHazard {
  AcuteToxicity = 'ACUTE_TOXICITY',
  AspirationHazard = 'ASPIRATION_HAZARD',
  Carcinogenic = 'CARCINOGENIC',
  CausesRespiratoryOrSkinSensitization = 'CAUSES_RESPIRATORY_OR_SKIN_SENSITIZATION',
  EyeIrritant = 'EYE_IRRITANT',
  GermCellMutagenic = 'GERM_CELL_MUTAGENIC',
  HazardNotOtherwiseClassifiedHealth = 'HAZARD_NOT_OTHERWISE_CLASSIFIED_HEALTH',
  ReproductiveToxicity = 'REPRODUCTIVE_TOXICITY',
  SimpleAsphyxiant = 'SIMPLE_ASPHYXIANT',
  SkinIrritant = 'SKIN_IRRITANT',
  SpecificTargetOrganToxicity = 'SPECIFIC_TARGET_ORGAN_TOXICITY'
}

export type HighestGeneratingWasteStream = {
  __typename?: 'HighestGeneratingWasteStream';
  amount: Scalars['Float'];
  wasteStream: WasteStream;
};

export enum InsideOutside {
  Inside = 'INSIDE',
  Outside = 'OUTSIDE'
}

export type InsightsCandidate = {
  __typename?: 'InsightsCandidate';
  echoExporter: SelectedEchoExporterFields;
  facility: Facility;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  job: Job;
  jobId: Scalars['String'];
  matchScore?: Maybe<Scalars['Float']>;
  registryId: Scalars['String'];
  tenant: Tenant;
  tenantId: Scalars['String'];
};

export type InsightsCandidatesResult = {
  __typename?: 'InsightsCandidatesResult';
  count: Scalars['Int'];
  items: Array<InsightsCandidate>;
};

export type InsightsCohort = {
  __typename?: 'InsightsCohort';
  domainSearches: Array<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  nameSearches: Array<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type InsightsEchoAllFacilitiesResult = {
  __typename?: 'InsightsEchoAllFacilitiesResult';
  count: Scalars['Int'];
  items: Array<EchoExporterAggregated>;
};

export type InsightsEchoFacilitiesResult = {
  __typename?: 'InsightsEchoFacilitiesResult';
  count: Scalars['Int'];
  items: Array<FacilityEchoExporter>;
};

export type InsightsFacilityMix = {
  __typename?: 'InsightsFacilityMix';
  connectedFacilitiesCount: Scalars['Int'];
  facilitiesCount: Scalars['Int'];
  facilitiesWithMultiplePrograms: Scalars['Int'];
  facilityNaicsTypes: Array<InsightsFacilityNaicsType>;
  filteredFacilitiesCount: Scalars['Int'];
  hasNoGovtIdCount: Scalars['Int'];
  programAreas: Array<InsightsFacilityProgramArea>;
};

export type InsightsFacilityNaicsType = {
  __typename?: 'InsightsFacilityNaicsType';
  count: Scalars['Int'];
  naicsCode: Scalars['String'];
  name: Scalars['String'];
};

export type InsightsFacilityProgramArea = {
  __typename?: 'InsightsFacilityProgramArea';
  count: Scalars['Int'];
  key: Scalars['String'];
};

export type InsightsFilter = {
  naicsCode?: InputMaybe<Scalars['String']>;
  programArea?: InputMaybe<Scalars['String']>;
};

export type InsightsNonCompliance = {
  __typename?: 'InsightsNonCompliance';
  byProgramArea: Array<CountStat>;
  quarterlyByProgramArea: Array<QuarterlyStat>;
  quarterlyBySignificance: Array<QuarterlyStat>;
  violationsByFacility: Array<CountStat>;
};

export type InsightsPenalties = {
  __typename?: 'InsightsPenalties';
  averageCostPerViolation: Scalars['Float'];
  averagePenalties: Scalars['Float'];
  byFacility: Array<InsightsPenalty>;
  byProgramArea: Array<InsightsPenalty>;
  byQuarter: Array<InsightsPenalty>;
  byQuarterByProgramArea: Array<InsightsPenaltyQuarter>;
  totalPenalties: Scalars['Float'];
};

export type InsightsPenalty = {
  __typename?: 'InsightsPenalty';
  cost: Scalars['Float'];
  frsId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export type InsightsPenaltyQuarter = {
  __typename?: 'InsightsPenaltyQuarter';
  programAreas: Array<InsightsPenalty>;
  quarter: Scalars['String'];
};

export type InsightsViolations = {
  __typename?: 'InsightsViolations';
  percentageFacilitiesWithViolation: Scalars['Float'];
  programAreas: Array<Scalars['String']>;
  totalViolations: Scalars['Int'];
  violationsByFacility: Array<InsightsViolationsFacility>;
  violationsByProgramArea: Array<InsightsViolationsProgramArea>;
  violationsByQuarter: Array<InsightsViolationsQuarter>;
};

export type InsightsViolationsFacility = {
  __typename?: 'InsightsViolationsFacility';
  frsId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  totalViolations: Scalars['Int'];
};

export type InsightsViolationsProgramArea = {
  __typename?: 'InsightsViolationsProgramArea';
  name: Scalars['String'];
  totalViolations: Scalars['Int'];
};

export type InsightsViolationsQuarter = {
  __typename?: 'InsightsViolationsQuarter';
  quarter: Scalars['String'];
  violationsByProgramArea: Array<InsightsViolationsProgramArea>;
};

export type InternalTag = {
  __typename?: 'InternalTag';
  facilityCount: Scalars['Int'];
  name: Scalars['String'];
};

export type InternalTagsByNameResult = {
  __typename?: 'InternalTagsByNameResult';
  count: Scalars['Int'];
  items: Array<InternalTag>;
};

export enum InternationalFireCodeHazard {
  Combustible = 'COMBUSTIBLE',
  Corrosive = 'CORROSIVE',
  Explosive = 'EXPLOSIVE',
  Flammable = 'FLAMMABLE',
  HighlyToxic = 'HIGHLY_TOXIC',
  Inert = 'INERT',
  OrganicPeroxides = 'ORGANIC_PEROXIDES',
  Oxidizing = 'OXIDIZING',
  Pyrophoric = 'PYROPHORIC',
  Radioactive = 'RADIOACTIVE',
  Toxic = 'TOXIC',
  Unstable = 'UNSTABLE',
  WaterReactive = 'WATER_REACTIVE'
}

export enum Inventory {
  Chemical = 'CHEMICAL',
  Product = 'PRODUCT'
}

export type InventoryStatusResult = {
  __typename?: 'InventoryStatusResult';
  exists: Scalars['Boolean'];
  mostRecentYear?: Maybe<Scalars['Int']>;
};

export type Issue = {
  __typename?: 'Issue';
  dataName?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['String']>;
  jurisdictions?: Maybe<Array<Scalars['String']>>;
  key?: Maybe<Scalars['String']>;
  level: IssueLevel;
  message: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  modelId?: Maybe<Scalars['String']>;
  modelName: Scalars['String'];
  schemaStack?: Maybe<Array<SchemaSegment>>;
  tenantId?: Maybe<Scalars['String']>;
};

export enum IssueLevel {
  Critical = 'CRITICAL',
  Error = 'ERROR'
}

export type Job = {
  __typename?: 'Job';
  action?: Maybe<WebAutomationAction>;
  communication?: Maybe<Communication>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  document?: Maybe<Document>;
  extraction?: Maybe<Scalars['JSON']>;
  extractionKey?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  insightsCandidates: Array<InsightsCandidate>;
  logs: Array<JobLog>;
  output?: Maybe<Scalars['JSON']>;
  parameters?: Maybe<Scalars['JSON']>;
  payments: Array<Payment>;
  promotedAt?: Maybe<Scalars['DateTime']>;
  /** This is the entire Job record from the database */
  record?: Maybe<Scalars['JSON']>;
  reportId?: Maybe<Scalars['ID']>;
  reportingYear?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['ID']>;
  staffReportDownloadLink?: Maybe<Scalars['String']>;
  staffReportKey?: Maybe<Scalars['String']>;
  stateOrTerritory?: Maybe<Scalars['String']>;
  status: JobStatus;
  stepError?: Maybe<Scalars['String']>;
  stepsDone: Array<JobStepsDone>;
  task?: Maybe<JobTask>;
  taskArn?: Maybe<Scalars['String']>;
  taskUrl?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  totalIssues?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  user?: Maybe<User>;
};

export type JobLog = {
  __typename?: 'JobLog';
  cloudWatchLogStream?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  errorMessage?: Maybe<Scalars['String']>;
  htmlKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['String']>;
  screenshotKey?: Maybe<Scalars['String']>;
  screenshotUrl?: Maybe<Scalars['String']>;
  status: JobStatus;
  taskArn?: Maybe<Scalars['String']>;
  taskDefinitionArn?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type JobLogsResult = {
  __typename?: 'JobLogsResult';
  count: Scalars['Int'];
  items: Array<JobLog>;
};

export enum JobStatus {
  AwaitingManualIntervention = 'AWAITING_MANUAL_INTERVENTION',
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Dispatched = 'DISPATCHED',
  Failed = 'FAILED',
  FailedMayAutoRetry = 'FAILED_MAY_AUTO_RETRY',
  FailedNeedsHuman = 'FAILED_NEEDS_HUMAN',
  FailedProvisioningEcsTask = 'FAILED_PROVISIONING_ECS_TASK',
  FailedQualityControlCheck = 'FAILED_QUALITY_CONTROL_CHECK',
  Promoted = 'PROMOTED',
  /** @deprecated use PROVISIONING_ECS_TASK instead */
  Provisioning = 'PROVISIONING',
  ProvisioningEcsTask = 'PROVISIONING_ECS_TASK',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  /** @deprecated use JobStepDone (SendCheckStepDoneName.SEND_CHECK) instead */
  Sent = 'SENT',
  ShouldCancel = 'SHOULD_CANCEL',
  Succeeded = 'SUCCEEDED'
}

export type JobStepsDone = {
  __typename?: 'JobStepsDone';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  jobId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type JobStepsDoneResult = {
  __typename?: 'JobStepsDoneResult';
  count: Scalars['Int'];
  items: Array<JobStepsDone>;
};

export enum JobTask {
  AddDocument = 'ADD_DOCUMENT',
  AsmarkIngest = 'ASMARK_INGEST',
  BulkResetTierIiReports = 'BULK_RESET_TIER_II_REPORTS',
  BulkSendSubmissionsToReviewers = 'BULK_SEND_SUBMISSIONS_TO_REVIEWERS',
  BulkVerifyAndSubmitReports = 'BULK_VERIFY_AND_SUBMIT_REPORTS',
  ChemicalAggregation = 'CHEMICAL_AGGREGATION',
  CreateSubmissionTasks = 'CREATE_SUBMISSION_TASKS',
  CreateTierIiDeliverables = 'CREATE_TIER_II_DELIVERABLES',
  CreateTierIiDeliverablesLambda = 'CREATE_TIER_II_DELIVERABLES_LAMBDA',
  DatabaseBenchmark = 'DATABASE_BENCHMARK',
  DataPipeline = 'DATA_PIPELINE',
  DemoData = 'DEMO_DATA',
  DocsToSinglePdf = 'DOCS_TO_SINGLE_PDF',
  DocumentAiEnrichment = 'DOCUMENT_AI_ENRICHMENT',
  DownloadMissingBoldsignProofDocuments = 'DOWNLOAD_MISSING_BOLDSIGN_PROOF_DOCUMENTS',
  EmailDigests = 'EMAIL_DIGESTS',
  ErrorClustering = 'ERROR_CLUSTERING',
  ExportData = 'EXPORT_DATA',
  EManifestApi = 'E_MANIFEST_API',
  EManifestSiteAccess = 'E_MANIFEST_SITE_ACCESS',
  FacilityEmbedding = 'FACILITY_EMBEDDING',
  FileExtraction = 'FILE_EXTRACTION',
  GeneratePdf = 'GENERATE_PDF',
  GeneratePdfEcs = 'GENERATE_PDF_ECS',
  InsightsConnector = 'INSIGHTS_CONNECTOR',
  OneSchemaFileUpload = 'ONE_SCHEMA_FILE_UPLOAD',
  Presubmission = 'PRESUBMISSION',
  ProcessManifests = 'PROCESS_MANIFESTS',
  PromoteDraftReport = 'PROMOTE_DRAFT_REPORT',
  SendCheck = 'SEND_CHECK',
  SendEmail = 'SEND_EMAIL',
  SendMail = 'SEND_MAIL',
  SignPdf = 'SIGN_PDF',
  Slack = 'SLACK',
  StaffReport = 'STAFF_REPORT',
  Tier_2Submit = 'TIER_2_SUBMIT',
  ValidateTenant = 'VALIDATE_TENANT',
  WebAutomation = 'WEB_AUTOMATION',
  Zip = 'ZIP'
}

export type JobsResult = {
  __typename?: 'JobsResult';
  count: Scalars['Int'];
  items: Array<Job>;
};

export type LeadAgency = {
  __typename?: 'LeadAgency';
  additionalComments?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  attn: Scalars['String'];
  city: Scalars['String'];
  consolidated: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  lepcs: Array<Lepc>;
  name: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LeadAgencyInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attn: Scalars['String'];
  city: Scalars['String'];
  consolidated: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  phone: Scalars['String'];
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type Lepc = {
  __typename?: 'Lepc';
  additionaRequirements?: Maybe<Scalars['String']>;
  additionalComments?: Maybe<Scalars['String']>;
  additionalFees?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  deactivated: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  feeStructure?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCurrent1AsOf2021?: Maybe<Scalars['Boolean']>;
  isEmailed: Scalars['Boolean'];
  isMailed?: Maybe<Scalars['Boolean']>;
  isStateSubmits?: Maybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues?: Maybe<Array<Issue>>;
  latitude?: Maybe<Scalars['Float']>;
  leadAgency?: Maybe<LeadAgency>;
  leadAgencyId?: Maybe<Scalars['Int']>;
  leadAgencyName?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  mailingAddress?: Maybe<Scalars['String']>;
  mailingAddressLine2?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  needsT2sFile?: Maybe<Scalars['Boolean']>;
  needsXmlZipFile?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  portalId?: Maybe<Scalars['String']>;
  portalName?: Maybe<Scalars['String']>;
  preferUncertified: Scalars['Boolean'];
  requirementDetails?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  submissionNotes?: Maybe<Scalars['String']>;
  t2sValue?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LepcInput = {
  additionaRequirements?: InputMaybe<Scalars['String']>;
  additionalComments?: InputMaybe<Scalars['String']>;
  additionalFees?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  deactivated?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  feeStructure?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isCurrent1AsOf2021?: InputMaybe<Scalars['Boolean']>;
  isEmailed?: InputMaybe<Scalars['Boolean']>;
  isMailed?: InputMaybe<Scalars['Boolean']>;
  isStateSubmits?: InputMaybe<Scalars['Boolean']>;
  isSubmittedViaPortal?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  leadAgencyId?: InputMaybe<Scalars['Int']>;
  leadAgencyName?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Float']>;
  mailingAddress?: InputMaybe<Scalars['String']>;
  mailingAddressLine2?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  needsT2sFile?: InputMaybe<Scalars['Boolean']>;
  needsXmlZipFile?: InputMaybe<Scalars['Boolean']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  portalId?: InputMaybe<Scalars['String']>;
  portalName?: InputMaybe<Scalars['String']>;
  requirementDetails?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  submissionNotes?: InputMaybe<Scalars['String']>;
  t2sValue?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type LepcResult = {
  __typename?: 'LepcResult';
  count?: Maybe<Scalars['Int']>;
  items: Array<Lepc>;
};

export type LinkFacilitiesInput = {
  candidateIds: Array<Scalars['ID']>;
};

export type LobMail = {
  __typename?: 'LobMail';
  id: Scalars['ID'];
  lobId: Scalars['String'];
  lobUrl?: Maybe<Scalars['String']>;
  status?: Maybe<LobMailStatus>;
  type: LobMailType;
};

export enum LobMailStatus {
  Delivered = 'DELIVERED',
  InternationalExit = 'INTERNATIONAL_EXIT',
  InLocalArea = 'IN_LOCAL_AREA',
  InTransit = 'IN_TRANSIT',
  Issue = 'ISSUE',
  Mailed = 'MAILED',
  PickupAvailable = 'PICKUP_AVAILABLE',
  ProcessedForDelivery = 'PROCESSED_FOR_DELIVERY',
  ReturnedToSender = 'RETURNED_TO_SENDER',
  ReRouted = 'RE_ROUTED'
}

export enum LobMailType {
  Check = 'CHECK',
  Letter = 'LETTER'
}

export enum MajorMinorStatusFlag {
  Major = 'MAJOR',
  NonMajor = 'NON_MAJOR'
}

export enum ManageTagsAction {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export type ManifestEditInput = {
  desFacilityName?: InputMaybe<Scalars['String']>;
  manifestTrackingNumber: Scalars['String'];
  shippedDate?: InputMaybe<Scalars['DateTime']>;
  vendorSource?: InputMaybe<Scalars['String']>;
};

export type ManifestEditOrRevertResult = {
  __typename?: 'ManifestEditOrRevertResult';
  newProcessedManifest?: Maybe<ProcessedManifest>;
  originalProcessedManifest?: Maybe<ProcessedManifest>;
};

export type MarkAsReportingResult = {
  __typename?: 'MarkAsReportingResult';
  tierIIReports: Array<TierIiReport>;
};

export type MergeWasteStreamsInput = {
  comment?: InputMaybe<Scalars['String']>;
  internalNote?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  wasteStreamIds: Array<Scalars['ID']>;
};

export type ModelIssue = {
  __typename?: 'ModelIssue';
  dataName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRevalidating: Scalars['Boolean'];
  message: Scalars['String'];
  modelId: Scalars['String'];
  modelName: Scalars['String'];
  propertyKey: Scalars['String'];
  tenantId: Scalars['ID'];
  validatedAt: Scalars['DateTime'];
};

export type Municipality = {
  __typename?: 'Municipality';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type MunicipalityResult = {
  __typename?: 'MunicipalityResult';
  count: Scalars['Int'];
  items: Array<Municipality>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCommentToSubmission: Comment;
  addCommentsToSubmission: Array<Comment>;
  addFacilityAlternateIds: Scalars['Boolean'];
  addPaymentComment: PaymentComment;
  addWorkflowTag: Workflow;
  approveSubmissionDocumentReview: SubmissionDocumentReview;
  bulkResetTierIIReports: BulkResetReportsResult;
  bulkUpdateCohortMemberStatus: Scalars['Boolean'];
  bulkUpdateNotReportingReason?: Maybe<BulkUpdateNotReportingReasonResult>;
  bulkUpdateReconciliationStatus: Array<Payment>;
  bulkUpdateSubmissionsStatus: BulkSubmissionsJobResult;
  bulkVerifyAndSubmitReports: BulkVerifyAndSubmitReportsResult;
  cancelLobCheck: Payment;
  cancelPayment: Payment;
  closeReport?: Maybe<Scalars['Boolean']>;
  completeTierIIReportReviewStep: TierIiReport;
  conductCohort: Scalars['Boolean'];
  conductReport: Scalars['Boolean'];
  copyFacilityChemicals: CopyInventoryResult;
  copyFacilityInventoryForFacilities: BulkCopyInventoryResult;
  copyFacilityProducts: CopyInventoryResult;
  createCommunication: Array<Communication>;
  createDemoOrganization: Scalars['Boolean'];
  createInsightsCohort: InsightsCohort;
  createSubmission: Submission;
  createTask?: Maybe<Scalars['Boolean']>;
  createTierIIReport: TierIiReport;
  createTierIIReports: Array<TierIiReport>;
  createUser: User;
  createUserLogin?: Maybe<UserLogin>;
  createWebAutomationJobs?: Maybe<WebAutomationJobResult>;
  deleteCandidates: Scalars['Boolean'];
  deleteChemical: Chemical;
  deleteChemicalDocument: DeleteChemicalDocumentResult;
  deleteComment: Scalars['Boolean'];
  deleteCredential: Credential;
  deleteDocument: Document;
  deleteFacility: Facility;
  deleteFacilityChemical: FacilityChemical;
  deleteFacilityChemicalMeasurement: FacilityChemicalMeasurement;
  deleteFacilityChemicalMeasurementsByChemicalAndYear?: Maybe<DeleteFacilityChemicalMeasurementsByChemicalAndYearResult>;
  deleteFacilityContact: Scalars['Boolean'];
  deleteFacilityProduct?: Maybe<FacilityProduct>;
  deleteFacilityProductMeasurement: FacilityProductMeasurement;
  deleteFacilityProductMeasurementsByProductAndYear?: Maybe<DeleteFacilityProductMeasurementsByProductAndYearResult>;
  deleteFireDepartment: FireDepartment;
  deleteInsightsCohort: InsightsCohort;
  deleteInternalTag: Scalars['Boolean'];
  deleteLeadAgency: LeadAgency;
  deleteLepc: Lepc;
  deletePaymentComment: PaymentComment;
  deletePerson?: Maybe<Person>;
  deletePoliceDepartment: PoliceDepartment;
  deleteProduct: Product;
  deleteSubmission: Scalars['Boolean'];
  deleteTask?: Maybe<Scalars['Boolean']>;
  deleteVendorManifestAndLineItems: Scalars['Boolean'];
  deleteWasteLineUnifiedVendorData: Scalars['Int'];
  devtoolsResetReport?: Maybe<Scalars['Boolean']>;
  devtoolsResetReportsForTenant: DevtoolsReportsForTenantResult;
  downloadTierIIDeliverables: DownloadTierIiDeliverablesPreview;
  downloadTierIIDeliverablesByReport: DownloadTierIiDeliverablesPreview;
  editVendorManifest: ManifestEditOrRevertResult;
  editWasteLineUnified: WasteLineUnified;
  emailReviewers: EmailReviewersResult;
  emailSpecificReviewer: EmailReviewersResult;
  exemptMailingAddressFromVerification: Scalars['Boolean'];
  exportChemicalFacilitiesGridToCsv: ExportCsvResult;
  exportWorkflowActivitiesToCsv: ExportCsvResult;
  generateCombinedPdfFromDocuments: Job;
  generateInsightsCandidates: Scalars['Boolean'];
  generateInsightsCandidatesFromAlternateIds: InsightsCandidatesResult;
  generatePresignedUrl: GeneratePresignedUrlResult;
  generateStaffReport: Job;
  generateT2S: Scalars['String'];
  generateTierIIPdfPreview: GenerateTierIiPdfPreviewResult;
  importT2sFile: Array<Job>;
  linkFacilities: Scalars['Boolean'];
  manageFacilityTags: Array<Facility>;
  manageTierIIReportsTags: Array<TierIiReport>;
  markAsReporting: MarkAsReportingResult;
  mergeChemicals?: Maybe<Chemical>;
  mergePeople?: Maybe<Person>;
  mergeWasteStreams: Scalars['ID'];
  moveToReview: Submission;
  processOneschemaFileUpload: ProcessOneschemaFileUploadResult;
  promoteDraftReport?: Maybe<Scalars['Boolean']>;
  queueDocumentAIEnrichmentJob: DocumentAiEnrichmentJob;
  queueErrorClusteringJob: Job;
  queueSdsParsingJobs: Array<Job>;
  reconcilePayment: Payment;
  rejectSubmissionDocumentReview: SubmissionDocumentReview;
  removeDocumentFromActivity: ActivityDocument;
  removeDocumentFromReport: Scalars['Boolean'];
  removeTierIIReportAssignees: Array<TierIiReport>;
  removeTierIIReportReviewers: Array<TierIiReport>;
  removeUndergroundStorageTank: UndergroundStorageTank;
  removeWorkflowTag: Workflow;
  replacePersonFacilityAssociations?: Maybe<Scalars['Boolean']>;
  replaceReportDocumentsByType: Array<Document>;
  requeueActivities: RequeueActivitiesResult;
  requeueCommunication: Communication;
  requirementsOptInOptOut: RequirementsOptInOptOutResult;
  resendInvitationToUser: Scalars['Boolean'];
  resetEmulatedRole: Scalars['Boolean'];
  resetReport: Scalars['ID'];
  revertVendorManifestAndLineItems: ManifestEditOrRevertResult;
  sendLobCheck: Payment;
  sendSubmissionsToReviewers: BulkSubmissionsJobResult;
  setChemicalFlagForFacilities: SetChemicalFlagResult;
  setCollectionMode?: Maybe<SetCollectionModeResult>;
  setEmulatedRole: Scalars['Boolean'];
  setInReviewStatus: TierIiReport;
  setIsAlwaysReportedOnReportingFacilityChemical: ReportingFacilityChemical;
  setReviewComplete: TierIiReport;
  setSubmissionAssignees: BulkSubmissionsResult;
  setTierIIReportAssignees: Array<TierIiReport>;
  setTierIIReportReviewers: Array<TierIiReport>;
  setUserTenant: Scalars['Boolean'];
  setValueOnActivityUserInput: ActivityUserInput;
  setWasteFlagForFacilities: SetWasteFlagResult;
  splitChemical: Array<Chemical>;
  splitCohort: SplitCohortResult;
  splitPerson: Array<Person>;
  touchTierIIReportCAStep: Scalars['Boolean'];
  touchTierIIReportStep: Scalars['Boolean'];
  touchTierIIReportUstStep: Scalars['Boolean'];
  unmergeWasteStreams: Scalars['Boolean'];
  untouchTierIIReportCAStep: Scalars['Boolean'];
  unverifyChemical?: Maybe<Scalars['Boolean']>;
  unverifyChemicals?: Maybe<Scalars['Boolean']>;
  updateActivities: UpdateActivitiesResult;
  updateActivity: Activity;
  updateActivityAssignees: UpdateActivityAssigneesResult;
  updateCohortActivity: Activity;
  updateCommunication: Communication;
  updateFacilities: Array<Facility>;
  updateFacilitiesForInternalTag: Scalars['Boolean'];
  updateFacility?: Maybe<Facility>;
  updateFacilityStateFields: Facility;
  updateInsightsCohort: InsightsCohort;
  updateNotesToRegulators: TierIiReport;
  updateReasonForReport: TierIiReport;
  updateReconciliationStatus: Payment;
  updateRequiresReviewers: TierIiReport;
  updateSubmission: Submission;
  updateSubmissionStatus: Submission;
  updateTaskRecurring?: Maybe<VirtualEvent>;
  updateTaskSingle?: Maybe<VirtualEvent>;
  updateTierIIReportTags: TierIiReportTagsResult;
  updateTierIIReportVerifier: TierIiReport;
  updateUser: User;
  updateWasteLineUnifiedTags: Scalars['Boolean'];
  updateWasteStream: Scalars['ID'];
  updateWebAutomationJobs?: Maybe<WebAutomationJobResult>;
  updateWorkflowTags: Workflow;
  updateWorkflowTagsBulk: Array<Workflow>;
  upsertChemical: Chemical;
  upsertComment: Comment;
  upsertCredential: Credential;
  upsertDocument: Document;
  upsertDocuments: Array<Document>;
  upsertFacilityChemical: FacilityChemical;
  upsertFacilityChemicalMeasurement?: Maybe<FacilityChemicalMeasurement>;
  upsertFacilityChemicalStateField?: Maybe<FacilityChemicalStateField>;
  upsertFacilityChemicalStateFields?: Maybe<Array<Maybe<FacilityChemicalStateField>>>;
  upsertFacilityContact?: Maybe<FacilityContact>;
  upsertFacilityProduct: FacilityProduct;
  upsertFacilityProductMeasurement?: Maybe<FacilityProductMeasurement>;
  upsertFireDepartment: FireDepartment;
  upsertInternalTag: Scalars['Boolean'];
  upsertLeadAgency: LeadAgency;
  upsertLepc: Lepc;
  upsertPayment: Payment;
  upsertPerson: Person;
  upsertPoliceDepartment: PoliceDepartment;
  upsertProduct: Product;
  upsertTenant: Tenant;
  upsertUndergroundStorageTank: UndergroundStorageTank;
  upsertUserFacilitiesForTenant: UpsertUserFacilitiesForTenantResult;
  verifyChemical?: Maybe<Chemical>;
  verifyChemicals?: Maybe<Scalars['Boolean']>;
  verifyCredential: VerifyCredentialResult;
  verifyCredentials: VerifyCredentialsResult;
  wasteLinesUnifiedBulkUpdateWillNotReport: Scalars['Int'];
  workflowManagerScheduleEvent: Scalars['Boolean'];
};


export type MutationAddCommentToSubmissionArgs = {
  comment: CommentInput;
  submissionId: Scalars['ID'];
};


export type MutationAddCommentsToSubmissionArgs = {
  comments: Array<CommentInput>;
  submissionId: Scalars['ID'];
};


export type MutationAddFacilityAlternateIdsArgs = {
  alternateIds: Array<AlternateIdInput>;
  facilityId: Scalars['ID'];
};


export type MutationAddPaymentCommentArgs = {
  input: PaymentCommentInput;
};


export type MutationAddWorkflowTagArgs = {
  tagName: Scalars['String'];
  workflowId: Scalars['ID'];
};


export type MutationApproveSubmissionDocumentReviewArgs = {
  submissionDocumentReviewId: Scalars['ID'];
};


export type MutationBulkResetTierIiReportsArgs = {
  input: BulkResetReportInput;
};


export type MutationBulkUpdateCohortMemberStatusArgs = {
  cohortId: Scalars['ID'];
  cohortMemberIds: Array<Scalars['ID']>;
  status: CohortMemberStatus;
};


export type MutationBulkUpdateNotReportingReasonArgs = {
  input: NotReportingReasonInput;
};


export type MutationBulkUpdateReconciliationStatusArgs = {
  input: BulkUpdateReconciliationStatusInput;
};


export type MutationBulkUpdateSubmissionsStatusArgs = {
  input: BulkUpdateSubmissionsStatusInput;
};


export type MutationBulkVerifyAndSubmitReportsArgs = {
  reportIds: Array<Scalars['ID']>;
  verifier: TierIiReportVerifierInput;
};


export type MutationCancelLobCheckArgs = {
  id: Scalars['ID'];
};


export type MutationCancelPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationCloseReportArgs = {
  tierIIReportId: Scalars['ID'];
};


export type MutationCompleteTierIiReportReviewStepArgs = {
  reportId: Scalars['ID'];
};


export type MutationConductCohortArgs = {
  cohortId: Scalars['ID'];
};


export type MutationConductReportArgs = {
  reportId: Scalars['ID'];
};


export type MutationCopyFacilityChemicalsArgs = {
  facilityId: Scalars['ID'];
  fromYear?: InputMaybe<Scalars['Int']>;
  toYear: Scalars['Int'];
};


export type MutationCopyFacilityInventoryForFacilitiesArgs = {
  facilityIds: Array<Scalars['ID']>;
  toYear: Scalars['Int'];
};


export type MutationCopyFacilityProductsArgs = {
  facilityId: Scalars['ID'];
  fromYear?: InputMaybe<Scalars['Int']>;
  toYear: Scalars['Int'];
};


export type MutationCreateCommunicationArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  input: CreateCommunicationInput;
};


export type MutationCreateDemoOrganizationArgs = {
  input: DemoOrganizationInput;
};


export type MutationCreateInsightsCohortArgs = {
  domainSearches?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  nameSearches?: InputMaybe<Array<Scalars['String']>>;
  tenantId: Scalars['String'];
};


export type MutationCreateSubmissionArgs = {
  input: CreateSubmissionInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTierIiReportArgs = {
  facilityId: Scalars['ID'];
  reasonForReport?: InputMaybe<Scalars['String']>;
  reportKind: TierIiReportKind;
  reportingYear: Scalars['Int'];
};


export type MutationCreateTierIiReportsArgs = {
  facilityIds: Array<Scalars['ID']>;
  reportKind: TierIiReportKind;
  reportingYear: Scalars['Int'];
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserLoginArgs = {
  userId: Scalars['ID'];
};


export type MutationCreateWebAutomationJobsArgs = {
  input: Array<CreateWebAutomationJobInput>;
};


export type MutationDeleteCandidatesArgs = {
  input: DeleteCandidatesInput;
};


export type MutationDeleteChemicalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteChemicalDocumentArgs = {
  input: DeleteChemicalDocumentInput;
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCredentialArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID'];
  retainAsset?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteFacilityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityChemicalArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityChemicalMeasurementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityChemicalMeasurementsByChemicalAndYearArgs = {
  addZeroMeasurement?: InputMaybe<Scalars['Boolean']>;
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type MutationDeleteFacilityContactArgs = {
  facilityContactId: Scalars['ID'];
};


export type MutationDeleteFacilityProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityProductMeasurementArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFacilityProductMeasurementsByProductAndYearArgs = {
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type MutationDeleteFireDepartmentArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteInsightsCohortArgs = {
  id: Scalars['String'];
};


export type MutationDeleteInternalTagArgs = {
  tagName: Scalars['String'];
};


export type MutationDeleteLeadAgencyArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteLepcArgs = {
  id: Scalars['String'];
};


export type MutationDeletePaymentCommentArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePersonArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePoliceDepartmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationDeleteProductArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteSubmissionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTaskArgs = {
  input: EventMutationInput;
};


export type MutationDeleteVendorManifestAndLineItemsArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteWasteLineUnifiedVendorDataArgs = {
  id: Scalars['String'];
};


export type MutationDevtoolsResetReportArgs = {
  id: Scalars['ID'];
};


export type MutationDevtoolsResetReportsForTenantArgs = {
  input: DevtoolsReportsForTenantInput;
};


export type MutationDownloadTierIiDeliverablesArgs = {
  reportingYear?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['ID'];
};


export type MutationDownloadTierIiDeliverablesByReportArgs = {
  reportId: Scalars['ID'];
};


export type MutationEditVendorManifestArgs = {
  id: Scalars['ID'];
  input: ManifestEditInput;
};


export type MutationEditWasteLineUnifiedArgs = {
  id: Scalars['String'];
  input: WasteLineUnifiedInput;
  shippedDate: Scalars['DateTime'];
};


export type MutationEmailReviewersArgs = {
  reportId: Scalars['ID'];
};


export type MutationEmailSpecificReviewerArgs = {
  personId: Scalars['ID'];
  reportId: Scalars['ID'];
};


export type MutationExemptMailingAddressFromVerificationArgs = {
  input: ExemptMailingAddressFromVerificationInput;
};


export type MutationExportChemicalFacilitiesGridToCsvArgs = {
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type MutationExportWorkflowActivitiesToCsvArgs = {
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type MutationGenerateCombinedPdfFromDocumentsArgs = {
  input: GenerateCombinedPdfFromDocumentsInput;
};


export type MutationGenerateInsightsCandidatesArgs = {
  input: GenerateInsightsCandidatesInput;
};


export type MutationGenerateInsightsCandidatesFromAlternateIdsArgs = {
  tenantId: Scalars['ID'];
};


export type MutationGeneratePresignedUrlArgs = {
  contentType?: InputMaybe<Scalars['String']>;
  directory?: InputMaybe<Scalars['String']>;
  facilityId?: InputMaybe<Scalars['ID']>;
  fileName: Scalars['String'];
  tenantId: Scalars['ID'];
};


export type MutationGenerateStaffReportArgs = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  reportType: StaffReportType;
  reportingYear?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateT2SArgs = {
  reportId: Scalars['ID'];
};


export type MutationGenerateTierIiPdfPreviewArgs = {
  attachSitePlan?: InputMaybe<Scalars['Boolean']>;
  tierIIReportId: Scalars['ID'];
};


export type MutationImportT2sFileArgs = {
  input: T2sImportInput;
};


export type MutationLinkFacilitiesArgs = {
  input: LinkFacilitiesInput;
};


export type MutationManageFacilityTagsArgs = {
  facilityUpdates: Array<FacilityTagUpdate>;
  tenantId: Scalars['ID'];
};


export type MutationManageTierIiReportsTagsArgs = {
  reportUpdates: Array<ReportTagUpdate>;
};


export type MutationMarkAsReportingArgs = {
  facilityIds: Array<Scalars['ID']>;
};


export type MutationMergeChemicalsArgs = {
  ids: Array<Scalars['ID']>;
  input: ChemicalInput;
};


export type MutationMergePeopleArgs = {
  input: PersonInput;
  mergedPeopleIds: Array<Scalars['ID']>;
};


export type MutationMergeWasteStreamsArgs = {
  input: MergeWasteStreamsInput;
};


export type MutationMoveToReviewArgs = {
  input: UpdateSubmissionInput;
};


export type MutationProcessOneschemaFileUploadArgs = {
  input: ProcessOneschemaFileUploadInput;
};


export type MutationPromoteDraftReportArgs = {
  webAutomationJobId: Scalars['ID'];
};


export type MutationQueueDocumentAiEnrichmentJobArgs = {
  input: QueueDocumentAiEnrichmentJobInput;
};


export type MutationQueueErrorClusteringJobArgs = {
  input: QueueErrorClusteringJobInput;
};


export type MutationQueueSdsParsingJobsArgs = {
  input: CreateChemicalsFromSdsInput;
};


export type MutationReconcilePaymentArgs = {
  id: Scalars['ID'];
};


export type MutationRejectSubmissionDocumentReviewArgs = {
  submissionDocumentReviewId: Scalars['ID'];
};


export type MutationRemoveDocumentFromActivityArgs = {
  activityId: Scalars['ID'];
  documentId: Scalars['ID'];
};


export type MutationRemoveDocumentFromReportArgs = {
  documentId: Scalars['ID'];
  reportId: Scalars['ID'];
};


export type MutationRemoveTierIiReportAssigneesArgs = {
  assigneeIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationRemoveTierIiReportReviewersArgs = {
  reviewerIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationRemoveUndergroundStorageTankArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveWorkflowTagArgs = {
  tagId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationReplacePersonFacilityAssociationsArgs = {
  newPersonId: Scalars['ID'];
  oldPersonId: Scalars['ID'];
  reportingRoles?: InputMaybe<Array<ContactReportRole>>;
};


export type MutationReplaceReportDocumentsByTypeArgs = {
  documentType: DocumentType;
  documents: Array<DocumentInput2>;
  reportId: Scalars['ID'];
};


export type MutationRequeueActivitiesArgs = {
  activityIds: Array<Scalars['ID']>;
};


export type MutationRequeueCommunicationArgs = {
  id: Scalars['ID'];
};


export type MutationRequirementsOptInOptOutArgs = {
  comment: Scalars['String'];
  requirementStatus: RequirementStatus;
  submissionIds: Array<Scalars['ID']>;
};


export type MutationResendInvitationToUserArgs = {
  email: Scalars['String'];
};


export type MutationResetReportArgs = {
  inputs: ResetReportInput;
};


export type MutationRevertVendorManifestAndLineItemsArgs = {
  id: Scalars['ID'];
};


export type MutationSendLobCheckArgs = {
  input: SendLobCheckInput;
};


export type MutationSendSubmissionsToReviewersArgs = {
  submissionIds: Array<Scalars['ID']>;
};


export type MutationSetChemicalFlagForFacilitiesArgs = {
  facilityIds: Array<Scalars['ID']>;
  featureFlagOverride: FeatureFlagOverride;
};


export type MutationSetCollectionModeArgs = {
  collectionMode?: InputMaybe<CollectionMode>;
  facilityIds: Array<Scalars['ID']>;
};


export type MutationSetEmulatedRoleArgs = {
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  permissions: Array<Permission>;
  roleId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['String'];
};


export type MutationSetInReviewStatusArgs = {
  id: Scalars['ID'];
  inReview: Scalars['Boolean'];
};


export type MutationSetIsAlwaysReportedOnReportingFacilityChemicalArgs = {
  id: Scalars['ID'];
  isAlwaysReported?: InputMaybe<Scalars['Boolean']>;
};


export type MutationSetReviewCompleteArgs = {
  id: Scalars['ID'];
  reviewComplete: Scalars['Boolean'];
};


export type MutationSetSubmissionAssigneesArgs = {
  assigneeId: Scalars['ID'];
  submissionIds: Array<Scalars['ID']>;
};


export type MutationSetTierIiReportAssigneesArgs = {
  assigneeIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationSetTierIiReportReviewersArgs = {
  reviewerIds: Array<Scalars['ID']>;
  tierIIReportIds: Array<Scalars['ID']>;
};


export type MutationSetUserTenantArgs = {
  tenantId: Scalars['ID'];
};


export type MutationSetValueOnActivityUserInputArgs = {
  id: Scalars['ID'];
  value: Scalars['String'];
};


export type MutationSetWasteFlagForFacilitiesArgs = {
  facilityIds: Array<Scalars['ID']>;
  featureFlagOverride: FeatureFlagOverride;
};


export type MutationSplitChemicalArgs = {
  id: Scalars['ID'];
};


export type MutationSplitCohortArgs = {
  cohortId: Scalars['ID'];
};


export type MutationSplitPersonArgs = {
  id: Scalars['ID'];
};


export type MutationTouchTierIiReportCaStepArgs = {
  reportId: Scalars['ID'];
  step: TierIiReportCaStep;
};


export type MutationTouchTierIiReportStepArgs = {
  reportId: Scalars['ID'];
  step: TierIiReportStep;
};


export type MutationTouchTierIiReportUstStepArgs = {
  reportId: Scalars['ID'];
  step: TierIiReportUstStep;
  undergroundStorageTankId: Scalars['ID'];
};


export type MutationUnmergeWasteStreamsArgs = {
  input: UnmergeWasteStreamsInput;
};


export type MutationUntouchTierIiReportCaStepArgs = {
  reportId: Scalars['ID'];
  step: TierIiReportCaStep;
};


export type MutationUnverifyChemicalArgs = {
  chemicalId: Scalars['ID'];
};


export type MutationUnverifyChemicalsArgs = {
  chemicalIds: Array<Scalars['ID']>;
};


export type MutationUpdateActivitiesArgs = {
  allowPartialFailure?: InputMaybe<Scalars['Boolean']>;
  ids: Array<Scalars['ID']>;
  input: ActivityInput;
};


export type MutationUpdateActivityArgs = {
  id: Scalars['ID'];
  input: ActivityInput;
};


export type MutationUpdateActivityAssigneesArgs = {
  assigneeId?: InputMaybe<Scalars['ID']>;
  ids: Array<Scalars['ID']>;
};


export type MutationUpdateCohortActivityArgs = {
  id: Scalars['ID'];
  input: ActivityInput;
};


export type MutationUpdateCommunicationArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  input: UpdateCommunicationInput;
};


export type MutationUpdateFacilitiesArgs = {
  facility: FacilityInput;
  ids: Array<Scalars['ID']>;
};


export type MutationUpdateFacilitiesForInternalTagArgs = {
  facilityIds: Array<Scalars['ID']>;
  tagName: Scalars['String'];
};


export type MutationUpdateFacilityArgs = {
  facility: FacilityInput;
  id: Scalars['ID'];
  reportId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateFacilityStateFieldsArgs = {
  facilityId: Scalars['ID'];
  stateFields: Array<DynamicFieldInput>;
};


export type MutationUpdateInsightsCohortArgs = {
  domainSearches?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  nameSearches?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationUpdateNotesToRegulatorsArgs = {
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateReasonForReportArgs = {
  id: Scalars['ID'];
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateReconciliationStatusArgs = {
  input: UpdateReconciliationStatusInput;
};


export type MutationUpdateRequiresReviewersArgs = {
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  requiresReviewers?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateSubmissionArgs = {
  input: UpdateSubmissionInput;
};


export type MutationUpdateSubmissionStatusArgs = {
  input: UpdateSubmissionStatusInput;
};


export type MutationUpdateTaskRecurringArgs = {
  input: UpdateTaskRecurringInput;
};


export type MutationUpdateTaskSingleArgs = {
  input: UpdateTaskSingleInput;
};


export type MutationUpdateTierIiReportTagsArgs = {
  tags: Array<Scalars['String']>;
  tierIIReportId: Scalars['ID'];
};


export type MutationUpdateTierIiReportVerifierArgs = {
  reportId: Scalars['ID'];
  verifier: TierIiReportVerifier;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateWasteLineUnifiedTagsArgs = {
  input: UpdateWasteLineUnifiedTagsInput;
};


export type MutationUpdateWasteStreamArgs = {
  input: UpdateWasteStreamInput;
};


export type MutationUpdateWebAutomationJobsArgs = {
  ids: Array<Scalars['ID']>;
  input: UpdateWebAutomationJobInput;
};


export type MutationUpdateWorkflowTagsArgs = {
  tagIds: Array<Scalars['ID']>;
  workflowId: Scalars['ID'];
};


export type MutationUpdateWorkflowTagsBulkArgs = {
  workflowUpdates: Array<WorkflowTagUpdateInput>;
};


export type MutationUpsertChemicalArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: ChemicalInput;
};


export type MutationUpsertCommentArgs = {
  input: CommentInput;
};


export type MutationUpsertCredentialArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: CredentialInput;
};


export type MutationUpsertDocumentArgs = {
  associations?: InputMaybe<Array<DocumentAssociationsInput>>;
  currentSubmissionDocument: Scalars['Boolean'];
  document: DocumentInput2;
  generateTitleOnCreate?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  removeAssociations?: InputMaybe<Array<DocumentAssociationsInput>>;
};


export type MutationUpsertDocumentsArgs = {
  associations?: InputMaybe<Array<DocumentAssociationsInput>>;
  currentSubmissionDocument: Scalars['Boolean'];
  documents: Array<DocumentInput2>;
  generateTitleOnCreate?: InputMaybe<Scalars['Boolean']>;
  removeAssociations?: InputMaybe<Array<DocumentAssociationsInput>>;
};


export type MutationUpsertFacilityChemicalArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: FacilityChemicalInput;
  reportId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpsertFacilityChemicalMeasurementArgs = {
  id: Scalars['ID'];
  input: FacilityChemicalMeasurementInput;
};


export type MutationUpsertFacilityChemicalStateFieldArgs = {
  input: FacilityChemicalStateFieldInput;
};


export type MutationUpsertFacilityChemicalStateFieldsArgs = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  input: Array<FacilityChemicalStateFieldInput>;
  reportingYear: Scalars['Int'];
  type: ProgramArea;
};


export type MutationUpsertFacilityContactArgs = {
  data: FacilityContactInput;
  programArea?: InputMaybe<ProgramArea>;
};


export type MutationUpsertFacilityProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: FacilityProductInput;
};


export type MutationUpsertFacilityProductMeasurementArgs = {
  id: Scalars['ID'];
  input: FacilityProductMeasurementInput;
};


export type MutationUpsertFireDepartmentArgs = {
  id?: InputMaybe<Scalars['String']>;
  input: FireDepartmentInput;
};


export type MutationUpsertInternalTagArgs = {
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  newTagName?: InputMaybe<Scalars['String']>;
  tagName: Scalars['String'];
};


export type MutationUpsertLeadAgencyArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: LeadAgencyInput;
};


export type MutationUpsertLepcArgs = {
  id?: InputMaybe<Scalars['String']>;
  input: LepcInput;
};


export type MutationUpsertPaymentArgs = {
  input: PaymentInput;
  requeueJob?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpsertPersonArgs = {
  input: PersonFacilityContactsInput;
};


export type MutationUpsertPoliceDepartmentArgs = {
  id?: InputMaybe<Scalars['Int']>;
  input: PoliceDepartmentInput;
};


export type MutationUpsertProductArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: ProductInput;
};


export type MutationUpsertTenantArgs = {
  input: TenantInput;
};


export type MutationUpsertUndergroundStorageTankArgs = {
  input: UndergroundStorageTankInput;
};


export type MutationUpsertUserFacilitiesForTenantArgs = {
  facilityIds: Array<Scalars['ID']>;
  tenantId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationVerifyChemicalArgs = {
  chemicalId: Scalars['ID'];
};


export type MutationVerifyChemicalsArgs = {
  chemicalIds: Array<Scalars['ID']>;
};


export type MutationVerifyCredentialArgs = {
  input: VerifyCredentialInput;
};


export type MutationVerifyCredentialsArgs = {
  input: Array<VerifyCredentialInput>;
};


export type MutationWasteLinesUnifiedBulkUpdateWillNotReportArgs = {
  input: WasteLinesUnifiedBulkUpdateWillNotReportInput;
};

export type MyReportStatus = {
  __typename?: 'MyReportStatus';
  inProgress: MyReportStatusItem;
  inReview: MyReportStatusItem;
  notReporting: MyReportStatusItem;
  notStarted: MyReportStatusItem;
  submittedToEncamp: MyReportStatusItem;
};

export type MyReportStatusItem = {
  __typename?: 'MyReportStatusItem';
  count: Scalars['Int'];
  percent: Scalars['Float'];
};

export type MyTierIiFacilityResult = {
  __typename?: 'MyTierIIFacilityResult';
  myAssignedFacilityCount: Scalars['Int'];
  myAuthorizedFacilityCount: Scalars['Int'];
  myNonReportingFacilityCount: Scalars['Int'];
  myReportingFacilityCount: Scalars['Int'];
  totalFacilityCount: Scalars['Int'];
};

export enum NotReportingReason {
  Closed = 'CLOSED',
  CoLocated = 'CO_LOCATED',
  Inactive = 'INACTIVE',
  NotWithEncamp = 'NOT_WITH_ENCAMP',
  UnderThreshold = 'UNDER_THRESHOLD'
}

export type NotReportingReasonInput = {
  coLocatedId?: InputMaybe<Scalars['ID']>;
  dateClosed?: InputMaybe<Scalars['Date']>;
  dateInactive?: InputMaybe<Scalars['Date']>;
  facilityIds: Array<Scalars['ID']>;
  reason: NotReportingReason;
  reportingYear: Scalars['Int'];
};

export type Notification = {
  __typename?: 'Notification';
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['ID']>;
  tierIIReport?: Maybe<TierIiReport>;
  tierIIReportId?: Maybe<Scalars['ID']>;
};

export type NotificationsResult = {
  __typename?: 'NotificationsResult';
  count: Scalars['Int'];
  items: Array<Notification>;
};

export type NpdesDetailResult = {
  __typename?: 'NpdesDetailResult';
  facility?: Maybe<NpdesFacility>;
  permits: Array<NpdesPermit>;
};

export type NpdesFacility = {
  __typename?: 'NpdesFacility';
  city?: Maybe<Scalars['String']>;
  countyCode?: Maybe<Scalars['String']>;
  facilityName?: Maybe<Scalars['String']>;
  facilityTypeCode?: Maybe<FacilityTypeCode>;
  facilityUin?: Maybe<Scalars['String']>;
  geocodeLatitude?: Maybe<Scalars['Float']>;
  geocodeLongitude?: Maybe<Scalars['Float']>;
  icisFacilityInterestId: Scalars['String'];
  impairedWaters?: Maybe<Scalars['String']>;
  locationAddress?: Maybe<Scalars['String']>;
  npdesId?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
  supplementalAddressText?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NpdesFacilityResult = {
  __typename?: 'NpdesFacilityResult';
  count: Scalars['Int'];
  items: Array<NpdesFacility>;
};

export type NpdesPermit = {
  __typename?: 'NpdesPermit';
  activityId?: Maybe<Scalars['String']>;
  actualAverageFlowNmbr?: Maybe<Scalars['Float']>;
  agencyTypeCode?: Maybe<AgencyTypeCode>;
  dmrNonReceiptFlag?: Maybe<Scalars['Boolean']>;
  edmrAuthorizationFlag?: Maybe<Scalars['Boolean']>;
  effectiveDate?: Maybe<Scalars['DateTime']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  externalPermitNmbr?: Maybe<Scalars['String']>;
  facilityTypeIndicator?: Maybe<FacilityTypeIndicator>;
  issueDate?: Maybe<Scalars['DateTime']>;
  issuingAgency?: Maybe<Scalars['String']>;
  majorMinorStatusFlag?: Maybe<MajorMinorStatusFlag>;
  masterExternalPermitNmbr?: Maybe<Scalars['String']>;
  originalIssueDate?: Maybe<Scalars['DateTime']>;
  permitCompStatusFlag?: Maybe<Scalars['Boolean']>;
  permitName?: Maybe<Scalars['String']>;
  permitStatusCode?: Maybe<PermitStatusCode>;
  permitTypeCode?: Maybe<PermitTypeCode>;
  pretreatmentIndicatorCode?: Maybe<PretreatmentIndicatorCode>;
  radWbdHuc12s?: Maybe<Scalars['String']>;
  retirementDate?: Maybe<Scalars['DateTime']>;
  rncTrackingFlag?: Maybe<Scalars['Boolean']>;
  stateWaterBody?: Maybe<Scalars['String']>;
  stateWaterBodyName?: Maybe<Scalars['String']>;
  terminationDate?: Maybe<Scalars['DateTime']>;
  tmdlInterfaceFlag?: Maybe<Scalars['Boolean']>;
  totalDesignFlowNmbr?: Maybe<Scalars['Float']>;
  versionNmbr?: Maybe<Scalars['Int']>;
};

export enum OregonHazard {
  InfectiousOrEtiologic = 'INFECTIOUS_OR_ETIOLOGIC',
  PoisonousGas = 'POISONOUS_GAS',
  PoisonousMaterial = 'POISONOUS_MATERIAL',
  Radioactive = 'RADIOACTIVE'
}

export type OutstandingReviewer = {
  __typename?: 'OutstandingReviewer';
  email: Scalars['String'];
  first: Scalars['String'];
  last: Scalars['String'];
  reportCount: Scalars['Int'];
  userId: Scalars['ID'];
};

export type OutstandingReviewsResult = {
  __typename?: 'OutstandingReviewsResult';
  reportsWithoutReviewerCount: Scalars['Int'];
  reviewers: Array<OutstandingReviewer>;
};

export type PaginationMetadata = {
  __typename?: 'PaginationMetadata';
  endCursor?: Maybe<Scalars['String']>;
  startCursor?: Maybe<Scalars['String']>;
  totalItemCount: Scalars['Int'];
};

export enum Payee {
  Fd = 'FD',
  Lepc = 'LEPC',
  Rcra = 'RCRA',
  Serc = 'SERC'
}

export type Payment = {
  __typename?: 'Payment';
  activityId?: Maybe<Scalars['ID']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  billable: Scalars['Boolean'];
  city?: Maybe<Scalars['String']>;
  comments: Array<PaymentComment>;
  company?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  exceptionNote?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<FacilityPayment>>;
  id: Scalars['ID'];
  job?: Maybe<Job>;
  lobMail?: Maybe<LobMail>;
  memo?: Maybe<Scalars['String']>;
  paidAt: Scalars['DateTime'];
  payee?: Maybe<Scalars['String']>;
  payeeType?: Maybe<Payee>;
  paymentInvoices?: Maybe<Array<PaymentInvoice>>;
  paymentMethod?: Maybe<PaymentMethod>;
  reconciledAt?: Maybe<Scalars['DateTime']>;
  reconciledBy?: Maybe<Scalars['String']>;
  reconciliationHistory: Array<PaymentReconciliationHistory>;
  reconciliationStatus: ReconciliationStatus;
  recordedByEmail?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  status: PaymentStatus;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  tierIIReports?: Maybe<Array<TierIiReportPayment>>;
  zip?: Maybe<Scalars['String']>;
};

export type PaymentAssociation = {
  amount: Scalars['Float'];
  facilityId?: InputMaybe<Scalars['ID']>;
  reportId?: InputMaybe<Scalars['ID']>;
};

export type PaymentComment = {
  __typename?: 'PaymentComment';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  createdByEmail: Scalars['String'];
  deleted: Scalars['Boolean'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type PaymentCommentInput = {
  message: Scalars['String'];
  paymentId: Scalars['ID'];
};

export type PaymentInput = {
  activityId?: InputMaybe<Scalars['ID']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  associations: Array<PaymentAssociation>;
  billable?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['ID']>;
  exceptionNote?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  paidAt: Scalars['String'];
  payee: Scalars['String'];
  payeeType: Payee;
  paymentInvoices?: InputMaybe<Array<PaymentInvoiceInput>>;
  paymentMethod: PaymentMethod;
  state?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  zip?: InputMaybe<Scalars['String']>;
};

export type PaymentInvoice = {
  __typename?: 'PaymentInvoice';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceDocument?: Maybe<Document>;
  invoiceNumber?: Maybe<Scalars['String']>;
  payee?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
};

export type PaymentInvoiceInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceDocument?: InputMaybe<DocumentInput>;
  invoiceDocumentId: Scalars['ID'];
  invoiceNumber: Scalars['String'];
};

export enum PaymentMethod {
  Ach = 'ACH',
  Check = 'CHECK',
  CreditCard = 'CREDIT_CARD',
  NoPayment = 'NO_PAYMENT'
}

export type PaymentReconciliationHistory = {
  __typename?: 'PaymentReconciliationHistory';
  changedAt: Scalars['DateTime'];
  changedBy: Scalars['String'];
  changedByEmail: Scalars['String'];
  id: Scalars['ID'];
  newStatus: ReconciliationStatus;
  paymentId: Scalars['ID'];
  previousStatus?: Maybe<ReconciliationStatus>;
  reason?: Maybe<Scalars['String']>;
};

export enum PaymentStatus {
  AwaitingInvoice = 'AWAITING_INVOICE',
  Cancelled = 'CANCELLED',
  Failure = 'FAILURE',
  NoPayment = 'NO_PAYMENT',
  Paid = 'PAID',
  Pending = 'PENDING',
  Void = 'VOID'
}

export type PaymentsResult = {
  __typename?: 'PaymentsResult';
  count: Scalars['Int'];
  items: Array<Payment>;
};

export type PeopleResult = {
  __typename?: 'PeopleResult';
  count: Scalars['Int'];
  items: Array<Person>;
};

export enum Permission {
  CreateDataCollectionTask = 'CreateDataCollectionTask',
  CreateFacility = 'CreateFacility',
  CreateUserTenant = 'CreateUserTenant',
  EditOwnFacilityPermissions = 'EditOwnFacilityPermissions',
  EditOwnFacilityPermissionsUnlimited = 'EditOwnFacilityPermissionsUnlimited',
  FulfillDataCollectionTask = 'FulfillDataCollectionTask',
  ManageReviewerRequirements = 'ManageReviewerRequirements',
  ReadAllFacility = 'ReadAllFacility',
  ReadAllFacilityMinimal = 'ReadAllFacilityMinimal',
  ReadAllUserTenant = 'ReadAllUserTenant',
  ReadFacilityContact = 'ReadFacilityContact',
  ReadOrgEventSequences = 'ReadOrgEventSequences',
  ReadPerson = 'ReadPerson',
  ReadRole = 'ReadRole',
  ReadSystemAuditLog = 'ReadSystemAuditLog',
  ReadUserActivityLog = 'ReadUserActivityLog',
  ReadUserTenantRole = 'ReadUserTenantRole',
  RouteCalendar = 'RouteCalendar',
  RouteContacts = 'RouteContacts',
  RouteDocuments = 'RouteDocuments',
  RouteEpcra = 'RouteEPCRA',
  RouteEpcraCredentials = 'RouteEPCRACredentials',
  RouteEpcraOverview = 'RouteEPCRAOverview',
  RouteEpcraProducts = 'RouteEPCRAProducts',
  RouteEpcraReports = 'RouteEPCRAReports',
  RouteEpcraTierIi = 'RouteEPCRATierII',
  RouteFacilities = 'RouteFacilities',
  RouteInsights = 'RouteInsights',
  RouteRcra = 'RouteRCRA',
  VerifyTierIiReport = 'VerifyTierIIReport',
  ViewCredentials = 'ViewCredentials',
  WriteAllCalendarEvent = 'WriteAllCalendarEvent',
  WriteAllFacility = 'WriteAllFacility',
  WriteAllUserTenant = 'WriteAllUserTenant',
  WriteDataCollectionTask = 'WriteDataCollectionTask',
  WriteDataCollectionTaskTemplate = 'WriteDataCollectionTaskTemplate',
  WriteFacilityContact = 'WriteFacilityContact',
  WriteOrgEventSequences = 'WriteOrgEventSequences',
  WritePerson = 'WritePerson',
  WriteRole = 'WriteRole',
  WriteUserTenantRole = 'WriteUserTenantRole'
}

export enum PermitStatusCode {
  AdministrativelyContinued = 'ADMINISTRATIVELY_CONTINUED',
  Effective = 'EFFECTIVE',
  Expired = 'EXPIRED',
  NotNeeded = 'NOT_NEEDED',
  Pending = 'PENDING',
  Retired = 'RETIRED',
  Terminated = 'TERMINATED'
}

export enum PermitTypeCode {
  AssociatedPermitRecord = 'ASSOCIATED_PERMIT_RECORD',
  GeneralPermitCoveredFacility = 'GENERAL_PERMIT_COVERED_FACILITY',
  IndividualIuPermitNonNpdes = 'INDIVIDUAL_IU_PERMIT_NON_NPDES',
  IndividualStateIssuedPermitNonNpdes = 'INDIVIDUAL_STATE_ISSUED_PERMIT_NON_NPDES',
  NpdesIndividualPermit = 'NPDES_INDIVIDUAL_PERMIT',
  NpdesMasterGeneralPermit = 'NPDES_MASTER_GENERAL_PERMIT',
  StateIssuedMasterGeneralPermitNonNpdes = 'STATE_ISSUED_MASTER_GENERAL_PERMIT_NON_NPDES',
  UnpermittedFacility = 'UNPERMITTED_FACILITY'
}

export type Person = {
  __typename?: 'Person';
  attentionTo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dbNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facilityContacts?: Maybe<Array<FacilityContact>>;
  first?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEncamp?: Maybe<Scalars['Boolean']>;
  issues?: Maybe<Array<Issue>>;
  last?: Maybe<Scalars['String']>;
  phones?: Maybe<Array<Phone>>;
  renderPhone?: Maybe<DynamicField>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tankOwnerType?: Maybe<TankOwnerType>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  zip?: Maybe<Scalars['String']>;
};

export type PersonFacilitiesResult = {
  __typename?: 'PersonFacilitiesResult';
  count: Scalars['Int'];
  items: Array<Facility>;
};

export type PersonFacilityContactRolesInput = {
  facilityId: Scalars['ID'];
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>;
  reportingRoles: Array<ContactReportRole>;
};

export type PersonFacilityContactsInput = {
  facilityContactInput: Array<PersonFacilityContactRolesInput>;
  person: PersonInput;
};

export type PersonInput = {
  attentionTo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  dbNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Array<PhoneInput>>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress1?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  tankOwnerType?: InputMaybe<TankOwnerType>;
  tenantId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type Phone = {
  __typename?: 'Phone';
  number?: Maybe<Scalars['String']>;
  type: PhoneType;
};

export type PhoneInput = {
  number?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PhoneType>;
};

export enum PhoneType {
  Cell = 'CELL',
  Emergency = 'EMERGENCY',
  Fax = 'FAX',
  Home = 'HOME',
  Hrs_24 = 'HRS_24',
  Work = 'WORK'
}

export enum PhysicalHazard {
  CombustibleDust = 'COMBUSTIBLE_DUST',
  CompressedGas = 'COMPRESSED_GAS',
  CorrosiveToMetal = 'CORROSIVE_TO_METAL',
  Explosive = 'EXPLOSIVE',
  Flammable = 'FLAMMABLE',
  FlammableWithWater = 'FLAMMABLE_WITH_WATER',
  OrganicPeroxide = 'ORGANIC_PEROXIDE',
  Oxidizer = 'OXIDIZER',
  PyrophoricGas = 'PYROPHORIC_GAS',
  PyrophoricSolidOrLiquid = 'PYROPHORIC_SOLID_OR_LIQUID',
  SelfHeating = 'SELF_HEATING',
  SelfReactive = 'SELF_REACTIVE',
  UnclassifiedPhysicalHazard = 'UNCLASSIFIED_PHYSICAL_HAZARD'
}

export type PoliceDepartment = {
  __typename?: 'PoliceDepartment';
  additionalComments?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  attn?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  contactName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PoliceDepartmentForValidation = {
  additionalComments?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  contactName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type PoliceDepartmentInput = {
  additionalComments?: InputMaybe<Scalars['String']>;
  address: Scalars['String'];
  attn?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  contactName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type PoliceDepartmentResult = {
  __typename?: 'PoliceDepartmentResult';
  count: Scalars['Int'];
  items: Array<PoliceDepartment>;
};

export type PortalCredential = {
  __typename?: 'PortalCredential';
  credential?: Maybe<Credential>;
  type?: Maybe<PortalType>;
  url?: Maybe<Scalars['String']>;
};

export enum PortalType {
  AZmyDeq = 'AZmyDEQ',
  Cers = 'CERS',
  EPlan = 'EPlan',
  Mo = 'MO',
  Tx = 'TX',
  Tier2Manager = 'Tier2Manager'
}

export enum Pressure {
  AmbientPressure = 'AMBIENT_PRESSURE',
  GreaterThanAmbientPressure = 'GREATER_THAN_AMBIENT_PRESSURE',
  LessThanAmbientPressure = 'LESS_THAN_AMBIENT_PRESSURE',
  Other = 'OTHER'
}

export enum PretreatmentIndicatorCode {
  Approved = 'APPROVED',
  Covered = 'COVERED',
  Epa = 'EPA',
  RequiredAndDeveloping = 'REQUIRED_AND_DEVELOPING',
  State = 'STATE'
}

export type ProcessOneschemaFileUploadInput = {
  processingFunction: ProcessingFunction;
  tenantId: Scalars['ID'];
  url: Scalars['String'];
};

export type ProcessOneschemaFileUploadResult = {
  __typename?: 'ProcessOneschemaFileUploadResult';
  result: Scalars['String'];
};

export type ProcessedManifest = {
  __typename?: 'ProcessedManifest';
  desFacilityName?: Maybe<Scalars['String']>;
  eManifestCertifiedDate?: Maybe<Scalars['DateTime']>;
  eManifestCreatedDate?: Maybe<Scalars['DateTime']>;
  eManifestDuration?: Maybe<Scalars['Int']>;
  epaId?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEManifest?: Maybe<Scalars['Boolean']>;
  manifestTrackingNumber: Scalars['String'];
  shippedDate: Scalars['DateTime'];
  tenant: Tenant;
  tenantId: Scalars['String'];
  vendor?: Maybe<Scalars['String']>;
  vendorManifest?: Maybe<VendorManifest>;
  wasteLineCount?: Maybe<Scalars['Int']>;
};

export type ProcessedManifestSummary = {
  __typename?: 'ProcessedManifestSummary';
  displayedManifestId?: Maybe<Scalars['String']>;
  eManifestCertifiedDate?: Maybe<Scalars['DateTime']>;
  eManifestCreatedDate?: Maybe<Scalars['DateTime']>;
  eManifestDuration?: Maybe<Scalars['Int']>;
  epaId?: Maybe<Scalars['String']>;
  facilityName?: Maybe<Scalars['String']>;
  hasEManifest?: Maybe<Scalars['Boolean']>;
  hasIssues?: Maybe<Scalars['Boolean']>;
  hasIssuesReason?: Maybe<Array<HasIssuesReason>>;
  hasVendorManifest?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  manifestTrackingNumber?: Maybe<Scalars['String']>;
  shippedDate?: Maybe<Scalars['DateTime']>;
  vendor?: Maybe<Scalars['String']>;
  wasteLines: WasteManifestLineItemsResult;
};

export type ProcessedManifestsResult = {
  __typename?: 'ProcessedManifestsResult';
  count: Scalars['Int'];
  items: Array<ProcessedManifest>;
};

export enum ProcessingFunction {
  EManifest = 'eManifest',
  WasteManifest = 'wasteManifest'
}

export type Product = {
  __typename?: 'Product';
  alternateId?: Maybe<Scalars['String']>;
  facilityProductMeasurementCount?: Maybe<Scalars['Int']>;
  facilityProductMeasurements?: Maybe<Array<FacilityProductMeasurement>>;
  facilityProducts?: Maybe<Array<FacilityProduct>>;
  id: Scalars['ID'];
  issues: Array<Issue>;
  name: Scalars['String'];
  productChemicals?: Maybe<Array<ProductChemical>>;
  productTenants?: Maybe<Array<ProductTenant>>;
  reference?: Maybe<Scalars['String']>;
};


export type ProductFacilityProductMeasurementCountArgs = {
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type ProductFacilityProductsArgs = {
  facilityId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
};

export type ProductChemical = {
  __typename?: 'ProductChemical';
  amount: Scalars['Float'];
  chemical: Chemical;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  otherPressureValue?: Maybe<Scalars['String']>;
  overrides: Array<ProductChemicalOverride>;
  pressure?: Maybe<Pressure>;
  product: Product;
  productId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit: UnitType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type ProductChemicalBreakdown = {
  __typename?: 'ProductChemicalBreakdown';
  chemicalMaxAmount?: Maybe<AmountWithUnit>;
  productMaxAmount?: Maybe<AmountWithUnit>;
};

export type ProductChemicalInput = {
  amount?: InputMaybe<Scalars['Float']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  otherPressureValue?: InputMaybe<Scalars['String']>;
  overrides: Array<ProductChemicalOverrideInput>;
  pressure?: InputMaybe<Pressure>;
  productId?: InputMaybe<Scalars['ID']>;
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
  unit?: InputMaybe<UnitType>;
};

export type ProductChemicalMeasurementSummary = {
  __typename?: 'ProductChemicalMeasurementSummary';
  chemical: Chemical;
  maxAmount?: Maybe<AmountWithUnit>;
};

export type ProductChemicalOverride = {
  __typename?: 'ProductChemicalOverride';
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  productChemicalId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
};

export type ProductChemicalOverrideInput = {
  id: Scalars['ID'];
  jurisdiction: Scalars['String'];
  otherPressureValue?: InputMaybe<Scalars['String']>;
  pressure?: InputMaybe<Pressure>;
  storageType?: InputMaybe<Scalars['String']>;
  storageTypeDescription?: InputMaybe<Scalars['String']>;
  temperature?: InputMaybe<Temperature>;
};

export type ProductInput = {
  alternateId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productChemicals?: InputMaybe<Array<ProductChemicalInput>>;
  reference?: InputMaybe<Scalars['String']>;
  tenantIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ProductMeasurementSummary = {
  __typename?: 'ProductMeasurementSummary';
  id: Scalars['ID'];
  issues: Array<Issue>;
  name: Scalars['String'];
  productChemicals: Array<ProductChemicalMeasurementSummary>;
  totalMeasurements: Scalars['Int'];
};

export type ProductMeasurementsForReportResult = {
  __typename?: 'ProductMeasurementsForReportResult';
  count: Scalars['Int'];
  items: Array<ProductMeasurementSummary>;
};

export type ProductTenant = {
  __typename?: 'ProductTenant';
  id: Scalars['ID'];
  product: Product;
  productId: Scalars['ID'];
  tenant: Tenant;
  tenantId: Scalars['String'];
};

export type ProductWithFacilityCount = {
  __typename?: 'ProductWithFacilityCount';
  facilityCount: Scalars['Int'];
  product: Product;
};

export type ProductsResult = {
  __typename?: 'ProductsResult';
  count: Scalars['Int'];
  items: Array<Product>;
};

export enum ProgramArea {
  Epcra = 'EPCRA',
  Rcra = 'RCRA'
}

export type ProlificIssue = {
  __typename?: 'ProlificIssue';
  issue: ModelIssue;
  reportsAffected: Scalars['Int'];
  url?: Maybe<Scalars['String']>;
};

export type ProlificIssuesResult = {
  __typename?: 'ProlificIssuesResult';
  count: Scalars['Int'];
  items: Array<ProlificIssue>;
};

export enum PureOrMixture {
  Mixture = 'MIXTURE',
  Pure = 'PURE'
}

export type QuarterlyHistory = {
  __typename?: 'QuarterlyHistory';
  quarter: Scalars['String'];
  status: EchoQuarterlyHistory;
};

export type QuarterlyStat = {
  __typename?: 'QuarterlyStat';
  count: Scalars['Int'];
  group?: Maybe<Scalars['String']>;
  quarter: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activities: ActivitiesResult;
  activityLogs: ActivityLogsResult;
  bulkReportsSafeToReset: Array<BulkReportSafeToResetResponse>;
  bulkSubmissionsSafeToSendToReviewers: Array<SafeToSendToReviewersResponse>;
  bulkSubmissionsSafeToUpdate: Array<SafeToUpdateSubmissionResponse>;
  bulkTierIIReportVerifierValidator: Array<Issue>;
  cersFacilities: FacilitiesResult;
  checkForFile: CheckForFileResult;
  chemicalAnomalies: ChemicalAnomaliesResult;
  chemicalEnabledFacilities: FacilitiesResult;
  chemicalFacilities: ChemicalFacilitiesResult;
  chemicalInputValidator: Array<Issue>;
  chemicalWithAssociatedData: ChemicalWithAssociatedData;
  chemicalWithAssociatedDataForFacility: ChemicalWithAssociatedData;
  chemicals: ChemicalsResult;
  chemicalsByIds: Array<Chemical>;
  chemicalsOverviewMyProgress: ChemicalsOverviewMyProgressResult;
  cohort?: Maybe<Cohort>;
  cohortMembers: CohortMembersResult;
  cohorts: CohortsResult;
  communication?: Maybe<Communication>;
  communicationValidator: Array<Issue>;
  communications: CommunicationsResult;
  copyableDemoTenants: Array<Tenant>;
  counties: CountiesResult;
  credential: Credential;
  credentialInputValidator: Array<Issue>;
  credentials: CredentialResult;
  demoAccountCandidates: DemoAccountCandidateSearchResult;
  deniedFacilities: DeniedFacilitiesResult;
  document: Document;
  documentAIEnrichmentJob: DocumentAiEnrichmentJob;
  documentInputValidator: Array<Issue>;
  documents: DocumentsResult;
  echoExporter: EchoExporter;
  echoExporters: EchoExporterResult;
  echoOverview?: Maybe<EchoOverview>;
  encampFilingStatus: EncampFilingStatusResult;
  encampStats: EncampStats;
  errorClusterGroupsByRunId?: Maybe<ErrorClusterGroupsResult>;
  errorClusterRuns?: Maybe<ErrorClusterRunsResult>;
  errorClustersByRunId?: Maybe<ErrorClustersResult>;
  errorsBlockingCohort?: Maybe<ErrorsBlockingCohortResult>;
  facilities: FacilitiesResult;
  facilitiesByInternalTagName: FacilitiesResult;
  facilitiesForCredential: Array<Facility>;
  facilitiesWithInsightsCandidates: FacilitiesResult;
  facility?: Maybe<Facility>;
  facilityChemical?: Maybe<FacilityChemical>;
  facilityChemicalByYear?: Maybe<FacilityChemical>;
  facilityChemicalInputValidator: Array<Issue>;
  facilityChemicalMeasurement?: Maybe<FacilityChemicalMeasurement>;
  facilityChemicalMeasurementInputValidator: Array<Issue>;
  facilityChemicalMeasurements: FacilityChemicalMeasurementsResult;
  facilityChemicalMeasurementsForReport: FacilityChemicalMeasurementsForReportResult;
  facilityChemicalStateField?: Maybe<Array<FacilityChemicalStateField>>;
  facilityChemicalStateFieldsForFacility?: Maybe<DynamicFieldsResult>;
  facilityChemicalStorageLocationInputValidator: Array<Issue>;
  facilityChemicals: FacilityChemicalsResult;
  facilityContactInputValidator: Array<Issue>;
  facilityInputValidator: Array<Issue>;
  facilityInventoryStatus: InventoryStatusResult;
  facilityMatchesForDocuments: Array<DocumentFacilityMatches>;
  facilityProduct: FacilityProduct;
  facilityProductByYear?: Maybe<FacilityProduct>;
  facilityProductInputValidator: Array<Issue>;
  facilityProductMeasurement?: Maybe<FacilityProductMeasurement>;
  facilityProductMeasurementInputValidator: Array<Issue>;
  facilityProductMeasurements: FacilityProductMeasurementsResult;
  facilityProductStorageLocationInputValidator: Array<Issue>;
  facilityProducts: FacilityProductsResult;
  facilityStateFields: Array<DynamicField>;
  facilityTierIIReports: FacilityTierIiReportsResult;
  facilityUsage: FacilityUsage;
  facilityWasteShipmentCharts: FacilityWasteShipmentChartsOutput;
  fireDepartment: FireDepartment;
  fireDepartmentInputValidator: Array<Issue>;
  fireDepartmentSearch: FireDepartmentResult;
  fireDepartments?: Maybe<FireDepartmentResult>;
  fireDepartmentsPicker?: Maybe<FireDepartmentResult>;
  generatorStatusSummary: GeneratorStatusSummary;
  getAcceptableFileFormatsByDocumentType: Array<FileFormatsByDocumentType>;
  getAllTierIIReportTags: Array<Scalars['String']>;
  getAllWorkflowTags: Array<Tag>;
  getCurrentUser: User;
  getDocumentDownloadLink?: Maybe<Scalars['String']>;
  getEmbeddedDocumentPreparationUrl?: Maybe<Scalars['String']>;
  getEmbeddedDocumentSigningUrl?: Maybe<Scalars['String']>;
  getFacilityChemicalThresholdData: FacilityChemicalThresholdData;
  getOneSchemaJwt?: Maybe<Scalars['String']>;
  /**
   * Provide list of required inputs for a given activity
   * by description (which files or fees need to be provided)
   */
  getRequiredStaffInputs?: Maybe<RequiredStaffInputResult>;
  getUserById: User;
  groupedFireDepartmentSearch: GroupedFireDepartmentsResult;
  groupedLepcSearch: GroupedLepcsResult;
  insightsCandidates: InsightsCandidatesResult;
  insightsCohorts: Array<InsightsCohort>;
  insightsEchoAllFacilities: InsightsEchoAllFacilitiesResult;
  insightsEchoMyFacilities: InsightsEchoFacilitiesResult;
  insightsFacilityMix: InsightsFacilityMix;
  insightsNonCompliance: InsightsNonCompliance;
  insightsPenalties: InsightsPenalties;
  insightsViolations: InsightsViolations;
  internalTagsByName: InternalTagsByNameResult;
  job: Job;
  jobLogs: JobLogsResult;
  jobStepsDone: JobStepsDoneResult;
  jobs: JobsResult;
  leadAgencies: LeadAgencyResult;
  leadAgency: LeadAgency;
  leadAgencyInputValidator: Array<Issue>;
  lepc: Lepc;
  lepcInputValidator: Array<Issue>;
  lepcSearch: LepcResult;
  lepcs?: Maybe<LepcResult>;
  manifestEditInputValidator: Array<Issue>;
  mergedWasteStreamDestinations: WasteStreamDestinationsResult;
  municipalities?: Maybe<MunicipalityResult>;
  myReportStatus: MyReportStatus;
  myTierIIFacilities: MyTierIiFacilityResult;
  notifications: NotificationsResult;
  npdesDetail: NpdesDetailResult;
  npdesFacilities: NpdesFacilityResult;
  originalWasteStreamsById?: Maybe<WasteStreamRawsResult>;
  outstandingReviews: OutstandingReviewsResult;
  payment: Payment;
  payments: PaymentsResult;
  people: PeopleResult;
  peopleByIds: Array<Person>;
  person?: Maybe<Person>;
  personFacilities: PersonFacilitiesResult;
  personFacilityContactsInputValidator: Array<Issue>;
  policeDepartment: PoliceDepartment;
  policeDepartmentInputValidator: Array<Issue>;
  policeDepartments: PoliceDepartmentResult;
  problematicReports: FacilityTierIiReportsResult;
  processedManifests: ProcessedManifestsResult;
  product: Product;
  productChemicalInputValidator: Array<Issue>;
  productForFacility: Product;
  productInputValidator: Array<Issue>;
  productMeasurementsForReport: ProductMeasurementsForReportResult;
  productWithFacilityCount: ProductWithFacilityCount;
  products: ProductsResult;
  profile: Person;
  prolificIssues: ProlificIssuesResult;
  rcraInfoHdHandler: Array<HdHandler>;
  rcraInfoHdHandlers: HdHandlerResult;
  readT2sFile: ReadT2sFileResponse;
  regulatoryInputValidator: Array<Issue>;
  reportSafeToReset: ReportSafeToResetResponse;
  reportingFacilityChemical: ReportingFacilityChemical;
  reportingFacilityChemicalCounts: ReportingFacilityChemicalCountsResult;
  reportingFacilityChemicalInputValidator: Array<Issue>;
  reportingFacilityChemicals: ReportingFacilityChemicalsResult;
  reportingSeasonSummary: ReportingSeasonSummary;
  requirements: RequirementsResult;
  roles: Array<Role>;
  staffUsers: UsersResult;
  storageLocations: StorageLocationsResult;
  submission?: Maybe<Submission>;
  submissionComments: Array<Comment>;
  submissionErrorStats: SubmissionErrorStatsResult;
  submissionInputValidator: Array<Issue>;
  submissionVirtualEvents: VirtualEventResult;
  tags: TagsResult;
  tenant: Tenant;
  tenantInputValidator: Array<Issue>;
  tenants: TenantsResult;
  tierIIReport: TierIiReport;
  tierIIReportActivitiesInError: TierIiReportActivitiesResult;
  tierIIReportContacts: Array<FacilityContact>;
  tierIIReportReviewStepValidator: Array<Issue>;
  tierIIReportSubmittedDocuments: Array<Document>;
  tierIIReportVerifyStepValidator: Array<Issue>;
  tierIIReports: TierIiReportsResult;
  totalQuantityByTsdf: TotalQuantityByTsdfResult;
  undergroundStorageTankFields?: Maybe<Array<DynamicField>>;
  undergroundStorageTankInputValidator: Array<Issue>;
  user?: Maybe<User>;
  userInputValidator: Array<Issue>;
  users: UsersResult;
  virtualEvent?: Maybe<VirtualEvent>;
  virtualEvents: VirtualEventResult;
  wasteFacilities: WasteFacilityEpaIdResult;
  wasteFacilitiesByGeneratorStatusAndState: Array<WasteFacilitiesByGeneratorStatusAndState>;
  wasteLineUnifiedInputValidator: Array<Issue>;
  wasteLinesUnified?: Maybe<WasteLinesUnifiedResult>;
  wasteManagementMethod: Array<WasteManagementMethod>;
  wasteManifestLineItems: WasteManifestLineItemsResult;
  wasteManifestVendors: Array<Scalars['String']>;
  wasteManifests: WasteManifestsResult;
  wasteShipmentsByFacility: WasteShipmentsByFacility;
  wasteStream?: Maybe<WasteStream>;
  wasteStreamDestinations: WasteStreamDestinationsResult;
  wasteStreamShipmentsByMonth: WasteStreamShipmentChartsOutput;
  wasteTotalWaste: WasteTotalWasteResponse;
  wasteVendorTotals: Array<WasteVendorResult>;
  webAutomationJob: WebAutomationJobWithPromotionJob;
  webAutomationJobs: WebAutomationJobsResult;
  workflowActivities: WorkflowActivitiesResult;
  workflowManagerConfigRules: WorkflowManagerConfigRulesResult;
  workflowManagerConfigs: WorkflowManagerConfigResult;
  workflowOverviewSeasonSummary: WorkflowOverviewSeasonSummary;
};


export type QueryActivitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryActivityLogsArgs = {
  activityId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryBulkReportsSafeToResetArgs = {
  reportIds: Array<Scalars['ID']>;
};


export type QueryBulkSubmissionsSafeToSendToReviewersArgs = {
  submissionIds: Array<Scalars['ID']>;
};


export type QueryBulkSubmissionsSafeToUpdateArgs = {
  submissionIds: Array<Scalars['ID']>;
  targetStatus: SubmissionStatus;
};


export type QueryBulkTierIiReportVerifierValidatorArgs = {
  data: TierIiReportVerifier;
  reportIds: Array<Scalars['ID']>;
};


export type QueryCersFacilitiesArgs = {
  id: Scalars['ID'];
};


export type QueryCheckForFileArgs = {
  key: Scalars['String'];
};


export type QueryChemicalAnomaliesArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['ID'];
};


export type QueryChemicalEnabledFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryChemicalFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryChemicalInputValidatorArgs = {
  data: ChemicalInput;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryChemicalWithAssociatedDataArgs = {
  chemicalId: Scalars['ID'];
};


export type QueryChemicalWithAssociatedDataForFacilityArgs = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
};


export type QueryChemicalsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryChemicalsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryChemicalsOverviewMyProgressArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  tenantId: Scalars['ID'];
};


export type QueryCohortArgs = {
  id: Scalars['ID'];
};


export type QueryCohortMembersArgs = {
  cohortId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryCohortsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryCommunicationArgs = {
  id: Scalars['ID'];
};


export type QueryCommunicationValidatorArgs = {
  input: CreateCommunicationInput;
};


export type QueryCommunicationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryCopyableDemoTenantsArgs = {
  input: CopyableDemoTenantInput;
};


export type QueryCountiesArgs = {
  state: Scalars['String'];
};


export type QueryCredentialArgs = {
  facilitiesPage?: InputMaybe<Scalars['Int']>;
  facilitiesPageSize?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};


export type QueryCredentialInputValidatorArgs = {
  data: CredentialInputForValidation;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryCredentialsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryDemoAccountCandidatesArgs = {
  input: DemoOrganizationInput;
};


export type QueryDeniedFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentAiEnrichmentJobArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentInputValidatorArgs = {
  fileSize?: InputMaybe<Scalars['Int']>;
  input: DocumentInput;
};


export type QueryDocumentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryEchoExporterArgs = {
  registryId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryEchoExportersArgs = {
  filterTenantId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryEchoOverviewArgs = {
  cohortIds?: InputMaybe<Array<Scalars['String']>>;
  filterTenantId?: InputMaybe<Scalars['String']>;
  naicsCode?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type QueryEncampFilingStatusArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  reportKind: TierIiReportKind;
  tenantId: Scalars['ID'];
};


export type QueryEncampStatsArgs = {
  tenantId: Scalars['ID'];
};


export type QueryErrorClusterGroupsByRunIdArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  runId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryErrorClusterRunsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryErrorClustersByRunIdArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  runId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryErrorsBlockingCohortArgs = {
  runId: Scalars['String'];
};


export type QueryFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilitiesByInternalTagNameArgs = {
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tagName: Scalars['String'];
};


export type QueryFacilitiesForCredentialArgs = {
  credentialId: Scalars['ID'];
};


export type QueryFacilitiesWithInsightsCandidatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityChemicalArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityChemicalByYearArgs = {
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type QueryFacilityChemicalInputValidatorArgs = {
  input: FacilityChemicalInput;
};


export type QueryFacilityChemicalMeasurementArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityChemicalMeasurementInputValidatorArgs = {
  input: FacilityChemicalMeasurementInput;
};


export type QueryFacilityChemicalMeasurementsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityChemicalMeasurementsForReportArgs = {
  facilityId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityChemicalStateFieldArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryFacilityChemicalStateFieldsForFacilityArgs = {
  facilityId: Scalars['ID'];
};


export type QueryFacilityChemicalStorageLocationInputValidatorArgs = {
  facilityChemical?: InputMaybe<FacilityChemicalInput>;
  facilityChemicalId?: InputMaybe<Scalars['String']>;
  facilityId: Scalars['String'];
  input: FacilityChemicalStorageLocationInput;
};


export type QueryFacilityChemicalsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityContactInputValidatorArgs = {
  data: FacilityContactInput;
};


export type QueryFacilityInputValidatorArgs = {
  data: FacilityInput;
  id: Scalars['ID'];
  omit?: InputMaybe<Array<Scalars['String']>>;
  pick?: InputMaybe<Array<Scalars['String']>>;
  reportId?: InputMaybe<Scalars['ID']>;
};


export type QueryFacilityInventoryStatusArgs = {
  facilityId: Scalars['ID'];
  inventory: Inventory;
  toYear: Scalars['Int'];
};


export type QueryFacilityMatchesForDocumentsArgs = {
  documentIds: Array<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  minSimilarity?: InputMaybe<Scalars['Float']>;
};


export type QueryFacilityProductArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityProductByYearArgs = {
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type QueryFacilityProductInputValidatorArgs = {
  input: FacilityProductInput;
};


export type QueryFacilityProductMeasurementArgs = {
  id: Scalars['ID'];
};


export type QueryFacilityProductMeasurementInputValidatorArgs = {
  input: FacilityProductMeasurementInput;
};


export type QueryFacilityProductMeasurementsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityProductStorageLocationInputValidatorArgs = {
  facilityId: Scalars['String'];
  input: FacilityProductStorageLocationInput;
};


export type QueryFacilityProductsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryFacilityStateFieldsArgs = {
  input: FacilityStateFieldsInput;
};


export type QueryFacilityTierIiReportsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryFacilityUsageArgs = {
  chemicalId: Scalars['ID'];
  includeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryFacilityWasteShipmentChartsArgs = {
  facilityId: Scalars['ID'];
  filter: FacilityWasteShipmentsFilter;
};


export type QueryFireDepartmentArgs = {
  id: Scalars['String'];
};


export type QueryFireDepartmentInputValidatorArgs = {
  data: FireDepartmentInput;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryFireDepartmentSearchArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryFireDepartmentsArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryFireDepartmentsPickerArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGeneratorStatusSummaryArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  facilityId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryGetAcceptableFileFormatsByDocumentTypeArgs = {
  facilityId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QueryGetDocumentDownloadLinkArgs = {
  id: Scalars['ID'];
};


export type QueryGetEmbeddedDocumentPreparationUrlArgs = {
  submissionId: Scalars['ID'];
};


export type QueryGetEmbeddedDocumentSigningUrlArgs = {
  submissionId: Scalars['ID'];
};


export type QueryGetFacilityChemicalThresholdDataArgs = {
  input: FacilityChemicalInput;
};


export type QueryGetOneSchemaJwtArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetRequiredStaffInputsArgs = {
  activityDescription: Scalars['String'];
};


export type QueryGetUserByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGroupedFireDepartmentSearchArgs = {
  facilityIds: Array<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryGroupedLepcSearchArgs = {
  facilityIds: Array<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryInsightsCandidatesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryInsightsCohortsArgs = {
  tenantId: Scalars['String'];
};


export type QueryInsightsEchoAllFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryInsightsEchoMyFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryInsightsFacilityMixArgs = {
  naicsCode?: InputMaybe<Scalars['String']>;
  programArea?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type QueryInsightsNonComplianceArgs = {
  filter?: InputMaybe<InsightsFilter>;
  tenantId: Scalars['String'];
};


export type QueryInsightsPenaltiesArgs = {
  filter?: InputMaybe<InsightsFilter>;
  tenantId: Scalars['String'];
};


export type QueryInsightsViolationsArgs = {
  filter?: InputMaybe<InsightsFilter>;
  tenantId: Scalars['ID'];
};


export type QueryInternalTagsByNameArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryJobArgs = {
  id: Scalars['ID'];
};


export type QueryJobLogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryJobStepsDoneArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryJobsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryLeadAgenciesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryLeadAgencyArgs = {
  id: Scalars['Int'];
};


export type QueryLeadAgencyInputValidatorArgs = {
  data: LeadAgencyInput;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryLepcArgs = {
  id: Scalars['String'];
};


export type QueryLepcInputValidatorArgs = {
  data: LepcInput;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryLepcSearchArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryLepcsArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryManifestEditInputValidatorArgs = {
  input: ManifestEditInput;
  manifestId: Scalars['ID'];
};


export type QueryMergedWasteStreamDestinationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  viewType: DestinationViewType;
  wasteStreamIds: Array<Scalars['ID']>;
};


export type QueryMunicipalitiesArgs = {
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QueryMyReportStatusArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  reportKind: TierIiReportKind;
  tenantId: Scalars['ID'];
};


export type QueryMyTierIiFacilitiesArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  tenantId: Scalars['ID'];
};


export type QueryNotificationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryNpdesDetailArgs = {
  npdesId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryNpdesFacilitiesArgs = {
  filterTenantId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryOriginalWasteStreamsByIdArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  view?: InputMaybe<FacilityWasteView>;
  wasteStreamId: Scalars['ID'];
};


export type QueryOutstandingReviewsArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  tenantId: Scalars['ID'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryPeopleArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryPeopleByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPersonArgs = {
  id: Scalars['ID'];
};


export type QueryPersonFacilitiesArgs = {
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryPersonFacilityContactsInputValidatorArgs = {
  data: PersonFacilityContactsInput;
};


export type QueryPoliceDepartmentArgs = {
  id: Scalars['Int'];
};


export type QueryPoliceDepartmentInputValidatorArgs = {
  data: PoliceDepartmentForValidation;
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryPoliceDepartmentsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryProblematicReportsArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['ID'];
};


export type QueryProcessedManifestsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryProductArgs = {
  productId: Scalars['ID'];
};


export type QueryProductChemicalInputValidatorArgs = {
  input: ProductChemicalInput;
};


export type QueryProductForFacilityArgs = {
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
};


export type QueryProductInputValidatorArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input: ProductInput;
};


export type QueryProductMeasurementsForReportArgs = {
  facilityId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryProductWithFacilityCountArgs = {
  productId: Scalars['ID'];
};


export type QueryProductsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryProlificIssuesArgs = {
  filter?: InputMaybe<ChemicalOverviewFilter>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['ID'];
};


export type QueryRcraInfoHdHandlerArgs = {
  handlerId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryRcraInfoHdHandlersArgs = {
  filterTenantId?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  tenantId: Scalars['String'];
};


export type QueryReadT2sFileArgs = {
  documentId: Scalars['ID'];
};


export type QueryRegulatoryInputValidatorArgs = {
  data: FacilityInput;
  id: Scalars['ID'];
  omit?: InputMaybe<Array<Scalars['String']>>;
  pick?: InputMaybe<Array<Scalars['String']>>;
  reportId?: InputMaybe<Scalars['ID']>;
};


export type QueryReportSafeToResetArgs = {
  reportId: Scalars['ID'];
};


export type QueryReportingFacilityChemicalArgs = {
  id: Scalars['ID'];
  reportId?: InputMaybe<Scalars['ID']>;
};


export type QueryReportingFacilityChemicalCountsArgs = {
  reportId: Scalars['ID'];
};


export type QueryReportingFacilityChemicalInputValidatorArgs = {
  id: Scalars['ID'];
  input: Array<FacilityChemicalStateFieldInput>;
};


export type QueryReportingFacilityChemicalsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryReportingSeasonSummaryArgs = {
  reportKinds?: InputMaybe<Array<TierIiReportKind>>;
  year: Scalars['Int'];
};


export type QueryRequirementsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryRolesArgs = {
  tenantId: Scalars['ID'];
};


export type QueryStaffUsersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryStorageLocationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QuerySubmissionArgs = {
  id: Scalars['ID'];
};


export type QuerySubmissionCommentsArgs = {
  submissionId: Scalars['ID'];
};


export type QuerySubmissionErrorStatsArgs = {
  year: Scalars['Int'];
};


export type QuerySubmissionInputValidatorArgs = {
  input: SubmissionInputForValidation;
};


export type QuerySubmissionVirtualEventsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTagsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTenantArgs = {
  id: Scalars['ID'];
};


export type QueryTenantInputValidatorArgs = {
  input: TenantInput;
};


export type QueryTenantsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTierIiReportArgs = {
  reportId: Scalars['ID'];
  version?: InputMaybe<Scalars['String']>;
};


export type QueryTierIiReportActivitiesInErrorArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTierIiReportContactsArgs = {
  reportId: Scalars['ID'];
};


export type QueryTierIiReportReviewStepValidatorArgs = {
  facilityId: Scalars['ID'];
  reasonForReport?: InputMaybe<Scalars['String']>;
  reportId: Scalars['ID'];
};


export type QueryTierIiReportSubmittedDocumentsArgs = {
  reportId: Scalars['ID'];
};


export type QueryTierIiReportVerifyStepValidatorArgs = {
  data: TierIiReportVerifier;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  reportingYear: Scalars['Int'];
};


export type QueryTierIiReportsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryTotalQuantityByTsdfArgs = {
  filter: WasteOverviewFilter;
  maxResults?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
};


export type QueryUndergroundStorageTankFieldsArgs = {
  jurisdictions?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryUndergroundStorageTankInputValidatorArgs = {
  input: UndergroundStorageTankInput;
  pick?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserInputValidatorArgs = {
  input: UserInput;
};


export type QueryUsersArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryVirtualEventArgs = {
  deadline: Scalars['DateTime'];
  taskId: Scalars['ID'];
};


export type QueryVirtualEventsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWasteFacilitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWasteFacilitiesByGeneratorStatusAndStateArgs = {
  filter: WasteOverviewFilter;
  tenantId: Scalars['String'];
};


export type QueryWasteLineUnifiedInputValidatorArgs = {
  input: WasteLineUnifiedInput;
};


export type QueryWasteLinesUnifiedArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWasteManagementMethodArgs = {
  filter: WasteOverviewFilter;
  limit?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
};


export type QueryWasteManifestLineItemsArgs = {
  wasteManifestId: Scalars['String'];
};


export type QueryWasteManifestsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWasteShipmentsByFacilityArgs = {
  facilityId: Scalars['ID'];
  year: Scalars['Int'];
};


export type QueryWasteStreamArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  startDate?: InputMaybe<Scalars['Date']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  view?: InputMaybe<FacilityWasteView>;
};


export type QueryWasteStreamDestinationsArgs = {
  endDate?: InputMaybe<Scalars['Date']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
  startDate?: InputMaybe<Scalars['Date']>;
  view?: InputMaybe<FacilityWasteView>;
  viewType: DestinationViewType;
  wasteStreamId: Scalars['ID'];
};


export type QueryWasteStreamShipmentsByMonthArgs = {
  filter: FacilityWasteShipmentsFilter;
  wasteStreamId: Scalars['ID'];
};


export type QueryWasteTotalWasteArgs = {
  filter: WasteOverviewFilter;
  tenantId: Scalars['String'];
};


export type QueryWasteVendorTotalsArgs = {
  filter: WasteOverviewFilter;
  limit?: InputMaybe<Scalars['Int']>;
  tenantId: Scalars['String'];
};


export type QueryWebAutomationJobArgs = {
  id: Scalars['ID'];
};


export type QueryWebAutomationJobsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWorkflowActivitiesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWorkflowManagerConfigRulesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Array<SortModel>>;
};


export type QueryWorkflowOverviewSeasonSummaryArgs = {
  reportKinds: Array<TierIiReportKind>;
  year: Scalars['Int'];
};

export type QueryConfiguration = {
  cityWeight?: InputMaybe<Scalars['Int']>;
  distanceWeight?: InputMaybe<Scalars['Int']>;
  facilityNameWeight?: InputMaybe<Scalars['Int']>;
  matchLimit?: InputMaybe<Scalars['Int']>;
  minMatchScore?: InputMaybe<Scalars['Float']>;
  naicsCodeWeight?: InputMaybe<Scalars['Int']>;
  streetAddressWeight?: InputMaybe<Scalars['Int']>;
  tenantNameWeight?: InputMaybe<Scalars['Int']>;
  zipPrefixWeight?: InputMaybe<Scalars['Float']>;
  zipWeight?: InputMaybe<Scalars['Int']>;
};

export type QueueDocumentAiEnrichmentJobInput = {
  documents: Array<CreateDocumentInput>;
  tenantId: Scalars['ID'];
};

export type QueueErrorClusteringJobInput = {
  activityTypes?: InputMaybe<Array<Scalars['String']>>;
  distanceThreshold?: InputMaybe<Scalars['Float']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  reportingYear?: InputMaybe<Scalars['Int']>;
};

export enum RcraInfoAccessibility {
  ResponsibilitiesTransferredToCercla = 'RESPONSIBILITIES_TRANSFERRED_TO_CERCLA',
  ResponsiblePartiesHaveFledTheCountry = 'RESPONSIBLE_PARTIES_HAVE_FLED_THE_COUNTRY',
  SiteInBankruptcy = 'SITE_IN_BANKRUPTCY',
  SiteInLitigation = 'SITE_IN_LITIGATION'
}

export enum RcraInfoDataOrigin {
  DataEntry = 'DATA_ENTRY',
  Emanifest = 'EMANIFEST',
  Emergency = 'EMERGENCY',
  ManualLoad = 'MANUAL_LOAD',
  Myrcraid = 'MYRCRAID',
  RcrainfoBrLoadUtility = 'RCRAINFO_BR_LOAD_UTILITY',
  RcrainfoIndustryApplication = 'RCRAINFO_INDUSTRY_APPLICATION',
  Translation = 'TRANSLATION',
  Utility = 'UTILITY'
}

export enum RcraInfoFederalWasteGeneratorStatus {
  LargeQuantityGenerator = 'LARGE_QUANTITY_GENERATOR',
  NotAGenerator = 'NOT_A_GENERATOR',
  Pending = 'PENDING',
  SmallQuantityGenerator = 'SMALL_QUANTITY_GENERATOR',
  Undetermined = 'UNDETERMINED',
  VerySmallQuantityGenerator = 'VERY_SMALL_QUANTITY_GENERATOR'
}

export enum RcraInfoLandType {
  County = 'COUNTY',
  District = 'DISTRICT',
  Federal = 'FEDERAL',
  Municipal = 'MUNICIPAL',
  Other = 'OTHER',
  Private = 'PRIVATE',
  State = 'STATE',
  Tribal = 'TRIBAL'
}

export enum RcraInfoNonNotifier {
  FormerNonNotifier = 'FORMER_NON_NOTIFIER',
  NonNotifier = 'NON_NOTIFIER',
  NonNotifierDeterminedToBeExempt = 'NON_NOTIFIER_DETERMINED_TO_BE_EXEMPT'
}

export enum RcraInfoOwnerOperatorIndicator {
  CurrentOperator = 'CURRENT_OPERATOR',
  CurrentOwner = 'CURRENT_OWNER',
  PreviousOperator = 'PREVIOUS_OPERATOR',
  PreviousOwner = 'PREVIOUS_OWNER'
}

export enum RcraInfoSourceType {
  Deactivation = 'DEACTIVATION',
  ElectronicManifestBroker = 'ELECTRONIC_MANIFEST_BROKER',
  Emergency = 'EMERGENCY',
  Implementer = 'IMPLEMENTER',
  Notification = 'NOTIFICATION',
  PartA = 'PART_A',
  Report = 'REPORT',
  ReportUpdateWithNotification = 'REPORT_UPDATE_WITH_NOTIFICATION',
  Temporary = 'TEMPORARY'
}

export type ReadT2sFileResponse = {
  __typename?: 'ReadT2sFileResponse';
  facilities: Array<T2sReadFacility>;
  reportingYear: Scalars['Int'];
};

export type RecipientInput = {
  communicationType?: InputMaybe<CommunicationType>;
  coverLetterDocumentId?: InputMaybe<Scalars['ID']>;
  emailBody?: InputMaybe<Scalars['String']>;
  emailRecipientAddresses?: InputMaybe<Array<Scalars['String']>>;
  emailReplyTo?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  emailTemplateName?: InputMaybe<Scalars['String']>;
  fireDepartmentId?: InputMaybe<Scalars['ID']>;
  leadAgencyId?: InputMaybe<Scalars['Int']>;
  lepcId?: InputMaybe<Scalars['ID']>;
  mailRecipientAddressLine1?: InputMaybe<Scalars['String']>;
  mailRecipientAddressLine2?: InputMaybe<Scalars['String']>;
  mailRecipientCity?: InputMaybe<Scalars['String']>;
  mailRecipientState?: InputMaybe<Scalars['String']>;
  mailRecipientZip?: InputMaybe<Scalars['String']>;
  policeDepartmentId?: InputMaybe<Scalars['Int']>;
  recipientName?: InputMaybe<Scalars['String']>;
};

export enum ReconciliationStatus {
  Problem = 'PROBLEM',
  Reconciled = 'RECONCILED',
  Unreconciled = 'UNRECONCILED'
}

export enum RegulatoryStatusOption {
  LargeQuantityGenerator = 'LARGE_QUANTITY_GENERATOR',
  None = 'NONE',
  SmallQuantityGenerator = 'SMALL_QUANTITY_GENERATOR',
  VerySmallQuantityGenerator = 'VERY_SMALL_QUANTITY_GENERATOR'
}

export type ReportSafeToResetResponse = {
  __typename?: 'ReportSafeToResetResponse';
  activities?: Maybe<Array<Maybe<ActivitySafeToResetResponse>>>;
  isSafeToReset: Scalars['Boolean'];
  unsafeResetReasons: Array<Scalars['String']>;
};

export type ReportTagUpdate = {
  reportId: Scalars['ID'];
  tags: Array<Scalars['String']>;
};

export type ReportingFacilityChemical = {
  __typename?: 'ReportingFacilityChemical';
  aggregationError?: Maybe<Scalars['JSON']>;
  aggregationErrorMessage?: Maybe<Scalars['String']>;
  averageAmount?: Maybe<Scalars['Float']>;
  averageAmountCode?: Maybe<Scalars['Int']>;
  chemical?: Maybe<Chemical>;
  chemicalId: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  daysOnSite?: Maybe<Scalars['Int']>;
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isAlwaysReported?: Maybe<Scalars['Boolean']>;
  isOverThreshold?: Maybe<Scalars['Boolean']>;
  issueCount?: Maybe<Scalars['Int']>;
  issues: Array<Issue>;
  jurisdictions: Array<Scalars['String']>;
  manuallyEdited?: Maybe<Scalars['Boolean']>;
  maxAmount?: Maybe<Scalars['Float']>;
  maxAmountCode?: Maybe<Scalars['Int']>;
  maxAmountLargestContainer?: Maybe<Scalars['Float']>;
  maxAmountProductChemicalBreakdown?: Maybe<ProductChemicalBreakdown>;
  origin?: Maybe<ReportingFacilityChemicalOrigin>;
  previousYearMaxAmount?: Maybe<AmountWithUnit>;
  reportingYear: Scalars['Int'];
  stateFields: Array<DynamicField>;
  storageLocations?: Maybe<Array<ReportingFacilityChemicalStorageLocation>>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  willReport?: Maybe<Scalars['Boolean']>;
};

export type ReportingFacilityChemicalCountsResult = {
  __typename?: 'ReportingFacilityChemicalCountsResult';
  allChemicalsCount: Scalars['Int'];
  chemicalsToReportCount: Scalars['Int'];
};

export type ReportingFacilityChemicalInput = {
  averageAmount?: InputMaybe<Scalars['Float']>;
  averageAmountCode?: InputMaybe<Scalars['Int']>;
  chemicalId?: InputMaybe<Scalars['ID']>;
  daysOnSite?: InputMaybe<Scalars['Int']>;
  facilityId: Scalars['ID'];
  hasConfidentialStorageLocations?: InputMaybe<Scalars['Boolean']>;
  isAlwaysReported?: InputMaybe<Scalars['Boolean']>;
  isOverThreshold?: InputMaybe<Scalars['Boolean']>;
  manuallyEdited?: InputMaybe<Scalars['Boolean']>;
  maxAmount?: InputMaybe<Scalars['Float']>;
  maxAmountCode?: InputMaybe<Scalars['Int']>;
  maxAmountLargestContainer?: InputMaybe<Scalars['Float']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  stateFields?: InputMaybe<Array<DynamicFieldInput>>;
  storageLocations?: InputMaybe<Array<FacilityChemicalStorageLocationInput>>;
  unit?: InputMaybe<UnitType>;
};

export type ReportingFacilityChemicalOrigin = {
  __typename?: 'ReportingFacilityChemicalOrigin';
  facilityChemical?: Maybe<FacilityChemical>;
  facilityChemicalId?: Maybe<Scalars['ID']>;
  facilityChemicalMeasurements?: Maybe<Array<FacilityChemicalMeasurement>>;
  facilityProductMeasurements?: Maybe<Array<FacilityProductMeasurement>>;
  facilityProducts?: Maybe<Array<FacilityProduct>>;
  id: Scalars['ID'];
};

export type ReportingFacilityChemicalStorageLocation = {
  __typename?: 'ReportingFacilityChemicalStorageLocation';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  maxAmount?: Maybe<Scalars['Float']>;
  otherPressureValue?: Maybe<Scalars['String']>;
  pressure?: Maybe<Pressure>;
  reportingFacilityChemical?: Maybe<ReportingFacilityChemical>;
  reportingFacilityChemicalId: Scalars['ID'];
  storageLocation?: Maybe<StorageLocation>;
  storageLocationId: Scalars['ID'];
  storageType?: Maybe<Scalars['String']>;
  storageTypeDescription?: Maybe<Scalars['String']>;
  temperature?: Maybe<Temperature>;
  unit?: Maybe<UnitType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type ReportingFacilityChemicalsResult = {
  __typename?: 'ReportingFacilityChemicalsResult';
  count: Scalars['Int'];
  items: Array<ReportingFacilityChemical>;
};

export type ReportingSeasonSummary = {
  __typename?: 'ReportingSeasonSummary';
  facilitiesTotal: Scalars['Int'];
  noReportsTotal: Scalars['Int'];
  organizationSummaries: Array<UnverifiedSummary>;
  reportsInAwaitingVerification: Scalars['Int'];
  reportsInFilingComplete: Scalars['Int'];
  reportsInNotReporting: Scalars['Int'];
  reportsInProcessing: Scalars['Int'];
  reportsTotal: Scalars['Int'];
  reportsUnverified: Scalars['Int'];
  staffSummaries: Array<StaffSummary>;
  stateSummaries: Array<UnverifiedSummary>;
  workflowsCountAutomation: Scalars['Int'];
  workflowsCountError: Scalars['Int'];
  workflowsCountHuman: Scalars['Int'];
  workflowsCountWaitForAll: Scalars['Int'];
  year: Scalars['Int'];
};

export type RequeueActivitiesResult = {
  __typename?: 'RequeueActivitiesResult';
  activitiesUpdated: Array<Scalars['ID']>;
  updatedCount: Scalars['Int'];
};

export type RequiredStaffInputItem = {
  __typename?: 'RequiredStaffInputItem';
  inputType?: Maybe<StaffInputType>;
  name: StaffInput;
};

export type RequiredStaffInputResult = {
  __typename?: 'RequiredStaffInputResult';
  activityType?: Maybe<Scalars['String']>;
  consolidated?: Maybe<Scalars['String']>;
  jurisdictionType?: Maybe<Scalars['String']>;
  links?: Maybe<Array<StaffInputLink>>;
  requiredStaffInputs: Array<RequiredStaffInputItem>;
};

export type Requirement = {
  __typename?: 'Requirement';
  facilityId: Scalars['ID'];
  facilityName: Scalars['String'];
  frequency: Frequency;
  id: Scalars['ID'];
  interval: Scalars['Int'];
  nextDueDate?: Maybe<Scalars['String']>;
  requirementJurisdictions?: Maybe<Array<Scalars['String']>>;
  requirementStatus?: Maybe<RequirementStatus>;
  state: Scalars['String'];
  submissionId: Scalars['ID'];
  submissionType: Scalars['String'];
  taskDescription?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
  tenantName: Scalars['String'];
};

export enum RequirementStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED'
}

export type RequirementsOptInOptOutResult = {
  __typename?: 'RequirementsOptInOptOutResult';
  comments: Array<Comment>;
  updatedCount: Scalars['Int'];
};

export type RequirementsResult = {
  __typename?: 'RequirementsResult';
  count: Scalars['Int'];
  items: Array<Requirement>;
};

export type ResetReportInput = {
  encampStatus: TierIiReportEncampStatus;
  organizationStatus: TierIiReportOrgStatus;
  reportId: Scalars['ID'];
  safetyOverride?: InputMaybe<Scalars['Boolean']>;
  shouldForceCancelWorkflow?: InputMaybe<Scalars['Boolean']>;
  shouldForceReSnapshot?: InputMaybe<Scalars['Boolean']>;
  untouchedSteps?: InputMaybe<Array<TierIiReportStep>>;
};

export enum ReviewMode {
  Parallel = 'PARALLEL',
  Sequential = 'SEQUENTIAL'
}

export enum ReviewerStatus {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  None = 'NONE',
  NotCompleted = 'NOT_COMPLETED',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export type Role = {
  __typename?: 'Role';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
};

export type SafeToSendToReviewersResponse = {
  __typename?: 'SafeToSendToReviewersResponse';
  id: Scalars['ID'];
  isSafe: Scalars['Boolean'];
  reasons: Array<Scalars['String']>;
  submission: Submission;
};

export type SafeToUpdateSubmissionResponse = {
  __typename?: 'SafeToUpdateSubmissionResponse';
  id: Scalars['ID'];
  isSafe: Scalars['Boolean'];
  reasons: Array<Scalars['String']>;
  submission: Submission;
};

export type SchemaSegment = {
  __typename?: 'SchemaSegment';
  id?: Maybe<Scalars['String']>;
  model: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type SelectedEchoExporterFields = {
  __typename?: 'SelectedEchoExporterFields';
  dfrUrl?: Maybe<Scalars['String']>;
  facActiveFlag?: Maybe<Scalars['Boolean']>;
  facCity?: Maybe<Scalars['String']>;
  facLat?: Maybe<Scalars['Float']>;
  facLong?: Maybe<Scalars['Float']>;
  facNaicsCodes: Array<Scalars['String']>;
  facName?: Maybe<Scalars['String']>;
  facState?: Maybe<Scalars['String']>;
  facStreet?: Maybe<Scalars['String']>;
  facZip?: Maybe<Scalars['String']>;
  npdesIds: Array<Scalars['String']>;
  rcraIds: Array<Scalars['String']>;
  registryId: Scalars['String'];
};

export type SendLobCheckInput = {
  activityId?: InputMaybe<Scalars['ID']>;
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  amount: Scalars['Float'];
  associations: Array<PaymentAssociation>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  invoiceDocumentId: Scalars['ID'];
  invoiceNumber?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  payeeType: Payee;
  recipient: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  tenantId: Scalars['ID'];
  zip: Scalars['String'];
};

export type SetChemicalFlagResult = {
  __typename?: 'SetChemicalFlagResult';
  succeeded: Scalars['Boolean'];
};

export type SetCollectionModeResult = {
  __typename?: 'SetCollectionModeResult';
  facilities: Array<Facility>;
  succeeded?: Maybe<Scalars['Boolean']>;
};

export type SetWasteFlagResult = {
  __typename?: 'SetWasteFlagResult';
  succeeded: Scalars['Boolean'];
};

export enum SignatureStatus {
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  None = 'NONE',
  NotCompleted = 'NOT_COMPLETED',
  Revoked = 'REVOKED'
}

export enum SignatureType {
  Digital = 'DIGITAL',
  None = 'NONE',
  WetInk = 'WET_INK'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortModel = {
  field: Scalars['String'];
  sort?: InputMaybe<Scalars['String']>;
};

export type SplitCohortResult = {
  __typename?: 'SplitCohortResult';
  closedCohort: Cohort;
  newCohort: Cohort;
};

export enum StaffInput {
  Certification = 'Certification',
  Check = 'Check',
  CoverLetter = 'CoverLetter',
  FeeCalculation = 'FeeCalculation',
  Fees = 'Fees',
  Form = 'Form',
  Invoice = 'Invoice',
  Other = 'Other',
  Proof = 'Proof',
  Receipt = 'Receipt',
  Report = 'Report',
  Submission = 'Submission'
}

export type StaffInputLink = {
  __typename?: 'StaffInputLink';
  link: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export enum StaffInputType {
  File = 'File',
  Numeric = 'Numeric'
}

export enum StaffReportType {
  BillingAnalysis = 'BillingAnalysis',
  CersReportSubmissionStatus = 'CERSReportSubmissionStatus',
  CancelledPayments = 'CancelledPayments',
  FacilityBilling = 'FacilityBilling',
  NewUsers = 'NewUsers',
  NewlyNotReportingFacilities = 'NewlyNotReportingFacilities',
  NotReportingAnalysis = 'NotReportingAnalysis',
  Rbr = 'RBR',
  TierIiValidation = 'TierIIValidation',
  YtdOverThreshold = 'YtdOverThreshold'
}

export type StaffSummary = {
  __typename?: 'StaffSummary';
  completedCount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  reportCount: Scalars['Int'];
};

export type StateFieldInfoInput = {
  jurisdiction: Scalars['String'];
  key: Scalars['String'];
  type: ProgramArea;
};

export enum StateOfMatter {
  Gas = 'GAS',
  Liquid = 'LIQUID',
  Solid = 'SOLID'
}

export enum StateRegulatoryStatus {
  ConditionallyExemptSmallQuantityGenerator = 'CONDITIONALLY_EXEMPT_SMALL_QUANTITY_GENERATOR',
  KansasSmallQuantityGenerator = 'KANSAS_SMALL_QUANTITY_GENERATOR',
  LargeQuantityGenerator = 'LARGE_QUANTITY_GENERATOR',
  MarylandGeneratorFullyRegulated = 'MARYLAND_GENERATOR_FULLY_REGULATED',
  MediumQuantityGenerator = 'MEDIUM_QUANTITY_GENERATOR',
  MiniQuantityGenerator = 'MINI_QUANTITY_GENERATOR',
  NotAGenerator = 'NOT_A_GENERATOR',
  Pending = 'PENDING',
  SameAsFederal = 'SAME_AS_FEDERAL',
  SmallQuantityGenerator = 'SMALL_QUANTITY_GENERATOR',
  TexasClass_1OnlyGenerator = 'TEXAS_CLASS_1_ONLY_GENERATOR',
  Undetermined = 'UNDETERMINED',
  VerySmallQuantityGenerator = 'VERY_SMALL_QUANTITY_GENERATOR'
}

export type StorageLocation = {
  __typename?: 'StorageLocation';
  CA_gridNumber?: Maybe<Scalars['String']>;
  CA_mapNumber?: Maybe<Scalars['String']>;
  OR_insideOutside?: Maybe<InsideOutside>;
  OR_storageArea?: Maybe<Scalars['String']>;
  OR_storageBuilding?: Maybe<Scalars['String']>;
  OR_storageFloor?: Maybe<Scalars['String']>;
  OR_storageQuadrant?: Maybe<StorageQuadrant>;
  OR_storageRoom?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  facility: Facility;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type StorageLocationInput = {
  CA_gridNumber?: InputMaybe<Scalars['String']>;
  CA_mapNumber?: InputMaybe<Scalars['String']>;
  OR_insideOutside?: InputMaybe<InsideOutside>;
  OR_storageArea?: InputMaybe<Scalars['String']>;
  OR_storageBuilding?: InputMaybe<Scalars['String']>;
  OR_storageFloor?: InputMaybe<Scalars['String']>;
  OR_storageQuadrant?: InputMaybe<StorageQuadrant>;
  OR_storageRoom?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type StorageLocationsResult = {
  __typename?: 'StorageLocationsResult';
  count: Scalars['Int'];
  items: Array<StorageLocation>;
};

export enum StorageQuadrant {
  C = 'C',
  E = 'E',
  N = 'N',
  Ne = 'NE',
  Nw = 'NW',
  S = 'S',
  Se = 'SE',
  Sw = 'SW',
  V = 'V',
  W = 'W'
}

export type Submission = {
  __typename?: 'Submission';
  comments: Array<Comment>;
  communications: Array<Communication>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  documents?: Maybe<Array<SubmissionDocument>>;
  dueDate?: Maybe<Scalars['DateTime']>;
  facilitySubmissions: Array<FacilitySubmission>;
  id: Scalars['ID'];
  issues: Array<Issue>;
  metadata?: Maybe<Scalars['JSON']>;
  notes?: Maybe<Scalars['String']>;
  notifications: Array<Notification>;
  payments: Array<SubmissionPayment>;
  recipient?: Maybe<Scalars['String']>;
  reportingPeriodEnd?: Maybe<Scalars['DateTime']>;
  reportingPeriodStart?: Maybe<Scalars['DateTime']>;
  requirementStatus?: Maybe<RequirementStatus>;
  reviewMode: ReviewMode;
  reviewRequired: Scalars['Boolean'];
  reviewers: Array<SubmissionReviewer>;
  signatureType?: Maybe<SignatureType>;
  signedAt?: Maybe<Scalars['DateTime']>;
  staffAssignee?: Maybe<User>;
  status: SubmissionStatus;
  submissionMethod?: Maybe<SubmissionMethod>;
  submissionType: SubmissionType;
  submittedAt?: Maybe<Scalars['DateTime']>;
  tags: Array<SubmissionTag>;
  tenantId: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type SubmissionCommentInputForValidation = {
  activityId?: InputMaybe<Scalars['ID']>;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  isSystemMessage?: InputMaybe<Scalars['Boolean']>;
  reportId?: InputMaybe<Scalars['ID']>;
  submissionId?: InputMaybe<Scalars['ID']>;
  workflowId?: InputMaybe<Scalars['ID']>;
};

export type SubmissionDocument = {
  __typename?: 'SubmissionDocument';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  document: Document;
  documentId: Scalars['ID'];
  documentSource: DocumentSource;
  externalDocumentId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  reviewRequired: Scalars['Boolean'];
  status?: Maybe<DocumentStatus>;
  submissionDocumentReviews: Array<SubmissionDocumentReview>;
  submissionId: Scalars['ID'];
  type: SubmissionDocumentType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type SubmissionDocumentInputForValidation = {
  documentId: Scalars['ID'];
  type: SubmissionDocumentType;
};

export type SubmissionDocumentReview = {
  __typename?: 'SubmissionDocumentReview';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  hasViewed: Scalars['Boolean'];
  id: Scalars['ID'];
  reviewerStatus?: Maybe<ReviewerStatus>;
  signatureStatus?: Maybe<SignatureStatus>;
  submissionDocument?: Maybe<SubmissionDocument>;
  submissionDocumentId: Scalars['ID'];
  submissionReviewer?: Maybe<SubmissionReviewer>;
  submissionReviewerId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export enum SubmissionDocumentType {
  Attachment = 'ATTACHMENT',
  RejectedSubmission = 'REJECTED_SUBMISSION',
  SignedSubmission = 'SIGNED_SUBMISSION',
  Submission = 'SUBMISSION'
}

export type SubmissionErrorStatsResult = {
  __typename?: 'SubmissionErrorStatsResult';
  errorsByAssignee: Array<SubmissionErrorStatsResultItem>;
  errorsByCustomer: Array<SubmissionErrorStatsResultItem>;
  errorsByState: Array<SubmissionErrorStatsResultItem>;
  reportsCurrentlyBlockedByErrors: Scalars['Int'];
};

export type SubmissionErrorStatsResultItem = {
  __typename?: 'SubmissionErrorStatsResultItem';
  name?: Maybe<Scalars['String']>;
  val: Scalars['Int'];
};

export type SubmissionInputForValidation = {
  comment?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Array<SubmissionCommentInputForValidation>>;
  documents?: InputMaybe<Array<SubmissionDocumentInputForValidation>>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  notes?: InputMaybe<Scalars['String']>;
  recipient: Scalars['String'];
  reviewMode: ReviewMode;
  reviewRequired: Scalars['Boolean'];
  reviewers?: InputMaybe<Array<SubmissionReviewerInputForValidation>>;
  signatureType: SignatureType;
  submissionMethod?: InputMaybe<SubmissionMethod>;
  submissionType?: InputMaybe<SubmissionType>;
  tenantId: Scalars['String'];
  title: Scalars['String'];
};

export enum SubmissionMethod {
  AzMydeqPortal = 'AZ_MYDEQ_PORTAL',
  CaEvqModule = 'CA_EVQ_MODULE',
  CountyPdfsOrPortals = 'COUNTY_PDFS_OR_PORTALS',
  CoSelfCertPortal = 'CO_SELF_CERT_PORTAL',
  DcSqgSelfCertificationPortal = 'DC_SQG_SELF_CERTIFICATION_PORTAL',
  HennepinHazwastePortal = 'HENNEPIN_HAZWASTE_PORTAL',
  IdPortal = 'ID_PORTAL',
  KsKeimsPortal = 'KS_KEIMS_PORTAL',
  KyGatewayPortal = 'KY_GATEWAY_PORTAL',
  MoMogems = 'MO_MOGEMS',
  MpcaEServices = 'MPCA_E_SERVICES',
  OrPortal = 'OR_PORTAL',
  PaperForm = 'PAPER_FORM',
  RcrainfoAnnualReportingModule = 'RCRAINFO_ANNUAL_REPORTING_MODULE',
  RcrainfoBiennialReportingModule = 'RCRAINFO_BIENNIAL_REPORTING_MODULE',
  RcrainfoMyrcraidModule = 'RCRAINFO_MYRCRAID_MODULE',
  TxSteersPortal = 'TX_STEERS_PORTAL',
  WaSawsTurboplan = 'WA_SAWS_TURBOPLAN',
  WiDnrSwitchboard = 'WI_DNR_SWITCHBOARD'
}

export type SubmissionPayment = {
  __typename?: 'SubmissionPayment';
  amount?: Maybe<Scalars['FlexibleFloat']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  payment: Payment;
  paymentId: Scalars['ID'];
  submission: Submission;
  submissionId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type SubmissionReviewer = {
  __typename?: 'SubmissionReviewer';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  dueDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  isSigner: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  reviewOrder: Scalars['Int'];
  submissionDocumentReviews: Array<SubmissionDocumentReview>;
  submissionId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['ID'];
};

export type SubmissionReviewerInput = {
  dueDate?: InputMaybe<Scalars['DateTime']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  isSigner?: InputMaybe<Scalars['Boolean']>;
  isStaff?: InputMaybe<Scalars['Boolean']>;
  reviewOrder: Scalars['Int'];
  userId: Scalars['ID'];
};

export type SubmissionReviewerInputForValidation = {
  dueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  isRequired: Scalars['Boolean'];
  isSigner: Scalars['Boolean'];
  isStaff: Scalars['Boolean'];
  reviewOrder: Scalars['Int'];
  userId: Scalars['String'];
};

export enum SubmissionStatus {
  EncampInitialReview = 'ENCAMP_INITIAL_REVIEW',
  FilingComplete = 'FILING_COMPLETE',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  NotReporting = 'NOT_REPORTING',
  NotStarted = 'NOT_STARTED',
  ProcessingSubmission = 'PROCESSING_SUBMISSION'
}

export type SubmissionTag = {
  __typename?: 'SubmissionTag';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  submission: Submission;
  submissionId: Scalars['ID'];
  tag: Tag;
  tagId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export enum SubmissionType {
  AlAnnualNotification = 'AL_ANNUAL_NOTIFICATION',
  AnnualReport = 'ANNUAL_REPORT',
  AzGenerationReport = 'AZ_GENERATION_REPORT',
  AzP2AnnualProgressReport = 'AZ_P2_ANNUAL_PROGRESS_REPORT',
  AzRegistrationReport = 'AZ_REGISTRATION_REPORT',
  BiennialReport = 'BIENNIAL_REPORT',
  CaEvq = 'CA_EVQ',
  CoSqgSelfCertification = 'CO_SQG_SELF_CERTIFICATION',
  DcAnnualReport = 'DC_ANNUAL_REPORT',
  GaBiennialHazardousWasteReductionPlan = 'GA_BIENNIAL_HAZARDOUS_WASTE_REDUCTION_PLAN',
  IaAnnualReport = 'IA_ANNUAL_REPORT',
  IdAnnualReport = 'ID_ANNUAL_REPORT',
  KsAnnualReport = 'KS_ANNUAL_REPORT',
  KyAnnualReport = 'KY_ANNUAL_REPORT',
  KyRegistrationReport = 'KY_REGISTRATION_REPORT',
  MeAnnualReport = 'ME_ANNUAL_REPORT',
  MnCountyLicenseRenewals = 'MN_COUNTY_LICENSE_RENEWALS',
  MnHennepinCountyLicenseRenewal = 'MN_HENNEPIN_COUNTY_LICENSE_RENEWAL',
  MnMpcaLicenseRenewal = 'MN_MPCA_LICENSE_RENEWAL',
  MoAnnualReport = 'MO_ANNUAL_REPORT',
  MsP2AnnualProgressReport = 'MS_P2_ANNUAL_PROGRESS_REPORT',
  MtAnnualReport = 'MT_ANNUAL_REPORT',
  NhQuarterlyActivityReport = 'NH_QUARTERLY_ACTIVITY_REPORT',
  NhTriennialReport = 'NH_TRIENNIAL_REPORT',
  NyHazardousWasteReductionPlan = 'NY_HAZARDOUS_WASTE_REDUCTION_PLAN',
  NyQuarterlyWasteTaxes = 'NY_QUARTERLY_WASTE_TAXES',
  OrAnnualReport = 'OR_ANNUAL_REPORT',
  ScQuarterlyReport = 'SC_QUARTERLY_REPORT',
  ScSqgAnnualNotification = 'SC_SQG_ANNUAL_NOTIFICATION',
  TxAnnualWasteSummary = 'TX_ANNUAL_WASTE_SUMMARY',
  TxP2AnnualProgressReport = 'TX_P2_ANNUAL_PROGRESS_REPORT',
  WasteBiennial = 'WASTE_BIENNIAL',
  WaP2AnnualProgressReport = 'WA_P2_ANNUAL_PROGRESS_REPORT',
  WiAnnualReport = 'WI_ANNUAL_REPORT',
  WvHwGeneratorFees = 'WV_HW_GENERATOR_FEES'
}

export type SubmissionsResult = {
  __typename?: 'SubmissionsResult';
  count: Scalars['Int'];
  items: Array<Submission>;
};

export type SupplementalFireDepartment = {
  __typename?: 'SupplementalFireDepartment';
  facilityId: Scalars['String'];
  fireDepartment: FireDepartment;
  fireDepartmentId: Scalars['String'];
  id: Scalars['String'];
};

export type SupplementalLepc = {
  __typename?: 'SupplementalLepc';
  facilityId: Scalars['String'];
  id: Scalars['String'];
  lepc: Lepc;
  lepcId: Scalars['String'];
};

export type T2sImportInput = {
  documentId: Scalars['ID'];
  facilityIds: Array<InputMaybe<Scalars['ID']>>;
  reportingYear: Scalars['Int'];
};

export type T2sReadFacility = {
  __typename?: 'T2sReadFacility';
  chemicals: Scalars['Int'];
  city?: Maybe<Scalars['String']>;
  contacts: Scalars['Int'];
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type Tag = {
  __typename?: 'Tag';
  description?: Maybe<Scalars['String']>;
  facilities?: Maybe<Array<Facility>>;
  icon?: Maybe<TagIcon>;
  id: Scalars['String'];
  isDisabled: Scalars['Boolean'];
  isInternal: Scalars['Boolean'];
  name: Scalars['String'];
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  type: TagType;
};

export enum TagIcon {
  BadgeCheck = 'BADGE_CHECK',
  FolderOpen = 'FOLDER_OPEN',
  RadiationAlt = 'RADIATION_ALT',
  Recycle = 'RECYCLE',
  Trash = 'TRASH',
  UserHardHat = 'USER_HARD_HAT',
  Water = 'WATER',
  Wind = 'WIND'
}

export type TagInput = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum TagType {
  Document = 'Document',
  Facility = 'Facility',
  Task = 'Task',
  Waste = 'Waste'
}

export type TagsResult = {
  __typename?: 'TagsResult';
  count: Scalars['Int'];
  items: Array<Tag>;
};

export enum TankOwnerType {
  CountyAgency = 'COUNTY_AGENCY',
  FederalAgency = 'FEDERAL_AGENCY',
  LocalAgency = 'LOCAL_AGENCY',
  NonGovernment = 'NON_GOVERNMENT',
  StateAgency = 'STATE_AGENCY'
}

export type Task = {
  __typename?: 'Task';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ID']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['Date'];
  facilities: Array<Facility>;
  frequency: Frequency;
  id: Scalars['ID'];
  interval: Scalars['Int'];
  seriesId: Scalars['ID'];
  startDate: Scalars['Date'];
  submission?: Maybe<Submission>;
  taskTags: Array<TaskTag>;
  tenantId: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type TaskTag = {
  __typename?: 'TaskTag';
  id: Scalars['ID'];
  tag: Tag;
};

export enum Temperature {
  AmbientTemperature = 'AMBIENT_TEMPERATURE',
  CryogenicConditions = 'CRYOGENIC_CONDITIONS',
  GreaterThanAmbientTemperature = 'GREATER_THAN_AMBIENT_TEMPERATURE',
  LessThanAmbientTemperatureButNotCryogenic = 'LESS_THAN_AMBIENT_TEMPERATURE_BUT_NOT_CRYOGENIC'
}

export type Tenant = {
  __typename?: 'Tenant';
  contactCount?: Maybe<Scalars['Int']>;
  demoDataJobQueued?: Maybe<Scalars['Boolean']>;
  facilityCount?: Maybe<Scalars['Int']>;
  featureFlags: Scalars['JSON'];
  id: Scalars['ID'];
  isDemo: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
  isPartner: Scalars['Boolean'];
  name: Scalars['String'];
  partnerTenant?: Maybe<Tenant>;
  partnerTenantId?: Maybe<Scalars['ID']>;
  partnersTenants: Array<Tenant>;
  ssoDomains?: Maybe<Array<Scalars['String']>>;
  ssoMappingName?: Maybe<Scalars['String']>;
};

export type TenantInput = {
  copyDemoTenantId?: InputMaybe<Scalars['ID']>;
  copyWasteDemoTenantId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isDemo: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
  isPartner: Scalars['Boolean'];
  name: Scalars['String'];
  partnerTenantId?: InputMaybe<Scalars['ID']>;
  populateWithDemoData?: InputMaybe<Scalars['Boolean']>;
  useDefaultNaming?: InputMaybe<Scalars['Boolean']>;
};

export type TenantPrimitives = {
  __typename?: 'TenantPrimitives';
  contactCount?: Maybe<Scalars['Int']>;
  demoDataJobQueued?: Maybe<Scalars['Boolean']>;
  facilityCount?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  partnerTenantId?: Maybe<Scalars['ID']>;
};

export type TenantsResult = {
  __typename?: 'TenantsResult';
  count: Scalars['Int'];
  items: Array<Tenant>;
};

export type TierIiReport = {
  __typename?: 'TierIIReport';
  assignees: Array<TierIiReportAssignee>;
  cohortMemberships: Array<CohortMember>;
  comments?: Maybe<Array<Comment>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  currentWorkflow?: Maybe<Workflow>;
  department?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Document>>;
  encampStatus: TierIiReportEncampStatus;
  facility: Facility;
  facilityId: Scalars['ID'];
  filedBy?: Maybe<TierIiReportFiledBy>;
  filedOn?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  issues: Array<Issue>;
  notesToRegulators?: Maybe<Scalars['String']>;
  organizationStatus: TierIiReportOrgStatus;
  payments?: Maybe<Array<Payment>>;
  portalReportId?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Int']>;
  reasonForReport?: Maybe<Scalars['String']>;
  reportKind: TierIiReportKind;
  reportingYear: Scalars['Int'];
  requiresReviewers?: Maybe<Scalars['Boolean']>;
  reviewCompletedByUserId?: Maybe<Scalars['String']>;
  reviewers: Array<TierIiReportAssignee>;
  tags?: Maybe<Array<Scalars['String']>>;
  tenant: Tenant;
  tenantId: Scalars['ID'];
  touchedCASteps?: Maybe<Array<TierIiReportCaStep>>;
  touchedSteps?: Maybe<Array<TierIiReportStep>>;
  undergroundStorageTankStatuses?: Maybe<Array<TierIiReportUstStatus>>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['DateTime'];
  verifiedAt?: Maybe<Scalars['DateTime']>;
  verifiedByEncamp?: Maybe<Scalars['Boolean']>;
  verifierEmail?: Maybe<Scalars['String']>;
  verifierFullName?: Maybe<Scalars['String']>;
  verifierPhone?: Maybe<Scalars['String']>;
  verifierTitle?: Maybe<Scalars['String']>;
};

export type TierIiReportActivitiesResult = {
  __typename?: 'TierIIReportActivitiesResult';
  count: Scalars['Int'];
  items: Array<TierIiReportActivity>;
};

export type TierIiReportActivity = {
  __typename?: 'TierIIReportActivity';
  activityAssigneeEmail?: Maybe<Scalars['String']>;
  activityAssigneeFirst?: Maybe<Scalars['String']>;
  activityAssigneeLast?: Maybe<Scalars['String']>;
  activityDescription?: Maybe<Scalars['String']>;
  activityErrorMessage?: Maybe<Scalars['String']>;
  activityExecutionPlan?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  activityStatus?: Maybe<Scalars['String']>;
  activityType?: Maybe<Scalars['String']>;
  cersId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  customerFacilityId?: Maybe<Scalars['String']>;
  encampStatus?: Maybe<TierIiReportEncampStatus>;
  facilityId: Scalars['String'];
  facilityName: Scalars['String'];
  filedOn?: Maybe<Scalars['DateTime']>;
  hasIncompleteReviews?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isChampionReport?: Maybe<Scalars['Boolean']>;
  issueCount: Scalars['Int'];
  jobStatus?: Maybe<JobStatus>;
  organizationName: Scalars['String'];
  organizationStatus?: Maybe<TierIiReportOrgStatus>;
  partnerTenant?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Int']>;
  reportKind?: Maybe<Scalars['String']>;
  reportingYear?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  tenantId: Scalars['ID'];
  tierIIReportId?: Maybe<Scalars['ID']>;
  workflowId?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type TierIiReportAssignee = {
  __typename?: 'TierIIReportAssignee';
  assignmentType: AssignmentType;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  person: Person;
  personId: Scalars['ID'];
  tierIIReport: TierIiReport;
  tierIIReportId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type TierIiReportAssigneeInput = {
  assignmentType: AssignmentType;
  id?: InputMaybe<Scalars['ID']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  personId: Scalars['ID'];
  tierIIReportId: Scalars['ID'];
};

export enum TierIiReportCaStep {
  ApsaFacilityInformation = 'APSAFacilityInformation',
  AbovegroundPetroleumStorageActDocumentation = 'AbovegroundPetroleumStorageActDocumentation',
  EmergencyResponseContingencyPlan = 'EmergencyResponseContingencyPlan',
  EmployeeTrainingPlan = 'EmployeeTrainingPlan',
  FacilityInformation = 'FacilityInformation',
  HazardousWasteTankClosureCertificate = 'HazardousWasteTankClosureCertificate',
  OwnerStatementOfDesignatedUstOperatorCompliance = 'OwnerStatementOfDesignatedUSTOperatorCompliance',
  RecyclableMaterialsReportDocumentation = 'RecyclableMaterialsReportDocumentation',
  SitePlan = 'SitePlan',
  UstCertificationOfFinancialResponsibility = 'USTCertificationOfFinancialResponsibility',
  UstCertificationsOfInstallationModification = 'USTCertificationsOfInstallationModification',
  UstFacilityOperatingPermitApplication = 'USTFacilityOperatingPermitApplication',
  UstLetterFromChiefFinancialOfficer = 'USTLetterFromChiefFinancialOfficer',
  UstMonitoringSitePlan = 'USTMonitoringSitePlan',
  UstOwnerOperatorWrittenAgreement = 'USTOwnerOperatorWrittenAgreement',
  UstResponsePlan = 'USTResponsePlan'
}

export enum TierIiReportEncampStatus {
  AwaitingVerification = 'AWAITING_VERIFICATION',
  FilingComplete = 'FILING_COMPLETE',
  NotReporting = 'NOT_REPORTING',
  Processing = 'PROCESSING'
}

export enum TierIiReportFiledBy {
  Encamp = 'ENCAMP',
  Other = 'OTHER'
}

export enum TierIiReportKind {
  Annual = 'ANNUAL',
  Initial = 'INITIAL',
  Revision = 'REVISION',
  Update = 'UPDATE'
}

export enum TierIiReportOrgStatus {
  Assigned = 'ASSIGNED',
  InProgress = 'IN_PROGRESS',
  InReview = 'IN_REVIEW',
  NotReporting = 'NOT_REPORTING',
  NotStarted = 'NOT_STARTED',
  Verified = 'VERIFIED'
}

export type TierIiReportPayment = {
  __typename?: 'TierIIReportPayment';
  amount?: Maybe<Scalars['Float']>;
  tierIIReport?: Maybe<TierIiReport>;
};

export enum TierIiReportStep {
  Chemicals = 'CHEMICALS',
  ChemicalSummary = 'CHEMICAL_SUMMARY',
  Contacts = 'CONTACTS',
  Documents = 'DOCUMENTS',
  Facility = 'FACILITY',
  OtherChemicals = 'OTHER_CHEMICALS',
  Products = 'PRODUCTS',
  Regulatory = 'REGULATORY',
  ReportOverview = 'REPORT_OVERVIEW',
  Review = 'REVIEW',
  StateInformation = 'STATE_INFORMATION',
  VerifyAndSubmit = 'VERIFY_AND_SUBMIT'
}

export type TierIiReportTagsResult = {
  __typename?: 'TierIIReportTagsResult';
  id: Scalars['ID'];
  tags: Array<Scalars['String']>;
};

export type TierIiReportUstStatus = {
  __typename?: 'TierIIReportUstStatus';
  tierIIReportId: Scalars['ID'];
  touchedSteps: Array<Scalars['String']>;
  undergroundStorageTankId: Scalars['String'];
};

export enum TierIiReportUstStep {
  TankInformation = 'TankInformation',
  TankMonitoringPlan = 'TankMonitoringPlan'
}

export type TierIiReportVerifier = {
  isVerified?: InputMaybe<Scalars['Boolean']>;
  verifiedAt?: InputMaybe<Scalars['DateTime']>;
  verifierEmail?: InputMaybe<Scalars['String']>;
  verifierFullName?: InputMaybe<Scalars['String']>;
  verifierPhone?: InputMaybe<Scalars['String']>;
  verifierTitle?: InputMaybe<Scalars['String']>;
};

export type TierIiReportVerifierInput = {
  verifiedAt: Scalars['DateTime'];
  verifierEmail: Scalars['String'];
  verifierFullName: Scalars['String'];
  verifierPhone: Scalars['String'];
  verifierTitle: Scalars['String'];
};

export type TierIiReportsResult = {
  __typename?: 'TierIIReportsResult';
  count: Scalars['Int'];
  items: Array<TierIiReport>;
};

export type TotalQuantityByTsdf = {
  __typename?: 'TotalQuantityByTsdf';
  destinationFacilityId: Scalars['String'];
  destinationFacilityName: Scalars['String'];
  totalQuantityLbs: Scalars['Float'];
};

export type TotalQuantityByTsdfResult = {
  __typename?: 'TotalQuantityByTsdfResult';
  count: Scalars['Int'];
  items: Array<TotalQuantityByTsdf>;
  totalQuantityLbs: Scalars['Float'];
};

export type UndergroundStorageTank = {
  __typename?: 'UndergroundStorageTank';
  additionalDescription?: Maybe<Scalars['String']>;
  additionalInformation?: Maybe<Scalars['String']>;
  automaticTankGaugingAtgModelNumber?: Maybe<Scalars['String']>;
  automaticTankGaugingAtgPanelManufacturer?: Maybe<Scalars['String']>;
  automaticTankGaugingLeakTestFrequency?: Maybe<Scalars['String']>;
  automaticTankGaugingLeakTestFrequencyOther?: Maybe<Scalars['String']>;
  automaticTankGaugingProbeManufacturer?: Maybe<Scalars['String']>;
  automaticTankGaugingProbeModelNumber?: Maybe<Scalars['String']>;
  automaticTankGaugingProgrammedTankTests?: Maybe<Scalars['String']>;
  automaticTankGaugingProgrammedTankTestsOther?: Maybe<Scalars['String']>;
  capacityGallons?: Maybe<Scalars['FlexibleFloat']>;
  configuration?: Maybe<Scalars['String']>;
  constructionMaterial?: Maybe<Scalars['String']>;
  constructionMaterialOther?: Maybe<Scalars['String']>;
  constructionPrimaryContainment?: Maybe<Scalars['String']>;
  constructionPrimaryContainmentOther?: Maybe<Scalars['String']>;
  constructionSecondaryContainment?: Maybe<Scalars['String']>;
  constructionSecondaryContainmentOther?: Maybe<Scalars['String']>;
  constructionType?: Maybe<Scalars['String']>;
  continuousElectronicTankMonitoringEmpManufacturer?: Maybe<Scalars['String']>;
  continuousElectronicTankMonitoringEmpModelNumber?: Maybe<Scalars['String']>;
  continuousElectronicTankMonitoringLeakSensorManufacturer?: Maybe<Scalars['String']>;
  continuousElectronicTankMonitoringLeakSensorModelNumber?: Maybe<Scalars['String']>;
  continuousElectronicTankMonitoringSecondaryContainmentSystem?: Maybe<Scalars['String']>;
  corrosionProtection?: Maybe<Array<Scalars['String']>>;
  designatedOperatorTraining?: Maybe<Scalars['Boolean']>;
  electronicLineLeakDetectorFailureTriggersPumpShutdown?: Maybe<Scalars['Boolean']>;
  electronicLineLeakDetectorManufacturer?: Maybe<Scalars['String']>;
  electronicLineLeakDetectorModelNumber?: Maybe<Scalars['String']>;
  electronicLineLeakDetectorProgrammedInlineTesting?: Maybe<Scalars['String']>;
  electronicLineLeakDetectorTriggersAutoPumpShutdown?: Maybe<Scalars['Boolean']>;
  existingDiscoveredDate?: Maybe<Scalars['Date']>;
  facilityId: Scalars['ID'];
  fillComponentsInstalled?: Maybe<Array<Scalars['String']>>;
  firstNameResponsibility?: Maybe<Scalars['String']>;
  firstNameTitle?: Maybe<Scalars['String']>;
  hasUdcFailureTriggerShutdown?: Maybe<Scalars['Boolean']>;
  hasUdcLeakAlarmTriggerShutdown?: Maybe<Scalars['Boolean']>;
  hasUdcLeakDetection?: Maybe<Scalars['Boolean']>;
  hasUdcMonitoringStopFlow?: Maybe<Scalars['Boolean']>;
  hasUdcSecondaryLeakDetection?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  installationDate?: Maybe<Scalars['Date']>;
  integrityTestingFrequency?: Maybe<Scalars['String']>;
  integrityTestingFrequencyOther?: Maybe<Scalars['String']>;
  manufacturer?: Maybe<Scalars['String']>;
  mechanicalLineLeakDetectorManufacturer?: Maybe<Scalars['String']>;
  mechanicalLineLeakDetectorModelNumber?: Maybe<Scalars['String']>;
  monitoringEquipmentServiced?: Maybe<Scalars['String']>;
  monitoringEquipmentServicedOther?: Maybe<Scalars['String']>;
  nickname: Scalars['String'];
  numberOfCompartments?: Maybe<Scalars['FlexibleInt']>;
  otherMonitoring?: Maybe<Scalars['String']>;
  otherPipelineMonitoring?: Maybe<Scalars['String']>;
  otherTrainingDocuments?: Maybe<Scalars['String']>;
  overfillProtection?: Maybe<Array<Scalars['String']>>;
  periodicSystemTesting?: Maybe<Array<Scalars['String']>>;
  permanentlyClosedDate?: Maybe<Scalars['Date']>;
  pipeMonitoringMethod?: Maybe<Array<Scalars['String']>>;
  pipeSecContainmentMonitoringFailureTriggersPumpShutdown?: Maybe<Scalars['Boolean']>;
  pipeSecContainmentMonitoringLeakAlarmTriggersAutoPumpShutdown?: Maybe<Scalars['Boolean']>;
  pipeSecContainmentMonitoringLeakSensorManufacturer?: Maybe<Scalars['String']>;
  pipeSecContainmentMonitoringLeakSensorModelNumber?: Maybe<Scalars['String']>;
  pipeSecContainmentMonitoringPanelManufacturer?: Maybe<Scalars['String']>;
  pipeSecContainmentMonitoringPanelModelNumber?: Maybe<Scalars['String']>;
  pipeSecContainmentMonitoringPipingSecondaryContainment?: Maybe<Scalars['String']>;
  pipelineIntegrityTestingFrequency?: Maybe<Scalars['String']>;
  pipelineIntegrityTestingFrequencyOther?: Maybe<Scalars['String']>;
  pipingConstruction?: Maybe<Scalars['String']>;
  pipingSystemType?: Maybe<Scalars['String']>;
  pipingTurbineContainmentSump?: Maybe<Scalars['String']>;
  previouslyReported: Scalars['Boolean'];
  productWastePrimaryContainment?: Maybe<Scalars['String']>;
  productWastePrimaryContainmentOther?: Maybe<Scalars['String']>;
  productWasteSecondaryContainment?: Maybe<Scalars['String']>;
  productWasteSecondaryContainmentOther?: Maybe<Scalars['String']>;
  recordKeeping?: Maybe<Array<Scalars['String']>>;
  riserPipePrimaryContainment?: Maybe<Scalars['String']>;
  riserPipePrimaryContainmentOther?: Maybe<Scalars['String']>;
  riserPipeSecondaryContainment?: Maybe<Scalars['String']>;
  riserPipeSecondaryContainmentOther?: Maybe<Scalars['String']>;
  secondNameResponsibility?: Maybe<Scalars['String']>;
  secondNameTitle?: Maybe<Scalars['String']>;
  sitePlotPlanSubmitted?: Maybe<Scalars['String']>;
  tankContents?: Maybe<Scalars['String']>;
  tankContentsOther?: Maybe<Scalars['String']>;
  tankId: Scalars['String'];
  tankMonitoringMethod?: Maybe<Array<Scalars['String']>>;
  tankUsage?: Maybe<Scalars['String']>;
  tankUsageOther?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  typeOfAction?: Maybe<Scalars['String']>;
  udcConstruction?: Maybe<Scalars['String']>;
  udcLeakSensorManufacturer?: Maybe<Scalars['String']>;
  udcLeakSensorModel?: Maybe<Scalars['String']>;
  udcMonitoring?: Maybe<Scalars['String']>;
  udcMonitoringOther?: Maybe<Scalars['String']>;
  udcPanelManufacturer?: Maybe<Scalars['String']>;
  udcPanelModel?: Maybe<Scalars['String']>;
  udcSecondaryContactMonitoring?: Maybe<Scalars['String']>;
  ustPersonnelFamiliarTraining?: Maybe<Scalars['Boolean']>;
  vaporRecoveryPrimaryContainment?: Maybe<Scalars['String']>;
  vaporRecoveryPrimaryContainmentOther?: Maybe<Scalars['String']>;
  vaporRecoverySecondaryContainment?: Maybe<Scalars['String']>;
  vaporRecoverySecondaryContainmentOther?: Maybe<Scalars['String']>;
  ventPipingTransitionSumps?: Maybe<Scalars['String']>;
  ventPrimaryContainment?: Maybe<Scalars['String']>;
  ventPrimaryContainmentOther?: Maybe<Scalars['String']>;
  ventSecondaryContainment?: Maybe<Scalars['String']>;
  ventSecondaryContainmentOther?: Maybe<Scalars['String']>;
  visualPipelineMonitoringFrequency?: Maybe<Scalars['String']>;
  weeklyManualTankGaugeGaugingTestPeriod?: Maybe<Scalars['String']>;
};

export type UndergroundStorageTankInput = {
  additionalDescription?: InputMaybe<Scalars['String']>;
  additionalInformation?: InputMaybe<Scalars['String']>;
  automaticTankGaugingAtgModelNumber?: InputMaybe<Scalars['String']>;
  automaticTankGaugingAtgPanelManufacturer?: InputMaybe<Scalars['String']>;
  automaticTankGaugingLeakTestFrequency?: InputMaybe<Scalars['String']>;
  automaticTankGaugingLeakTestFrequencyOther?: InputMaybe<Scalars['String']>;
  automaticTankGaugingProbeManufacturer?: InputMaybe<Scalars['String']>;
  automaticTankGaugingProbeModelNumber?: InputMaybe<Scalars['String']>;
  automaticTankGaugingProgrammedTankTests?: InputMaybe<Scalars['String']>;
  automaticTankGaugingProgrammedTankTestsOther?: InputMaybe<Scalars['String']>;
  capacityGallons?: InputMaybe<Scalars['FlexibleFloat']>;
  configuration?: InputMaybe<Scalars['String']>;
  constructionMaterial?: InputMaybe<Scalars['String']>;
  constructionMaterialOther?: InputMaybe<Scalars['String']>;
  constructionPrimaryContainment?: InputMaybe<Scalars['String']>;
  constructionPrimaryContainmentOther?: InputMaybe<Scalars['String']>;
  constructionSecondaryContainment?: InputMaybe<Scalars['String']>;
  constructionSecondaryContainmentOther?: InputMaybe<Scalars['String']>;
  constructionType?: InputMaybe<Scalars['String']>;
  continuousElectronicTankMonitoringEmpManufacturer?: InputMaybe<Scalars['String']>;
  continuousElectronicTankMonitoringEmpModelNumber?: InputMaybe<Scalars['String']>;
  continuousElectronicTankMonitoringLeakSensorManufacturer?: InputMaybe<Scalars['String']>;
  continuousElectronicTankMonitoringLeakSensorModelNumber?: InputMaybe<Scalars['String']>;
  continuousElectronicTankMonitoringSecondaryContainmentSystem?: InputMaybe<Scalars['String']>;
  corrosionProtection?: InputMaybe<Array<Scalars['String']>>;
  designatedOperatorTraining?: InputMaybe<Scalars['Boolean']>;
  electronicLineLeakDetectorFailureTriggersPumpShutdown?: InputMaybe<Scalars['Boolean']>;
  electronicLineLeakDetectorManufacturer?: InputMaybe<Scalars['String']>;
  electronicLineLeakDetectorModelNumber?: InputMaybe<Scalars['String']>;
  electronicLineLeakDetectorProgrammedInlineTesting?: InputMaybe<Scalars['String']>;
  electronicLineLeakDetectorTriggersAutoPumpShutdown?: InputMaybe<Scalars['Boolean']>;
  existingDiscoveredDate?: InputMaybe<Scalars['Date']>;
  facilityId: Scalars['ID'];
  fillComponentsInstalled?: InputMaybe<Array<Scalars['String']>>;
  firstNameResponsibility?: InputMaybe<Scalars['String']>;
  firstNameTitle?: InputMaybe<Scalars['String']>;
  hasUdcFailureTriggerShutdown?: InputMaybe<Scalars['Boolean']>;
  hasUdcLeakAlarmTriggerShutdown?: InputMaybe<Scalars['Boolean']>;
  hasUdcLeakDetection?: InputMaybe<Scalars['Boolean']>;
  hasUdcMonitoringStopFlow?: InputMaybe<Scalars['Boolean']>;
  hasUdcSecondaryLeakDetection?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  installationDate?: InputMaybe<Scalars['Date']>;
  integrityTestingFrequency?: InputMaybe<Scalars['String']>;
  integrityTestingFrequencyOther?: InputMaybe<Scalars['String']>;
  manufacturer?: InputMaybe<Scalars['String']>;
  mechanicalLineLeakDetectorManufacturer?: InputMaybe<Scalars['String']>;
  mechanicalLineLeakDetectorModelNumber?: InputMaybe<Scalars['String']>;
  monitoringEquipmentServiced?: InputMaybe<Scalars['String']>;
  monitoringEquipmentServicedOther?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
  numberOfCompartments?: InputMaybe<Scalars['FlexibleInt']>;
  otherMonitoring?: InputMaybe<Scalars['String']>;
  otherPipelineMonitoring?: InputMaybe<Scalars['String']>;
  otherTrainingDocuments?: InputMaybe<Scalars['String']>;
  overfillProtection?: InputMaybe<Array<Scalars['String']>>;
  periodicSystemTesting?: InputMaybe<Array<Scalars['String']>>;
  permanentlyClosedDate?: InputMaybe<Scalars['Date']>;
  pipeMonitoringMethod?: InputMaybe<Array<Scalars['String']>>;
  pipeSecContainmentMonitoringFailureTriggersPumpShutdown?: InputMaybe<Scalars['Boolean']>;
  pipeSecContainmentMonitoringLeakAlarmTriggersAutoPumpShutdown?: InputMaybe<Scalars['Boolean']>;
  pipeSecContainmentMonitoringLeakSensorManufacturer?: InputMaybe<Scalars['String']>;
  pipeSecContainmentMonitoringLeakSensorModelNumber?: InputMaybe<Scalars['String']>;
  pipeSecContainmentMonitoringPanelManufacturer?: InputMaybe<Scalars['String']>;
  pipeSecContainmentMonitoringPanelModelNumber?: InputMaybe<Scalars['String']>;
  pipeSecContainmentMonitoringPipingSecondaryContainment?: InputMaybe<Scalars['String']>;
  pipelineIntegrityTestingFrequency?: InputMaybe<Scalars['String']>;
  pipelineIntegrityTestingFrequencyOther?: InputMaybe<Scalars['String']>;
  pipingConstruction?: InputMaybe<Scalars['String']>;
  pipingSystemType?: InputMaybe<Scalars['String']>;
  pipingTurbineContainmentSump?: InputMaybe<Scalars['String']>;
  previouslyReported?: InputMaybe<Scalars['Boolean']>;
  productWastePrimaryContainment?: InputMaybe<Scalars['String']>;
  productWastePrimaryContainmentOther?: InputMaybe<Scalars['String']>;
  productWasteSecondaryContainment?: InputMaybe<Scalars['String']>;
  productWasteSecondaryContainmentOther?: InputMaybe<Scalars['String']>;
  recordKeeping?: InputMaybe<Array<Scalars['String']>>;
  riserPipePrimaryContainment?: InputMaybe<Scalars['String']>;
  riserPipePrimaryContainmentOther?: InputMaybe<Scalars['String']>;
  riserPipeSecondaryContainment?: InputMaybe<Scalars['String']>;
  riserPipeSecondaryContainmentOther?: InputMaybe<Scalars['String']>;
  secondNameResponsibility?: InputMaybe<Scalars['String']>;
  secondNameTitle?: InputMaybe<Scalars['String']>;
  sitePlotPlanSubmitted?: InputMaybe<Scalars['String']>;
  tankContents?: InputMaybe<Scalars['String']>;
  tankContentsOther?: InputMaybe<Scalars['String']>;
  tankId?: InputMaybe<Scalars['String']>;
  tankMonitoringMethod?: InputMaybe<Array<Scalars['String']>>;
  tankUsage?: InputMaybe<Scalars['String']>;
  tankUsageOther?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  typeOfAction?: InputMaybe<Scalars['String']>;
  udcConstruction?: InputMaybe<Scalars['String']>;
  udcLeakSensorManufacturer?: InputMaybe<Scalars['String']>;
  udcLeakSensorModel?: InputMaybe<Scalars['String']>;
  udcMonitoring?: InputMaybe<Scalars['String']>;
  udcMonitoringOther?: InputMaybe<Scalars['String']>;
  udcPanelManufacturer?: InputMaybe<Scalars['String']>;
  udcPanelModel?: InputMaybe<Scalars['String']>;
  udcSecondaryContactMonitoring?: InputMaybe<Scalars['String']>;
  ustPersonnelFamiliarTraining?: InputMaybe<Scalars['Boolean']>;
  vaporRecoveryPrimaryContainment?: InputMaybe<Scalars['String']>;
  vaporRecoveryPrimaryContainmentOther?: InputMaybe<Scalars['String']>;
  vaporRecoverySecondaryContainment?: InputMaybe<Scalars['String']>;
  vaporRecoverySecondaryContainmentOther?: InputMaybe<Scalars['String']>;
  ventPipingTransitionSumps?: InputMaybe<Scalars['String']>;
  ventPrimaryContainment?: InputMaybe<Scalars['String']>;
  ventPrimaryContainmentOther?: InputMaybe<Scalars['String']>;
  ventSecondaryContainment?: InputMaybe<Scalars['String']>;
  ventSecondaryContainmentOther?: InputMaybe<Scalars['String']>;
  visualPipelineMonitoringFrequency?: InputMaybe<Scalars['String']>;
  weeklyManualTankGaugeGaugingTestPeriod?: InputMaybe<Scalars['String']>;
};

export enum UnitType {
  Barrels = 'BARRELS',
  CubicFeet = 'CUBIC_FEET',
  Gallons = 'GALLONS',
  Kilograms = 'KILOGRAMS',
  Liters = 'LITERS',
  MetricTons = 'METRIC_TONS',
  Pounds = 'POUNDS',
  Tons = 'TONS'
}

export type UnmergeWasteStreamsInput = {
  wasteStreamId: Scalars['ID'];
};

export type UnverifiedSummary = {
  __typename?: 'UnverifiedSummary';
  id: Scalars['ID'];
  name: Scalars['String'];
  reportCount: Scalars['Int'];
  unverifiedCount: Scalars['Int'];
};

export type UpdateActivitiesResult = {
  __typename?: 'UpdateActivitiesResult';
  errors?: Maybe<Array<Maybe<UpdatedActivitiesResultError>>>;
  updatedActivities?: Maybe<Array<Maybe<Activity>>>;
};

export type UpdateActivityAssigneesResult = {
  __typename?: 'UpdateActivityAssigneesResult';
  updatedActivities: Scalars['Int'];
};

export type UpdateCommunicationInput = {
  communicationDocuments: Array<DocumentWithSequenceInput>;
  facilities: Array<CommunicationFacilityInput>;
  recipient: RecipientInput;
  tenantId: Scalars['ID'];
  tierIIReportIds: Array<Scalars['ID']>;
};

export type UpdateReconciliationStatusInput = {
  newStatus: ReconciliationStatus;
  paymentId: Scalars['ID'];
};

export type UpdateSubmissionInput = {
  attachmentDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  recipient?: InputMaybe<Scalars['String']>;
  reportingPeriodEnd?: InputMaybe<Scalars['DateTime']>;
  reportingPeriodStart?: InputMaybe<Scalars['DateTime']>;
  reviewMode?: InputMaybe<ReviewMode>;
  reviewRequired?: InputMaybe<Scalars['Boolean']>;
  reviewers?: InputMaybe<Array<SubmissionReviewerInput>>;
  signatureType?: InputMaybe<SignatureType>;
  staffAssigneeId?: InputMaybe<Scalars['ID']>;
  submissionDocumentIds?: InputMaybe<Array<Scalars['ID']>>;
  submissionMethod?: InputMaybe<SubmissionMethod>;
  submissionType?: InputMaybe<SubmissionType>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSubmissionStatusInput = {
  submissionId: Scalars['ID'];
  submissionStatus: SubmissionStatus;
};

export type UpdateSubtaskInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTaskRecurringInput = {
  eventInput: UpdateVirtualEventInput;
  from?: InputMaybe<Scalars['Date']>;
  seriesId: Scalars['ID'];
  tenantId: Scalars['ID'];
};

export type UpdateTaskSingleInput = {
  eventInput: UpdateVirtualEventInput;
  tenantId: Scalars['ID'];
};

export type UpdateUserInput = {
  first?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<UserStatus>;
  tenantId: Scalars['ID'];
};

export type UpdateVirtualEventInput = {
  assigneeId?: InputMaybe<Scalars['String']>;
  completedAt?: InputMaybe<Scalars['DateTime']>;
  deadline?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentIds?: InputMaybe<Array<Scalars['String']>>;
  facilityIds?: InputMaybe<Array<Scalars['String']>>;
  frequency?: InputMaybe<Frequency>;
  id: Scalars['ID'];
  interval?: InputMaybe<Scalars['Int']>;
  links?: InputMaybe<Array<Scalars['String']>>;
  reminderDays?: InputMaybe<Array<Scalars['Int']>>;
  subtasks?: InputMaybe<Array<UpdateSubtaskInput>>;
  tags?: InputMaybe<Array<TagInput>>;
  title?: InputMaybe<Scalars['String']>;
  watcherIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateWasteLineUnifiedTagsInput = {
  ids: Array<Scalars['String']>;
  tagsToAdd: Array<Scalars['String']>;
  tagsToRemove: Array<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type UpdateWasteStreamInput = {
  classification?: InputMaybe<WasteClassification>;
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  internalNote?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateWebAutomationJobInput = {
  action?: InputMaybe<WebAutomationAction>;
  createdBy?: InputMaybe<Scalars['String']>;
  credentialId?: InputMaybe<Scalars['ID']>;
  credentialUsername?: InputMaybe<Scalars['String']>;
  encampRequestId?: InputMaybe<Scalars['ID']>;
  evidenceOfCompletionActions?: InputMaybe<Array<CollectEvidenceOfCompletionActions>>;
  facilityId?: InputMaybe<Scalars['ID']>;
  forceClassicSubmissionStrategy?: InputMaybe<Scalars['Boolean']>;
  reportId?: InputMaybe<Scalars['ID']>;
  reportingYear?: InputMaybe<Scalars['Int']>;
  requestId?: InputMaybe<Scalars['ID']>;
  stateOrTerritory?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<JobStatus>;
  stepError?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdatedActivitiesResultError = {
  __typename?: 'UpdatedActivitiesResultError';
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export enum UploadStatus {
  UploadComplete = 'UPLOAD_COMPLETE',
  UploadFailed = 'UPLOAD_FAILED',
  UploadStarted = 'UPLOAD_STARTED'
}

export type UpsertUserFacilitiesForTenantResult = {
  __typename?: 'UpsertUserFacilitiesForTenantResult';
  count: Scalars['Int'];
  userFacilities: Array<UserFacility>;
};

export type User = {
  __typename?: 'User';
  UserTenant: Array<UserTenant>;
  comments?: Maybe<Array<Comment>>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  facilities: Array<Facility>;
  id: Scalars['ID'];
  invitationExpiresAt?: Maybe<Scalars['DateTime']>;
  invitedAt?: Maybe<Scalars['DateTime']>;
  isEmulating?: Maybe<Scalars['Boolean']>;
  isPartner: Scalars['Boolean'];
  issues: Array<Issue>;
  originalUserType?: Maybe<UserType>;
  person?: Maybe<Person>;
  personId?: Maybe<Scalars['String']>;
  status: UserStatus;
  type: UserType;
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
};

export type UserFacility = {
  __typename?: 'UserFacility';
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID'];
  id: Scalars['ID'];
  user?: Maybe<User>;
  userId: Scalars['ID'];
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']>;
  facilities?: InputMaybe<Array<FacilityInput>>;
  first?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<UserStatus>;
  tenantId: Scalars['ID'];
};

export type UserLogin = {
  __typename?: 'UserLogin';
  id: Scalars['ID'];
  loginAt: Scalars['DateTime'];
  userId: Scalars['ID'];
};

export enum UserStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Inactive = 'INACTIVE',
  NotInvited = 'NOT_INVITED',
  Pending = 'PENDING'
}

export type UserTenant = {
  __typename?: 'UserTenant';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  role?: Maybe<Role>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  updatedBy?: Maybe<Scalars['String']>;
  userId: Scalars['ID'];
};

export enum UserType {
  Customer = 'CUSTOMER',
  StaffAdmin = 'STAFF_ADMIN',
  StaffEmployee = 'STAFF_EMPLOYEE',
  StaffTemp = 'STAFF_TEMP'
}

export type UsersResult = {
  __typename?: 'UsersResult';
  count: Scalars['Int'];
  items: Array<User>;
};

export type VendorManifest = {
  __typename?: 'VendorManifest';
  desFacilityName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  manifestTrackingNumber: Scalars['String'];
  manuallyEdited?: Maybe<Scalars['Boolean']>;
  originalDesFacilityName?: Maybe<Scalars['String']>;
  originalManifestTrackingNumber?: Maybe<Scalars['String']>;
  originalShippedDate?: Maybe<Scalars['DateTime']>;
  originalVendorSource?: Maybe<Scalars['String']>;
  shippedDate?: Maybe<Scalars['DateTime']>;
  vendorSource?: Maybe<Scalars['String']>;
};

export type VerifyCredentialInput = {
  credentialId?: InputMaybe<Scalars['ID']>;
  facilityId: Scalars['ID'];
};

export type VerifyCredentialResult = {
  __typename?: 'VerifyCredentialResult';
  facilityId: Scalars['ID'];
  queued: Scalars['Boolean'];
};

export type VerifyCredentialsResult = {
  __typename?: 'VerifyCredentialsResult';
  count: Scalars['Int'];
  results: Array<VerifyCredentialResult>;
};

export type VirtualEvent = {
  __typename?: 'VirtualEvent';
  assignee?: Maybe<User>;
  completedAt?: Maybe<Scalars['DateTime']>;
  deadline: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Document>>;
  facilities?: Maybe<Array<Facility>>;
  frequency: Frequency;
  id: Scalars['ID'];
  interval?: Maybe<Scalars['Int']>;
  links?: Maybe<Array<Scalars['String']>>;
  reminderDays: Array<Scalars['Int']>;
  seriesId: Scalars['ID'];
  status: VirtualEventStatus;
  submission?: Maybe<Submission>;
  subtasks?: Maybe<Array<VirtualEventSubtask>>;
  tags?: Maybe<Array<Tag>>;
  taskId: Scalars['ID'];
  title: Scalars['String'];
  watchers?: Maybe<Array<User>>;
};

export type VirtualEventResult = {
  __typename?: 'VirtualEventResult';
  count: Scalars['Int'];
  items: Array<VirtualEvent>;
};

export enum VirtualEventStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Overdue = 'OVERDUE'
}

export type VirtualEventSubtask = {
  __typename?: 'VirtualEventSubtask';
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export enum WasteClassification {
  Nonhazardous = 'NONHAZARDOUS',
  RcraAcutelyHazardous = 'RCRA_ACUTELY_HAZARDOUS',
  RcraHazardous = 'RCRA_HAZARDOUS',
  StateRegulated = 'STATE_REGULATED'
}

export enum WasteClassificationLegacy {
  Nonhazardous = 'NONHAZARDOUS',
  Pharmaceutical = 'PHARMACEUTICAL',
  RcraAcutelyHazardous = 'RCRA_ACUTELY_HAZARDOUS',
  RcraHazardous = 'RCRA_HAZARDOUS',
  StateRegulated = 'STATE_REGULATED',
  Universal = 'UNIVERSAL'
}

export type WasteCodesResult = {
  __typename?: 'WasteCodesResult';
  federalWasteCodes: Array<Scalars['String']>;
  stateWasteCodes: Array<Scalars['String']>;
};

export type WasteFacilitiesByGeneratorStatusAndState = {
  __typename?: 'WasteFacilitiesByGeneratorStatusAndState';
  count: Scalars['Int'];
  generatorStatus: RegulatoryStatusOption;
  state: Scalars['String'];
};

export type WasteFacilityEpaIdResult = {
  __typename?: 'WasteFacilityEpaIdResult';
  count: Scalars['Int'];
  items: Array<FacilityEpaId>;
};

export type WasteLine = {
  __typename?: 'WasteLine';
  brDensity?: Maybe<Scalars['String']>;
  brDensityUomCode?: Maybe<Scalars['String']>;
  brDensityUomDescription?: Maybe<Scalars['String']>;
  brFormCode?: Maybe<Scalars['String']>;
  brFormCodeDescription?: Maybe<Scalars['String']>;
  brSourceCode?: Maybe<Scalars['String']>;
  brSourceCodeDescription?: Maybe<Scalars['String']>;
  brWasteMinCode?: Maybe<Scalars['String']>;
  brWasteMinDescription?: Maybe<Scalars['String']>;
  consentNumber?: Maybe<Scalars['String']>;
  containerNumber?: Maybe<Scalars['Int']>;
  containerTypeCode?: Maybe<Scalars['String']>;
  containerTypeDescription?: Maybe<Scalars['String']>;
  disposalManagementCode?: Maybe<Scalars['String']>;
  dotHazardous?: Maybe<Scalars['Boolean']>;
  dotIdNumberDescription?: Maybe<Scalars['String']>;
  dotPrintedInformation?: Maybe<Scalars['String']>;
  epaWaste?: Maybe<Scalars['Boolean']>;
  federalWasteCodes?: Maybe<Array<Scalars['String']>>;
  managementMethodCode?: Maybe<Scalars['String']>;
  managementMethodDescription?: Maybe<Scalars['String']>;
  manifestId: Scalars['String'];
  manifestTrackingNumber: Scalars['String'];
  nonHazWasteDescription?: Maybe<Scalars['String']>;
  qtyUnitOfMeasureCode?: Maybe<Scalars['String']>;
  qtyUnitOfMeasureDesc?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  quantityAcuteKg?: Maybe<Scalars['Float']>;
  quantityAcuteTons?: Maybe<Scalars['Float']>;
  quantityDiscrepancy?: Maybe<Scalars['Boolean']>;
  quantityHazKg?: Maybe<Scalars['Float']>;
  quantityHazTons?: Maybe<Scalars['Float']>;
  quantityKg?: Maybe<Scalars['Float']>;
  quantityNonAcuteKg?: Maybe<Scalars['Float']>;
  quantityNonAcuteTons?: Maybe<Scalars['Float']>;
  quantityNonHazKg?: Maybe<Scalars['Float']>;
  quantityNonHazTons?: Maybe<Scalars['Float']>;
  quantityTons?: Maybe<Scalars['Float']>;
  stateWasteCodes?: Maybe<Array<Scalars['String']>>;
  tags?: Maybe<Array<Tag>>;
  vendorComments?: Maybe<Scalars['String']>;
  vendorDisposalMethod?: Maybe<Scalars['String']>;
  vendorProfileDescription?: Maybe<Scalars['String']>;
  vendorProfileNumber?: Maybe<Scalars['String']>;
  vendorTSDFApprovalCode?: Maybe<Scalars['String']>;
  vendorWasteTypeCategory?: Maybe<Scalars['String']>;
  vendorWasteTypeDescription?: Maybe<Scalars['String']>;
  wasteLineNumber: Scalars['String'];
  wasteManifest?: Maybe<WasteManifest>;
  wasteResidue?: Maybe<Scalars['Boolean']>;
  wasteTypeDiscrepancy?: Maybe<Scalars['Boolean']>;
};

export type WasteLineUnified = {
  __typename?: 'WasteLineUnified';
  destinationFacilityName?: Maybe<Scalars['String']>;
  dotDescription?: Maybe<Scalars['String']>;
  eManifestAmount?: Maybe<Scalars['Float']>;
  epaId?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['String']>;
  federalWasteCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['String'];
  isEManifest?: Maybe<Scalars['Boolean']>;
  lineItem?: Maybe<Scalars['String']>;
  managementMethodCode?: Maybe<Scalars['String']>;
  manifestTrackingNumber?: Maybe<Scalars['String']>;
  manuallyEdited?: Maybe<Scalars['Boolean']>;
  originalVendorAmount?: Maybe<Scalars['Float']>;
  originalVendorDotPrintedInformation?: Maybe<Scalars['String']>;
  originalVendorManagementMethodCode?: Maybe<Scalars['String']>;
  originalVendorNonHazWasteDescription?: Maybe<Scalars['String']>;
  originalVendorProfileDescription?: Maybe<Scalars['String']>;
  originalVendorProfileNumber?: Maybe<Scalars['String']>;
  originalVendorWasteLine?: Maybe<WasteLine>;
  processedManifestId: Scalars['String'];
  profileNumber?: Maybe<Scalars['String']>;
  shippedDate?: Maybe<Scalars['Date']>;
  stateWasteCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  tags: Array<Tag>;
  tenant: Tenant;
  tenantId: Scalars['String'];
  vendor?: Maybe<Scalars['String']>;
  vendorAmount?: Maybe<Scalars['Float']>;
  wasteLineNumber?: Maybe<Scalars['String']>;
  wasteStream?: Maybe<Scalars['String']>;
  willNotReport?: Maybe<Scalars['Boolean']>;
};

export type WasteLineUnifiedInput = {
  dotDescription?: InputMaybe<Scalars['String']>;
  lineItem?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<TagInput>>;
  vendorAmount?: InputMaybe<Scalars['Float']>;
  vendorManagementMethodCode?: InputMaybe<Scalars['String']>;
  vendorProfileNumber?: InputMaybe<Scalars['String']>;
  willNotReport?: InputMaybe<Scalars['Boolean']>;
};

export type WasteLinesUnifiedResult = {
  __typename?: 'WasteLinesUnifiedResult';
  count: Scalars['Int'];
  items: Array<WasteLineUnified>;
};

export type WasteManagementMethod = {
  __typename?: 'WasteManagementMethod';
  managementMethodCode: Scalars['String'];
  managementMethodDescription: Scalars['String'];
  totalQuantityPounds: Scalars['Float'];
};

export type WasteManifest = {
  __typename?: 'WasteManifest';
  brokerId?: Maybe<Scalars['String']>;
  desFacContactCompanyName?: Maybe<Scalars['String']>;
  desFacLocationCity?: Maybe<Scalars['String']>;
  desFacLocationState?: Maybe<Scalars['String']>;
  desFacLocationStreet1?: Maybe<Scalars['String']>;
  desFacLocationStreet2?: Maybe<Scalars['String']>;
  desFacLocationStreetNo?: Maybe<Scalars['String']>;
  desFacLocationZip?: Maybe<Scalars['String']>;
  desFacMailCity?: Maybe<Scalars['String']>;
  desFacMailState?: Maybe<Scalars['String']>;
  desFacMailStreet1?: Maybe<Scalars['String']>;
  desFacMailStreet2?: Maybe<Scalars['String']>;
  desFacMailStreetNo?: Maybe<Scalars['String']>;
  desFacMailZip?: Maybe<Scalars['String']>;
  desFacilityId?: Maybe<Scalars['String']>;
  desFacilityName?: Maybe<Scalars['String']>;
  eManifestCertifiedDate?: Maybe<Scalars['DateTime']>;
  eManifestCreatedDate?: Maybe<Scalars['DateTime']>;
  eManifestDuration?: Maybe<Scalars['Int']>;
  facility?: Maybe<Facility>;
  generatorContactCompanyName?: Maybe<Scalars['String']>;
  generatorId?: Maybe<Scalars['String']>;
  generatorLocationCity?: Maybe<Scalars['String']>;
  generatorLocationState?: Maybe<Scalars['String']>;
  generatorLocationStreet1?: Maybe<Scalars['String']>;
  generatorLocationStreet2?: Maybe<Scalars['String']>;
  generatorLocationStreetNo?: Maybe<Scalars['String']>;
  generatorLocationZip?: Maybe<Scalars['String']>;
  generatorMailCity?: Maybe<Scalars['String']>;
  generatorMailState?: Maybe<Scalars['String']>;
  generatorMailStreet1?: Maybe<Scalars['String']>;
  generatorMailStreet2?: Maybe<Scalars['String']>;
  generatorMailStreetNo?: Maybe<Scalars['String']>;
  generatorMailZip?: Maybe<Scalars['String']>;
  generatorName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  manifestResidue?: Maybe<Scalars['Boolean']>;
  manifestSource: WasteManifestSource;
  manifestTrackingNumber: Scalars['String'];
  originType?: Maybe<Scalars['String']>;
  receivedDate?: Maybe<Scalars['DateTime']>;
  rejection?: Maybe<Scalars['Boolean']>;
  shippedDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  submissionType: SubmissionType;
  totalQuantityAcuteKg?: Maybe<Scalars['Float']>;
  totalQuantityAcuteTons?: Maybe<Scalars['Float']>;
  totalQuantityHazKg?: Maybe<Scalars['Float']>;
  totalQuantityHazTons?: Maybe<Scalars['Float']>;
  totalQuantityKg?: Maybe<Scalars['Float']>;
  totalQuantityNonAcuteKg?: Maybe<Scalars['Float']>;
  totalQuantityNonAcuteTons?: Maybe<Scalars['Float']>;
  totalQuantityNonHazKg?: Maybe<Scalars['Float']>;
  totalQuantityNonHazTons?: Maybe<Scalars['Float']>;
  totalQuantityTons?: Maybe<Scalars['Float']>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  vendorBillQuantity?: Maybe<Scalars['Float']>;
  vendorBillTotal?: Maybe<Scalars['Float']>;
  vendorBillUnit?: Maybe<Scalars['String']>;
  vendorCompanyID?: Maybe<Scalars['String']>;
  vendorCustomerID?: Maybe<Scalars['String']>;
  vendorCustomerName?: Maybe<Scalars['String']>;
  vendorGeneratorID?: Maybe<Scalars['String']>;
  vendorGeneratorSiteCode?: Maybe<Scalars['String']>;
  vendorGeneratorSiteType?: Maybe<Scalars['String']>;
  vendorGeneratorSublocationCode?: Maybe<Scalars['String']>;
  vendorInvoiceCode?: Maybe<Scalars['String']>;
  vendorInvoiceDate?: Maybe<Scalars['DateTime']>;
  vendorProfitCtrID?: Maybe<Scalars['String']>;
  vendorPurchaseOrder?: Maybe<Scalars['String']>;
  vendorResourceType?: Maybe<Scalars['String']>;
  vendorSequenceID?: Maybe<Scalars['String']>;
  vendorSiteId?: Maybe<Scalars['String']>;
  vendorSource?: Maybe<Scalars['String']>;
  vendorTSDFCode?: Maybe<Scalars['String']>;
  vendorUnitPrice?: Maybe<Scalars['Float']>;
  vendorWorkOrderId?: Maybe<Scalars['String']>;
  wasteLines?: Maybe<Array<WasteLine>>;
  wasteTransporters?: Maybe<Array<WasteTransporter>>;
};

export type WasteManifestLineItemsResult = {
  __typename?: 'WasteManifestLineItemsResult';
  count: Scalars['Int'];
  items: Array<WasteLine>;
};

export enum WasteManifestSource {
  Vendor = 'Vendor',
  EManifest = 'eManifest'
}

export type WasteManifestsByTrackingNumber = {
  __typename?: 'WasteManifestsByTrackingNumber';
  manifestTrackingNumber: Scalars['String'];
  wasteManifests: Array<WasteManifest>;
};

export type WasteManifestsResult = {
  __typename?: 'WasteManifestsResult';
  count: Scalars['Int'];
  items: Array<ProcessedManifestSummary>;
};

export type WasteOverviewFilter = {
  currentGeneratorStatuses?: InputMaybe<Array<RegulatoryStatusOption>>;
  facilityTagIds?: InputMaybe<Array<Scalars['String']>>;
  shipDateEnd?: InputMaybe<Scalars['DateTime']>;
  shipDateStart?: InputMaybe<Scalars['DateTime']>;
  states?: InputMaybe<Array<Scalars['String']>>;
  wasteLineTagIds?: InputMaybe<Array<Scalars['String']>>;
};

export type WasteShipmentsByFacility = {
  __typename?: 'WasteShipmentsByFacility';
  hazardousWasteShipments?: Maybe<HazardousWasteShipmentsByFacility>;
  highestWasteStreamShipments?: Maybe<Array<WasteStreamShipment>>;
  wasteShipmentsByMonth?: Maybe<AllWasteShipmentsByFacility>;
};

export type WasteStream = {
  __typename?: 'WasteStream';
  classification?: Maybe<WasteClassification>;
  comment?: Maybe<Scalars['String']>;
  eManifestAmount?: Maybe<Scalars['Float']>;
  eManifestAmountAllTime?: Maybe<Scalars['Float']>;
  eManifestCount?: Maybe<Scalars['Int']>;
  eManifestDotDescription?: Maybe<Scalars['String']>;
  eManifestFormCode?: Maybe<Scalars['String']>;
  eManifestLineItemCount?: Maybe<Scalars['Int']>;
  eManifestProfileNumber?: Maybe<Scalars['String']>;
  eManifestSourceCode?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['ID']>;
  federalWasteCodes?: Maybe<Array<Scalars['String']>>;
  formCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalNote?: Maybe<Scalars['String']>;
  lastShipmentDate?: Maybe<Scalars['DateTime']>;
  lastShipmentDateAllTime?: Maybe<Scalars['DateTime']>;
  managementMethodCode?: Maybe<Scalars['String']>;
  mergeCount: Scalars['Int'];
  name: Scalars['String'];
  sourceCode?: Maybe<Scalars['String']>;
  stateWasteCodes?: Maybe<Array<Scalars['String']>>;
  vendorAmount?: Maybe<Scalars['Float']>;
  vendorAmountAllTime?: Maybe<Scalars['Float']>;
  vendorDotDescription?: Maybe<Scalars['String']>;
  vendorFormCode?: Maybe<Scalars['String']>;
  vendorManifestCount?: Maybe<Scalars['Int']>;
  vendorManifestLineItemCount?: Maybe<Scalars['Int']>;
  vendorProfileNumber?: Maybe<Scalars['String']>;
  vendorSourceCode?: Maybe<Scalars['String']>;
  wasteMinimizationCode?: Maybe<Scalars['String']>;
};

export type WasteStreamDestination = {
  __typename?: 'WasteStreamDestination';
  destinationFacilityId?: Maybe<Scalars['String']>;
  destinationFacilityName?: Maybe<Scalars['String']>;
  eManifestAmount?: Maybe<Scalars['Float']>;
  managementMethodCode?: Maybe<Scalars['String']>;
  vendorAmount?: Maybe<Scalars['Float']>;
};

export type WasteStreamDestinationsResult = {
  __typename?: 'WasteStreamDestinationsResult';
  count: Scalars['Int'];
  items: Array<WasteStreamDestination>;
};

export type WasteStreamRaw = {
  __typename?: 'WasteStreamRaw';
  classification?: Maybe<WasteClassification>;
  eManifestAmount?: Maybe<Scalars['Float']>;
  eManifestAmountAllTime?: Maybe<Scalars['Float']>;
  eManifestCount?: Maybe<Scalars['Int']>;
  eManifestDotDescription?: Maybe<Scalars['String']>;
  eManifestFormCode?: Maybe<Scalars['String']>;
  eManifestLineItemCount?: Maybe<Scalars['Int']>;
  eManifestProfileNumber?: Maybe<Scalars['String']>;
  eManifestSourceCode?: Maybe<Scalars['String']>;
  facilityId?: Maybe<Scalars['ID']>;
  federalWasteCodes?: Maybe<Array<Scalars['String']>>;
  formCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastShipmentDate?: Maybe<Scalars['DateTime']>;
  lastShipmentDateAllTime?: Maybe<Scalars['DateTime']>;
  managementMethodCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  sourceCode?: Maybe<Scalars['String']>;
  stateWasteCodes?: Maybe<Array<Scalars['String']>>;
  vendorAmount?: Maybe<Scalars['Float']>;
  vendorAmountAllTime?: Maybe<Scalars['Float']>;
  vendorDotDescription?: Maybe<Scalars['String']>;
  vendorFormCode?: Maybe<Scalars['String']>;
  vendorManifestCount?: Maybe<Scalars['Int']>;
  vendorManifestLineItemCount?: Maybe<Scalars['Int']>;
  vendorProfileNumber?: Maybe<Scalars['String']>;
  vendorSourceCode?: Maybe<Scalars['String']>;
  wasteMinimizationCode?: Maybe<Scalars['String']>;
  wasteStreamId: Scalars['ID'];
};

export type WasteStreamRawsResult = {
  __typename?: 'WasteStreamRawsResult';
  count: Scalars['Int'];
  items: Array<WasteStreamRaw>;
};

export type WasteStreamShipment = {
  __typename?: 'WasteStreamShipment';
  amount: Scalars['Float'];
  wasteStream: FacilityWasteStream;
};

export type WasteStreamShipmentChartsOutput = {
  __typename?: 'WasteStreamShipmentChartsOutput';
  wasteShipmentsByMonth: Array<WasteStreamWasteByMonth>;
};

export type WasteStreamWasteByMonth = {
  __typename?: 'WasteStreamWasteByMonth';
  eManifestAmount: Scalars['Float'];
  month: Scalars['Date'];
  vendorAmount: Scalars['Float'];
};

export type WasteStreamsResult = {
  __typename?: 'WasteStreamsResult';
  count: Scalars['Int'];
  items: Array<WasteStream>;
};

export type WasteTotalWasteResponse = {
  __typename?: 'WasteTotalWasteResponse';
  periodPercentChange?: Maybe<Scalars['Float']>;
  previousPeriodTotal?: Maybe<Scalars['Float']>;
  wasteByClassification: Array<WasteTotalWasteResult>;
};

export type WasteTotalWasteResult = {
  __typename?: 'WasteTotalWasteResult';
  classification: Scalars['String'];
  percentage: Scalars['Float'];
  totalAmountInPounds: Scalars['Float'];
};

export type WasteTransporter = {
  __typename?: 'WasteTransporter';
  manifestTrackingNumber: Scalars['String'];
  transporterId?: Maybe<Scalars['String']>;
  transporterLineNumber: Scalars['String'];
  transporterName?: Maybe<Scalars['String']>;
  vendorAddressLine1?: Maybe<Scalars['String']>;
  vendorAddressLine2?: Maybe<Scalars['String']>;
  vendorCity?: Maybe<Scalars['String']>;
  vendorState?: Maybe<Scalars['String']>;
  vendorZip?: Maybe<Scalars['String']>;
  wasteManifest?: Maybe<WasteManifest>;
};

export type WasteVendorResult = {
  __typename?: 'WasteVendorResult';
  manifestSource: Scalars['String'];
  totalQuantityPounds: Scalars['Float'];
};

export enum WebAutomationAction {
  AcquireLock = 'acquireLock',
  CloseDraftReport = 'closeDraftReport',
  CollectEvidenceOfCompletion = 'collectEvidenceOfCompletion',
  DeleteLock = 'deleteLock',
  DownloadReport = 'downloadReport',
  ExtractChemicalDatabase = 'extractChemicalDatabase',
  ExtractData = 'extractData',
  ExtractHazardousMaterialsPermit = 'extractHazardousMaterialsPermit',
  ExtractStateIDs = 'extractStateIDs',
  FinalizeSubmission = 'finalizeSubmission',
  GetFacilitiesList = 'getFacilitiesList',
  InputData = 'inputData',
  InputDataLepc = 'inputDataLepc',
  InputDataRevision = 'inputDataRevision',
  PortalSubmissionStatus = 'portalSubmissionStatus',
  Rcra870012 = 'rcra870012',
  Rcra870013 = 'rcra870013',
  RcraEvq = 'rcraEvq',
  RcraVerifyCredentials = 'rcraVerifyCredentials',
  ScrapeDistrictInfo = 'scrapeDistrictInfo',
  Verify870012Submission = 'verify870012Submission',
  VerifyCredentials = 'verifyCredentials'
}

export type WebAutomationJobResult = {
  __typename?: 'WebAutomationJobResult';
  count: Scalars['Int'];
};

export type WebAutomationJobWithPromotionJob = {
  __typename?: 'WebAutomationJobWithPromotionJob';
  action?: Maybe<WebAutomationAction>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  extraction?: Maybe<Scalars['JSON']>;
  extractionKey?: Maybe<Scalars['String']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  insightsCandidates: Array<InsightsCandidate>;
  logs: Array<JobLog>;
  parameters?: Maybe<Scalars['JSON']>;
  payments: Array<Payment>;
  /** @deprecated use `promotionJobUpdatedAt` instead */
  promotedAt?: Maybe<Scalars['DateTime']>;
  promotionJobId?: Maybe<Scalars['ID']>;
  promotionJobStatus?: Maybe<JobStatus>;
  promotionJobUpdatedAt?: Maybe<Scalars['DateTime']>;
  reportId?: Maybe<Scalars['ID']>;
  reportingYear?: Maybe<Scalars['Int']>;
  requestId?: Maybe<Scalars['ID']>;
  staffReportDownloadLink?: Maybe<Scalars['String']>;
  staffReportKey?: Maybe<Scalars['String']>;
  stateOrTerritory?: Maybe<Scalars['String']>;
  status?: Maybe<JobStatus>;
  stepsDone: Array<JobStepsDone>;
  task?: Maybe<JobTask>;
  taskArn?: Maybe<Scalars['String']>;
  taskUrl?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  totalIssues?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
};

export type WebAutomationJobsResult = {
  __typename?: 'WebAutomationJobsResult';
  count: Scalars['Int'];
  items: Array<WebAutomationJobWithPromotionJob>;
};

export enum WeightOrVolume {
  Volume = 'VOLUME',
  Weight = 'WEIGHT'
}

export type Workflow = {
  __typename?: 'Workflow';
  activities: Array<Activity>;
  cohort?: Maybe<Cohort>;
  cohortId?: Maybe<Scalars['ID']>;
  comments?: Maybe<Array<Comment>>;
  currentActivity?: Maybe<Activity>;
  currentActivityId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  status: WorkflowStatus;
  tags: Array<Tag>;
  tierIIReportId?: Maybe<Scalars['ID']>;
  type: WorkflowType;
};

export type WorkflowActivitiesResult = {
  __typename?: 'WorkflowActivitiesResult';
  count: Scalars['Int'];
  items: Array<WorkflowActivity>;
};

export type WorkflowActivity = {
  __typename?: 'WorkflowActivity';
  activityCreatedAt?: Maybe<Scalars['DateTime']>;
  activityId?: Maybe<Scalars['ID']>;
  activityStatus?: Maybe<ActivityStatus>;
  activityType?: Maybe<Scalars['String']>;
  activityUpdatedAt?: Maybe<Scalars['DateTime']>;
  assigneeEmail?: Maybe<Scalars['String']>;
  cohortId?: Maybe<Scalars['ID']>;
  cohortReadyMemberCount?: Maybe<Scalars['Int']>;
  cohortStatus?: Maybe<CohortStatus>;
  cohortTotalMemberCount?: Maybe<Scalars['Int']>;
  cohortType?: Maybe<CohortType>;
  credentials?: Maybe<Array<CredentialInfo>>;
  description?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  facilityAddress?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobStatus?: Maybe<JobStatus>;
  name?: Maybe<Scalars['String']>;
  organizationName: Scalars['String'];
  partnerTenantName?: Maybe<Scalars['String']>;
  plan?: Maybe<ExecutionPlanType>;
  reportKind?: Maybe<TierIiReportKind>;
  reportingYear: Scalars['Int'];
  state?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
  tenantId: Scalars['ID'];
  tierIIReportId?: Maybe<Scalars['ID']>;
  workflowId: Scalars['ID'];
  workflowStatus?: Maybe<WorkflowStatus>;
  workflowType?: Maybe<WorkflowType>;
};

export type WorkflowConfigEntity = {
  __typename?: 'WorkflowConfigEntity';
  name: Scalars['String'];
  type: WorkflowConfigEntityType;
};

export enum WorkflowConfigEntityType {
  Facility = 'FACILITY',
  State = 'STATE',
  Tenant = 'TENANT'
}

export type WorkflowManagerConfig = {
  __typename?: 'WorkflowManagerConfig';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  type: WorkflowManagerConfigType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  value: Scalars['String'];
};

export type WorkflowManagerConfigEnhanced = {
  __typename?: 'WorkflowManagerConfigEnhanced';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  notes?: Maybe<Scalars['String']>;
  relatedEntity?: Maybe<WorkflowConfigEntity>;
  type?: Maybe<WorkflowManagerConfigType>;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  value: Scalars['String'];
};

export type WorkflowManagerConfigResult = {
  __typename?: 'WorkflowManagerConfigResult';
  count: Scalars['Int'];
  items: Array<WorkflowManagerConfig>;
};

export type WorkflowManagerConfigRule = {
  __typename?: 'WorkflowManagerConfigRule';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  facility?: Maybe<Facility>;
  humanReadableValue: Scalars['String'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  tenant?: Maybe<Tenant>;
  type: WorkflowManagerConfigType;
  updatedAt: Scalars['DateTime'];
  updatedBy: Scalars['String'];
  value: Scalars['String'];
};

export type WorkflowManagerConfigRulesResult = {
  __typename?: 'WorkflowManagerConfigRulesResult';
  count: Scalars['Int'];
  items: Array<WorkflowManagerConfigRule>;
};

export enum WorkflowManagerConfigType {
  AllowEnvironment = 'ALLOW_ENVIRONMENT',
  AllowFacility = 'ALLOW_FACILITY',
  AllowFacilityRevision = 'ALLOW_FACILITY_REVISION',
  AllowState = 'ALLOW_STATE',
  AllowStateRevision = 'ALLOW_STATE_REVISION',
  DenyFacility = 'DENY_FACILITY',
  DenyFacilityRevision = 'DENY_FACILITY_REVISION',
  DenyLobMailToSerc = 'DENY_LOB_MAIL_TO_SERC',
  DenyTenant = 'DENY_TENANT',
  DenyTenantRevision = 'DENY_TENANT_REVISION',
  FacilityBypassValidation = 'FACILITY_BYPASS_VALIDATION',
  ForceReportTypeForSubmission = 'FORCE_REPORT_TYPE_FOR_SUBMISSION',
  MaxConcurrency = 'MAX_CONCURRENCY',
  MinConductExecutionTime = 'MIN_CONDUCT_EXECUTION_TIME',
  SchedulerWorkIntervalSleepTimeMs = 'SCHEDULER_WORK_INTERVAL_SLEEP_TIME_MS',
  StateBypassValidation = 'STATE_BYPASS_VALIDATION',
  TestingFailureRate = 'TESTING_FAILURE_RATE',
  Version = 'VERSION',
  WebAutomationStateOverrideUseAa = 'WEB_AUTOMATION_STATE_OVERRIDE_USE_AA'
}

export type WorkflowOverviewSeasonSummary = {
  __typename?: 'WorkflowOverviewSeasonSummary';
  staffSummaries: Array<StaffSummary>;
  workflowsCountError: Scalars['Int'];
  workflowsCountHuman: Scalars['Int'];
  workflowsCountWaitForAll: Scalars['Int'];
  year: Scalars['Int'];
};

export enum WorkflowStatus {
  Canceled = 'Canceled',
  Completed = 'Completed',
  Error = 'Error',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
  Paused = 'Paused'
}

export type WorkflowTagUpdateInput = {
  tagNames: Array<Scalars['String']>;
  workflowId: Scalars['ID'];
};

export enum WorkflowType {
  Cohort = 'Cohort',
  TierIiReportSubmission = 'TierIIReportSubmission'
}

export type DeleteFacilityChemicalMeasurementsByChemicalAndYearResult = {
  __typename?: 'deleteFacilityChemicalMeasurementsByChemicalAndYearResult';
  chemicalId: Scalars['ID'];
  facilityId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};

export type DeleteFacilityProductMeasurementsByProductAndYearResult = {
  __typename?: 'deleteFacilityProductMeasurementsByProductAndYearResult';
  facilityId: Scalars['ID'];
  productId: Scalars['ID'];
  reportingYear: Scalars['Int'];
};

export type FacilityChemicalMeasurementsForReportResult = {
  __typename?: 'facilityChemicalMeasurementsForReportResult';
  count: Scalars['Int'];
  items: Array<ChemicalMeasurementSummary>;
};

export type LeadAgencyResult = {
  __typename?: 'leadAgencyResult';
  count: Scalars['Int'];
  items: Array<LeadAgency>;
};

export type WasteLinesUnifiedBulkUpdateWillNotReportInput = {
  ids: Array<Scalars['String']>;
  willNotReport: Scalars['Boolean'];
};
